/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  resizeSelects: function($selects) {
    $selects.each(function() {
      var $this = $(this);
      var arrowWidth = 10;
      // create test element
      var text = $this.find('option:selected').text();
      var $test = $('<span>').html(text);
      
      // add to body, get width, and get out
      $test.appendTo('body');
      var width = $test.width();
      $test.remove();

      // set select width
      $this.width(width + arrowWidth);
    });
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a[href]:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function(i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/* ================ Product dynamic quantity pricing ================ */
(function() {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getProductSection(element) {
    return element && element.closest ? element.closest('[data-section-type="product"]') : null;
  }

  function getProductForm(section) {
    if (!section) return null;
    return section.querySelector('form[data-product-form]') || section.querySelector('form[action*="/cart/add"]');
  }

  function getProductQuantity(section) {
    if (section) {
      var selectedBreakInput = section.querySelector('[data-quantity-break-input]:checked');
      if (selectedBreakInput) {
        var breakQuantity = parseInt(selectedBreakInput.getAttribute('data-quantity'), 10);
        if (breakQuantity && breakQuantity > 0) {
          return breakQuantity;
        }
      }
    }

    var form = getProductForm(section);
    var input = form ? form.querySelector('input[name="quantity"]') : null;
    var quantity = input ? parseInt(input.value, 10) : 1;
    return quantity && quantity > 0 ? quantity : 1;
  }

  function getCurrentVariant(section) {
    return section && section._skyrocketDynamicPriceVariant ? section._skyrocketDynamicPriceVariant : null;
  }

  function getBasePrice(element, key) {
    var value = parseInt(element.getAttribute(key), 10);
    return isNaN(value) ? 0 : value;
  }

  function getVariantPriceData(section, element) {
    var variant = getCurrentVariant(section);
    if (variant && typeof variant.price !== 'undefined') {
      return {
        price: parseInt(variant.price, 10) || 0,
        compareAtPrice: parseInt(variant.compare_at_price, 10) || 0,
        available: variant.available !== false
      };
    }

    return {
      price: getBasePrice(element, 'data-base-price'),
      compareAtPrice: getBasePrice(element, 'data-base-compare-at-price'),
      available: true
    };
  }

  function updatePriceMarkup(container, price, compareAtPrice, available) {
    if (!container) return;

    var priceContainer = container.matches && container.matches('[data-price]')
      ? container
      : container.querySelector('[data-price]');
    if (!priceContainer) return;

    var isOnSale = compareAtPrice > price;
    priceContainer.classList.toggle('price--on-sale', isOnSale);
    priceContainer.classList.toggle('price--sold-out', available === false);

    priceContainer.querySelectorAll('[data-regular-price]').forEach(function(element) {
      element.textContent = formatMoney(isOnSale ? compareAtPrice : price);
    });

    priceContainer.querySelectorAll('[data-sale-price]').forEach(function(element) {
      element.textContent = formatMoney(price);
    });
  }

  function getSelectedUpsellTotal(section) {
    var total = 0;
    if (!section) return total;

    section.querySelectorAll('.js-cross-sell-bundle:not(.cross-sell-bundle--hidden) .cross-sell-bundle__checkbox:checked').forEach(function(checkbox) {
      var price = parseInt(checkbox.getAttribute('data-variant-price'), 10);
      if (isNaN(price)) price = 0;
      total += price;
    });

    section.querySelectorAll('[data-product-oneclick-upsell]').forEach(function(card) {
      if (card.getAttribute('data-available') !== 'true') return;

      var quantity = 0;
      var controlType = card.getAttribute('data-control-type') || 'switch';

      if (controlType === 'quantity') {
        var qtyInput = card.querySelector('[data-product-oneclick-qty]');
        quantity = qtyInput ? parseInt(qtyInput.value, 10) : 0;
      } else {
        var toggle = card.querySelector('[data-product-oneclick-toggle]');
        quantity = toggle && toggle.checked ? 1 : 0;
      }

      if (!quantity || quantity < 1) return;

      var price = parseInt(card.getAttribute('data-variant-price'), 10);
      if (isNaN(price)) price = 0;

      total += price * quantity;
    });

    section.querySelectorAll('[data-product-recommendation-item][data-mode="staged"].is-selected').forEach(function(card) {
      if (card.getAttribute('data-available') !== 'true') return;

      var quantityInput = card.querySelector('[data-product-recommendation-qty]');
      var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      if (!quantity || quantity < 1) quantity = 1;

      var price = parseInt(card.getAttribute('data-variant-price'), 10);
      if (isNaN(price)) price = 0;

      total += price * quantity;
    });

    return total;
  }

  function updateProductPriceBlocks(section) {
    if (!section) return;

    var quantity = getProductQuantity(section);
    section.querySelectorAll('[data-product-price-quantity-scaled]').forEach(function(block) {
      var priceData = getVariantPriceData(section, block);
      block.setAttribute('data-base-price', priceData.price);
      block.setAttribute('data-base-compare-at-price', priceData.compareAtPrice);
      updatePriceMarkup(
        block,
        priceData.price * quantity,
        priceData.compareAtPrice > priceData.price ? priceData.compareAtPrice * quantity : 0,
        priceData.available
      );
    });
  }

  function updateAddToCartPrices(section) {
    if (!section) return;

    var quantity = getProductQuantity(section);
    var upsellTotal = getSelectedUpsellTotal(section);

    section.querySelectorAll('[data-add-to-cart-price-scale-quantity="true"]').forEach(function(priceEl) {
      var priceData = getVariantPriceData(section, priceEl);
      priceEl.setAttribute('data-base-price', priceData.price);
      priceEl.setAttribute('data-base-compare-at-price', priceData.compareAtPrice);

      var buttonPrice = (priceData.price * quantity) + upsellTotal;
      var buttonCompare = priceData.compareAtPrice > priceData.price
        ? (priceData.compareAtPrice * quantity) + upsellTotal
        : 0;

      updatePriceMarkup(priceEl, buttonPrice, buttonCompare, priceData.available);
    });
  }

  function updateDynamicPrices(section) {
    if (!section) return;
    updateProductPriceBlocks(section);
    updateAddToCartPrices(section);
    updateSavedBadges(section, getCurrentVariant(section));
  }

  function scheduleUpdateFromElement(element) {
    var section = getProductSection(element);
    if (!section) return;

    window.setTimeout(function() {
      updateDynamicPrices(section);
    }, 0);
  }

  document.addEventListener('change', function(event) {
    if (
      event.target.closest('input[name="quantity"]') ||
      event.target.closest('[name="id"]') ||
      event.target.closest('[data-product-oneclick-toggle]') ||
      event.target.closest('[data-product-oneclick-qty]') ||
      event.target.closest('[data-product-recommendation-button]') ||
      event.target.closest('[data-product-recommendation-qty]') ||
      event.target.closest('[data-product-recommendation-variant]') ||
      event.target.closest('.cross-sell-bundle__checkbox') ||
      event.target.closest('.cross-sell-bundle__select-all-checkbox')
    ) {
      scheduleUpdateFromElement(event.target);
    }
  });

  document.addEventListener('input', function(event) {
    if (
      event.target.closest('input[name="quantity"]') ||
      event.target.closest('[data-product-oneclick-qty]') ||
      event.target.closest('[data-product-recommendation-qty]')
    ) {
      scheduleUpdateFromElement(event.target);
    }
  });

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('.qtybox .btnqty, [data-product-oneclick-qty-plus], [data-product-oneclick-qty-minus], [data-product-oneclick-card-toggle], [data-product-recommendation-button], [data-product-recommendation-qty-plus], [data-product-recommendation-qty-minus], [data-quantity-break-input], .cross-sell-bundle__select-all');
    if (trigger) scheduleUpdateFromElement(trigger);
  });

  if (window.jQuery) {
    jQuery(document).on('variantChange.skyrocketDynamicQuantityPricing', '[data-section-type="product"]', function(event) {
      this._skyrocketDynamicPriceVariant = event.variant || null;
      updateDynamicPrices(this);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-section-type="product"]').forEach(updateDynamicPrices);
  });

  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-section-type="product"]').forEach(updateDynamicPrices);
    if (event.target.matches && event.target.matches('[data-section-type="product"]')) {
      updateDynamicPrices(event.target);
    }
  });
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();



document.addEventListener('DOMContentLoaded', function() {
  // Define the function globally
  window.updateInventoryElement = function(variant) {
    // Get elements to update
    var inventoryCountElement = document.getElementById('inventoryCount');
    var inventoryOutElement = document.getElementById('inventoryOut');
    var inventoryRunningLowElement = document.getElementById('inventoryRunningLow');

    // Hide all elements initially
    if (inventoryCountElement) inventoryCountElement.parentElement.style.display = 'none';
    if (inventoryOutElement) inventoryOutElement.style.display = 'none';
    if (inventoryRunningLowElement) inventoryRunningLowElement.style.display = 'none';

    // Update based on variant information
    if (variant) {
      if (variant.inventory_quantity > 0) {
        // If there is stock available, update inventory count
        if (inventoryCountElement) {
          inventoryCountElement.textContent = variant.inventory_quantity;
          inventoryCountElement.parentElement.style.display = 'block';
        }
      } else if (!variant.available) {
        // If out of stock, show "Out of stock" message
        if (inventoryOutElement) {
          inventoryOutElement.style.display = 'inline';
        }
      } else {
        // If inventory is not tracked or running low
        if (inventoryRunningLowElement) {
          inventoryRunningLowElement.style.display = 'inline';
        }
      }
    }
  };
});





function updateSKUElement(variant, scope) {
  var context = scope && scope.querySelectorAll ? scope : document;
  var skuValueElement = context.querySelector('#sku-value') || document.getElementById('sku-value');
  var variantSkuContainer = context.querySelector('#variant-sku') || document.getElementById('variant-sku');
  var showLabel = variantSkuContainer ? variantSkuContainer.getAttribute('data-show-sku-label') === 'true' : false;

  if (skuValueElement) {
    if (variant && variant.sku) {
      skuValueElement.textContent = showLabel ? "SKU: " + variant.sku : variant.sku;
    } else {
      skuValueElement.textContent = showLabel ? "" : "";
    }
  }
}

function updateAvailabilityElement(variant, scope) {
  var context = scope && scope.querySelectorAll ? scope : document;
  var availabilityWrappers = context.querySelectorAll('[data-availability-stock]');

  if (availabilityWrappers.length) {
    availabilityWrappers.forEach(function(wrapper) {
      var availabilityAvailableElement = wrapper.querySelector('[data-availability-state="available"]');
      var availabilityUnavailableElement = wrapper.querySelector('[data-availability-state="unavailable"]');

      if (variant && variant.available) {
        if (availabilityAvailableElement) {
          availabilityAvailableElement.style.display = 'flex';
        }
        if (availabilityUnavailableElement) {
          availabilityUnavailableElement.style.display = 'none';
        }
      } else {
        if (availabilityAvailableElement) {
          availabilityAvailableElement.style.display = 'none';
        }
        if (availabilityUnavailableElement) {
          availabilityUnavailableElement.style.display = 'flex';
        }
      }
    });
    return;
  }

  var availabilityAvailableElement = context.querySelector('#availabilityAvailable') || document.getElementById('availabilityAvailable');
  var availabilityUnavailableElement = context.querySelector('#availabilityUnavailable') || document.getElementById('availabilityUnavailable');

  if (!variant) {
    return;
  }

  if (variant.available) {
    if (availabilityAvailableElement) {
      availabilityAvailableElement.style.display = 'flex';
    }
    if (availabilityUnavailableElement) {
      availabilityUnavailableElement.style.display = 'none';
    }
  } else {
    if (availabilityAvailableElement) {
      availabilityAvailableElement.style.display = 'none';
    }
    if (availabilityUnavailableElement) {
      availabilityUnavailableElement.style.display = 'flex';
    }
  }
}

function formatSaveBadgeMoney(cents) {
  if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
    return theme.Currency.formatMoney(cents, theme.moneyFormat);
  }
  if (window.Shopify && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents);
  }
  return '$' + (cents / 100).toFixed(2);
}

function getSaveBadgeQuantity(badgesContainer) {
  var section = badgesContainer && badgesContainer.closest
    ? badgesContainer.closest('[data-section-type="product"]')
    : null;

  if (section) {
    var selectedBreakInput = section.querySelector('[data-quantity-break-input]:checked');
    if (selectedBreakInput) {
      var breakQuantity = parseInt(selectedBreakInput.getAttribute('data-quantity'), 10);
      if (breakQuantity && breakQuantity > 0) {
        return breakQuantity;
      }
    }

    var form = section.querySelector('form[data-product-form]') || section.querySelector('form[action*="/cart/add"]');
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    if (quantity && quantity > 0) {
      return quantity;
    }
  }

  return 1;
}

function updateSavedBadges(scope, variant) {
  var context = scope && scope.querySelectorAll ? scope : document;
  var badgesContainers = context.querySelectorAll('.price__badges');

  badgesContainers.forEach(function(badgesContainer) {
    var saleBadge = badgesContainer.querySelector('.price__badge--sale');
    var soldOutBadge = badgesContainer.querySelector('.price__badge--sold-out');
    var showAmount = badgesContainer.getAttribute('data-amount-show') === 'true';
    var showPercent = badgesContainer.getAttribute('data-percent-show') === 'true';
    var saveBadgeEnabled = badgesContainer.getAttribute('data-save-badge-enabled') === 'true';
    var scalePriceByQuantity = badgesContainer.getAttribute('data-scale-price-by-quantity') === 'true';

    var basePrice = variant && typeof variant.price !== 'undefined'
      ? parseInt(variant.price, 10) || 0
      : parseInt(badgesContainer.getAttribute('data-base-price'), 10) || 0;
    var baseCompareAtPrice = variant && typeof variant.compare_at_price !== 'undefined'
      ? parseInt(variant.compare_at_price, 10) || 0
      : parseInt(badgesContainer.getAttribute('data-base-compare-at-price'), 10) || 0;
    var available = variant && typeof variant.available !== 'undefined'
      ? variant.available !== false
      : badgesContainer.getAttribute('data-available') !== 'false';

    badgesContainer.setAttribute('data-base-price', basePrice);
    badgesContainer.setAttribute('data-base-compare-at-price', baseCompareAtPrice);
    badgesContainer.setAttribute('data-available', available ? 'true' : 'false');

    var quantity = scalePriceByQuantity ? getSaveBadgeQuantity(badgesContainer) : 1;
    var price = basePrice * quantity;
    var compareAtPrice = baseCompareAtPrice > basePrice ? baseCompareAtPrice * quantity : 0;
    var amountSaved = compareAtPrice - price;
    var percentageSaved = compareAtPrice > 0 ? Math.round((amountSaved / compareAtPrice) * 100) : 0;
    var showSaleBadge = saveBadgeEnabled && available && compareAtPrice > price && (showAmount || showPercent);
    var showSoldOutBadge = !available;

    if (saleBadge) {
      var saveElement = saleBadge.querySelector('span');
      if (saveElement && showSaleBadge) {
        var saveText = 'Save';
        if (showAmount && amountSaved > 0) {
          saveText += ' ' + formatSaveBadgeMoney(amountSaved);
        }
        if (showPercent && percentageSaved > 0) {
          saveText += showAmount ? ' (' + percentageSaved + '%)' : ' ' + percentageSaved + '%';
        }
        saveElement.textContent = saveText;
      }

      saleBadge.style.display = showSaleBadge ? 'inline-block' : 'none';
    }

    if (soldOutBadge) {
      soldOutBadge.style.display = showSoldOutBadge ? 'inline-block' : 'none';
    }

    badgesContainer.style.display = showSaleBadge || showSoldOutBadge ? 'flex' : 'none';
  });
}

function updateSaveBadge(variant, scope) {
  updateSavedBadges(scope, variant);
}



/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    
_updateAddToCartPrice: function(variant) {
    var priceElement = document.querySelector('.add-to-carst-price');
    if (priceElement && variant) {
        priceElement.textContent = variant.price; // returnnn
    }
},

_updateBadges: function(variant) {
    updateSavedBadges(this.$container && this.$container[0], variant);
},
    
_updateSaveBadge: function(variant) {
    updateSavedBadges(this.$container && this.$container[0], variant);
},




  _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
          type: 'variantChange',
          variant: variant
      });

      if (!variant) {
          return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;
    
      updateSKUElement(variant, this.$container && this.$container[0]);
      updateAvailabilityElement(variant, this.$container && this.$container[0]);

      if (this.enableHistoryState) {
          this._updateHistoryState(variant);
      }

      this._updateAddToCartPrice(variant);
    
      this._updateBadges(variant);
    
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearch = (function() {
  'use strict';

  function validateQuery(query) {
    var error;

    if (query === null || query === undefined) {
      error = new TypeError("'query' is missing");
      error.type = 'argument';
      throw error;
    }

    if (typeof query !== 'string') {
      error = new TypeError("'query' is not a string");
      error.type = 'argument';
      throw error;
    }
  }

  function GenericError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function NotFoundError(status) {
    var error = Error.call(this);

    error.name = 'Not found';
    error.message = 'Not found';
    error.status = status;

    return error;
  }

  function ServerError() {
    var error = Error.call(this);

    error.name = 'Server error';
    error.message = 'Something went wrong on the server';
    error.status = 500;

    return error;
  }

  function ContentTypeError(status) {
    var error = Error.call(this);

    error.name = 'Content-Type error';
    error.message = 'Content-Type was not provided or is of wrong type';
    error.status = status;

    return error;
  }

  function JsonParseError(status) {
    var error = Error.call(this);

    error.name = 'JSON parse error';
    error.message = 'JSON syntax error';
    error.status = status;

    return error;
  }

  function ThrottledError(status, name, message, retryAfter) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;
    error.retryAfter = retryAfter;

    return error;
  }

  function InvalidParameterError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function ExpectationFailedError(status, name, message) {
    var error = Error.call(this);

    error.name = name;
    error.message = message;
    error.status = status;

    return error;
  }

  function request(configParams, query, onSuccess, onError) {
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function() {
      if (xhr.readyState !== XMLHttpRequest.DONE) {
        return;
      }

      var contentType = xhr.getResponseHeader('Content-Type');

      if (xhr.status >= 500) {
        onError(new ServerError());

        return;
      }

      if (xhr.status === 404) {
        onError(new NotFoundError(xhr.status));

        return;
      }

      if (
        typeof contentType !== 'string' ||
        contentType.toLowerCase().match('application/json') === null
      ) {
        onError(new ContentTypeError(xhr.status));

        return;
      }

      if (xhr.status === 417) {
        try {
          var invalidParameterJson = JSON.parse(xhr.responseText);

          onError(
            new InvalidParameterError(
              xhr.status,
              invalidParameterJson.message,
              invalidParameterJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 422) {
        try {
          var expectationFailedJson = JSON.parse(xhr.responseText);

          onError(
            new ExpectationFailedError(
              xhr.status,
              expectationFailedJson.message,
              expectationFailedJson.description
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 429) {
        try {
          var throttledJson = JSON.parse(xhr.responseText);

          onError(
            new ThrottledError(
              xhr.status,
              throttledJson.message,
              throttledJson.description,
              xhr.getResponseHeader('Retry-After')
            )
          );
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          res.query = query;
          onSuccess(res);
        } catch (error) {
          onError(new JsonParseError(xhr.status));
        }

        return;
      }

      try {
        var genericErrorJson = JSON.parse(xhr.responseText);
        onError(
          new GenericError(
            xhr.status,
            genericErrorJson.message,
            genericErrorJson.description
          )
        );
      } catch (error) {
        onError(new JsonParseError(xhr.status));
      }

      return;
    };

    xhr.open(
      'get',
      '/search/suggest.json?q=' + encodeURIComponent(query) + '&' + configParams
    );

    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.send();
  }

  function Cache(config) {
    this._store = {};
    this._keys = [];
    if (config && config.bucketSize) {
      this.bucketSize = config.bucketSize;
    } else {
      this.bucketSize = 20;
    }
  }

  Cache.prototype.set = function(key, value) {
    if (this.count() >= this.bucketSize) {
      var deleteKey = this._keys.splice(0, 1);
      this.delete(deleteKey);
    }

    this._keys.push(key);
    this._store[key] = value;

    return this._store;
  };

  Cache.prototype.get = function(key) {
    return this._store[key];
  };

  Cache.prototype.has = function(key) {
    return Boolean(this._store[key]);
  };

  Cache.prototype.count = function() {
    return Object.keys(this._store).length;
  };

  Cache.prototype.delete = function(key) {
    var exists = Boolean(this._store[key]);
    delete this._store[key];
    return exists && !this._store[key];
  };

  function Dispatcher() {
    this.events = {};
  }

  Dispatcher.prototype.on = function(eventName, callback) {
    var event = this.events[eventName];
    if (!event) {
      event = new DispatcherEvent(eventName);
      this.events[eventName] = event;
    }
    event.registerCallback(callback);
  };

  Dispatcher.prototype.off = function(eventName, callback) {
    var event = this.events[eventName];
    if (event && event.callbacks.indexOf(callback) > -1) {
      event.unregisterCallback(callback);
      if (event.callbacks.length === 0) {
        delete this.events[eventName];
      }
    }
  };

  Dispatcher.prototype.dispatch = function(eventName, payload) {
    var event = this.events[eventName];
    if (event) {
      event.fire(payload);
    }
  };

  function DispatcherEvent(eventName) {
    this.eventName = eventName;
    this.callbacks = [];
  }

  DispatcherEvent.prototype.registerCallback = function(callback) {
    this.callbacks.push(callback);
  };

  DispatcherEvent.prototype.unregisterCallback = function(callback) {
    var index = this.callbacks.indexOf(callback);
    if (index > -1) {
      this.callbacks.splice(index, 1);
    }
  };

  DispatcherEvent.prototype.fire = function(payload) {
    var callbacks = this.callbacks.slice(0);
    callbacks.forEach(function(callback) {
      callback(payload);
    });
  };

  function debounce(func, wait) {
    var timeout = null;
    return function() {
      var context = this;
      var args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        func.apply(context, args);
      }, wait || 0);
    };
  }

  function objectToQueryParams(obj, parentKey) {
    var output = '';
    parentKey = parentKey || null;

    Object.keys(obj).forEach(function(key) {
      var outputKey = key + '=';
      if (parentKey) {
        outputKey = parentKey + '[' + key + ']';
      }

      switch (trueTypeOf(obj[key])) {
        case 'object':
          output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
          break;
        case 'array':
          output += outputKey + '=' + obj[key].join(',') + '&';
          break;
        default:
          if (parentKey) {
            outputKey += '=';
          }
          output += outputKey + encodeURIComponent(obj[key]) + '&';
          break;
      }
    });

    return output;
  }

  function trueTypeOf(obj) {
    return Object.prototype.toString
      .call(obj)
      .slice(8, -1)
      .toLowerCase();
  }

  var DEBOUNCE_RATE = 10;
  var requestDebounced = debounce(request, DEBOUNCE_RATE);

  function PredictiveSearch(config) {
    if (!config) {
      throw new TypeError('No config object was specified');
    }

    this._retryAfter = null;
    this._currentQuery = null;

    this.dispatcher = new Dispatcher();
    this.cache = new Cache({ bucketSize: 40 });
    this.configParams = objectToQueryParams(config);
  }

  PredictiveSearch.TYPES = {
    PRODUCT: 'product',
    PAGE: 'page',
    ARTICLE: 'article'
  };

  PredictiveSearch.FIELDS = {
    AUTHOR: 'author',
    BODY: 'body',
    PRODUCT_TYPE: 'product_type',
    TAG: 'tag',
    TITLE: 'title',
    VARIANTS_BARCODE: 'variants.barcode',
    VARIANTS_SKU: 'variants.sku',
    VARIANTS_TITLE: 'variants.title',
    VENDOR: 'vendor'
  };

  PredictiveSearch.UNAVAILABLE_PRODUCTS = {
    SHOW: 'show',
    HIDE: 'hide',
    LAST: 'last'
  };

  PredictiveSearch.prototype.query = function query(query) {
    try {
      validateQuery(query);
    } catch (error) {
      this.dispatcher.dispatch('error', error);
      return;
    }

    if (query === '') {
      return this;
    }

    this._currentQuery = normalizeQuery(query);
    var cacheResult = this.cache.get(this._currentQuery);
    if (cacheResult) {
      this.dispatcher.dispatch('success', cacheResult);
      return this;
    }

    requestDebounced(
      this.configParams,
      query,
      function(result) {
        this.cache.set(normalizeQuery(result.query), result);
        if (normalizeQuery(result.query) === this._currentQuery) {
          this._retryAfter = null;
          this.dispatcher.dispatch('success', result);
        }
      }.bind(this),
      function(error) {
        if (error.retryAfter) {
          this._retryAfter = error.retryAfter;
        }
        this.dispatcher.dispatch('error', error);
      }.bind(this)
    );

    return this;
  };

  PredictiveSearch.prototype.on = function on(eventName, callback) {
    this.dispatcher.on(eventName, callback);

    return this;
  };

  PredictiveSearch.prototype.off = function on(eventName, callback) {
    this.dispatcher.off(eventName, callback);

    return this;
  };

  function normalizeQuery(query) {
    if (typeof query !== 'string') {
      return null;
    }

    return query
      .trim()
      .replace(' ', '-')
      .toLowerCase();
  }

  return PredictiveSearch;
})();

this.Shopify = this.Shopify || {};
this.Shopify.theme = this.Shopify.theme || {};
this.Shopify.theme.PredictiveSearchComponent = (function(PredictiveSearch) {
  'use strict';

  PredictiveSearch =
    PredictiveSearch && PredictiveSearch.hasOwnProperty('default')
      ? PredictiveSearch['default']
      : PredictiveSearch;

  var DEFAULT_PREDICTIVE_SEARCH_API_CONFIG = {
    resources: {
      type: [PredictiveSearch.TYPES.PRODUCT],
      options: {
        unavailable_products: PredictiveSearch.UNAVAILABLE_PRODUCTS.LAST,
        fields: [
          PredictiveSearch.FIELDS.TITLE,
          PredictiveSearch.FIELDS.VENDOR,
          PredictiveSearch.FIELDS.PRODUCT_TYPE,
          PredictiveSearch.FIELDS.VARIANTS_TITLE
        ]
      }
    }
  };

  function PredictiveSearchComponent(config) {
    // validate config
    if (
      !config ||
      !config.selectors ||
      !config.selectors.input ||
      !isString(config.selectors.input) ||
      !config.selectors.result ||
      !isString(config.selectors.result) ||
      !config.resultTemplateFct ||
      !isFunction(config.resultTemplateFct) ||
      !config.numberOfResultsTemplateFct ||
      !isFunction(config.numberOfResultsTemplateFct) ||
      !config.loadingResultsMessageTemplateFct ||
      !isFunction(config.loadingResultsMessageTemplateFct)
    ) {
      var error = new TypeError(
        'PredictiveSearchComponent config is not valid'
      );
      error.type = 'argument';
      throw error;
    }

    // Find nodes
    this.nodes = findNodes(config.selectors);

    // Validate nodes
    if (!isValidNodes(this.nodes)) {
      // eslint-disable-next-line no-console
      console.warn('Could not find valid nodes');
      return;
    }

    // Store the keyword that was used for the search
    this._searchKeyword = '';

    // Assign result template
    this.resultTemplateFct = config.resultTemplateFct;

    // Assign number of results template
    this.numberOfResultsTemplateFct = config.numberOfResultsTemplateFct;

    // Assign loading state template function
    this.loadingResultsMessageTemplateFct =
      config.loadingResultsMessageTemplateFct;

    // Assign number of search results
    this.numberOfResults = config.numberOfResults || 4;

    // Set classes
    this.classes = {
      visibleVariant: config.visibleVariant
        ? config.visibleVariant
        : 'predictive-search-wrapper--visible',
      itemSelected: config.itemSelectedClass
        ? config.itemSelectedClass
        : 'predictive-search-item--selected',
      clearButtonVisible: config.clearButtonVisibleClass
        ? config.clearButtonVisibleClass
        : 'predictive-search__clear-button--visible'
    };

    this.selectors = {
      searchResult: config.searchResult
        ? config.searchResult
        : '[data-search-result]'
    };

    // Assign callbacks
    this.callbacks = assignCallbacks(config);

    // Add input attributes
    addInputAttributes(this.nodes.input);

    // Add input event listeners
    this._addInputEventListeners();

    // Add body listener
    this._addBodyEventListener();

    // Add accessibility announcer
    this._addAccessibilityAnnouncer();

    // Display the reset button if the input is not empty
    this._toggleClearButtonVisibility();

    // Instantiate Predictive Search API
    this.predictiveSearch = new PredictiveSearch(
      config.PredictiveSearchAPIConfig
        ? config.PredictiveSearchAPIConfig
        : DEFAULT_PREDICTIVE_SEARCH_API_CONFIG
    );

    // Add predictive search success event listener
    this.predictiveSearch.on(
      'success',
      this._handlePredictiveSearchSuccess.bind(this)
    );

    // Add predictive search error event listener
    this.predictiveSearch.on(
      'error',
      this._handlePredictiveSearchError.bind(this)
    );
  }

  /**
   * Private methods
   */
  function findNodes(selectors) {
    return {
      input: document.querySelector(selectors.input),
      reset: document.querySelector(selectors.reset),
      result: document.querySelector(selectors.result)
    };
  }

  function isValidNodes(nodes) {
    if (
      !nodes ||
      !nodes.input ||
      !nodes.result ||
      nodes.input.tagName !== 'INPUT'
    ) {
      return false;
    }

    return true;
  }

  function assignCallbacks(config) {
    return {
      onBodyMousedown: config.onBodyMousedown,
      onBeforeOpen: config.onBeforeOpen,
      onOpen: config.onOpen,
      onBeforeClose: config.onBeforeClose,
      onClose: config.onClose,
      onInputFocus: config.onInputFocus,
      onInputKeyup: config.onInputKeyup,
      onInputBlur: config.onInputBlur,
      onInputReset: config.onInputReset,
      onBeforeDestroy: config.onBeforeDestroy,
      onDestroy: config.onDestroy
    };
  }

  function addInputAttributes(input) {
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
  }

  function removeInputAttributes(input) {
    input.removeAttribute('autocorrect', 'off');
    input.removeAttribute('autocomplete', 'off');
    input.removeAttribute('autocapitalize', 'off');
    input.removeAttribute('spellcheck', 'false');
  }

  /**
   * Public variables
   */
  PredictiveSearchComponent.prototype.isResultVisible = false;
  PredictiveSearchComponent.prototype.results = {};

  /**
   * "Private" variables
   */
  PredictiveSearchComponent.prototype._latencyTimer = null;
  PredictiveSearchComponent.prototype._resultNodeClicked = false;

  /**
   * "Private" instance methods
   */
  PredictiveSearchComponent.prototype._addInputEventListeners = function() {
    var input = this.nodes.input;
    var reset = this.nodes.reset;

    if (!input) {
      return;
    }

    this._handleInputFocus = this._handleInputFocus.bind(this);
    this._handleInputBlur = this._handleInputBlur.bind(this);
    this._handleInputKeyup = this._handleInputKeyup.bind(this);
    this._handleInputKeydown = this._handleInputKeydown.bind(this);

    input.addEventListener('focus', this._handleInputFocus);
    input.addEventListener('blur', this._handleInputBlur);
    input.addEventListener('keyup', this._handleInputKeyup);
    input.addEventListener('keydown', this._handleInputKeydown);

    if (reset) {
      this._handleInputReset = this._handleInputReset.bind(this);
      reset.addEventListener('click', this._handleInputReset);
    }
  };

  PredictiveSearchComponent.prototype._removeInputEventListeners = function() {
    var input = this.nodes.input;

    input.removeEventListener('focus', this._handleInputFocus);
    input.removeEventListener('blur', this._handleInputBlur);
    input.removeEventListener('keyup', this._handleInputKeyup);
    input.removeEventListener('keydown', this._handleInputKeydown);
  };

  PredictiveSearchComponent.prototype._addBodyEventListener = function() {
    this._handleBodyMousedown = this._handleBodyMousedown.bind(this);

    document
      .querySelector('body')
      .addEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeBodyEventListener = function() {
    document
      .querySelector('body')
      .removeEventListener('mousedown', this._handleBodyMousedown);
  };

  PredictiveSearchComponent.prototype._removeClearButtonEventListener = function() {
    var reset = this.nodes.reset;

    if (!reset) {
      return;
    }

    reset.removeEventListener('click', this._handleInputReset);
  };

  /**
   * Event handlers
   */
  PredictiveSearchComponent.prototype._handleBodyMousedown = function(evt) {
    if (this.isResultVisible && this.nodes !== null) {
      if (
        evt.target.isEqualNode(this.nodes.input) ||
        this.nodes.input.contains(evt.target) ||
        evt.target.isEqualNode(this.nodes.result) ||
        this.nodes.result.contains(evt.target)
      ) {
        this._resultNodeClicked = true;
      } else {
        if (isFunction(this.callbacks.onBodyMousedown)) {
          var returnedValue = this.callbacks.onBodyMousedown(this.nodes);
          if (isBoolean(returnedValue) && returnedValue) {
            this.close();
          }
        } else {
          this.close();
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._handleInputFocus = function(evt) {
    if (isFunction(this.callbacks.onInputFocus)) {
      var returnedValue = this.callbacks.onInputFocus(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputBlur = function() {
    // This has to be done async, to wait for the focus to be on the next
    // element and avoid closing the results.
    // Example: Going from the input to the reset button.
    setTimeout(
      function() {
        if (isFunction(this.callbacks.onInputBlur)) {
          var returnedValue = this.callbacks.onInputBlur(this.nodes);
          if (isBoolean(returnedValue) && !returnedValue) {
            return false;
          }
        }

        if (document.activeElement.isEqualNode(this.nodes.reset)) {
          return false;
        }

        if (this._resultNodeClicked) {
          this._resultNodeClicked = false;
          return false;
        }

        this.close();
      }.bind(this)
    );

    return true;
  };

  PredictiveSearchComponent.prototype._addAccessibilityAnnouncer = function() {
    this._accessibilityAnnouncerDiv = window.document.createElement('div');

    this._accessibilityAnnouncerDiv.setAttribute(
      'style',
      'position: absolute !important; overflow: hidden; clip: rect(0 0 0 0); height: 1px; width: 1px; margin: -1px; padding: 0; border: 0;'
    );

    this._accessibilityAnnouncerDiv.setAttribute('data-search-announcer', '');
    this._accessibilityAnnouncerDiv.setAttribute('aria-live', 'polite');
    this._accessibilityAnnouncerDiv.setAttribute('aria-atomic', 'true');

    this.nodes.result.parentElement.appendChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._removeAccessibilityAnnouncer = function() {
    this.nodes.result.parentElement.removeChild(
      this._accessibilityAnnouncerDiv
    );
  };

  PredictiveSearchComponent.prototype._updateAccessibilityAttributesAfterSelectingElement = function(
    previousSelectedElement,
    currentSelectedElement
  ) {
    // Update the active descendant on the search input
    this.nodes.input.setAttribute(
      'aria-activedescendant',
      currentSelectedElement.id
    );

    // Unmark the previousSelected elemented as selected
    if (previousSelectedElement) {
      previousSelectedElement.removeAttribute('aria-selected');
    }

    // Mark the element as selected
    currentSelectedElement.setAttribute('aria-selected', true);
  };

  PredictiveSearchComponent.prototype._clearAriaActiveDescendant = function() {
    this.nodes.input.setAttribute('aria-activedescendant', '');
  };

  PredictiveSearchComponent.prototype._announceNumberOfResultsFound = function(
    results
  ) {
    var currentAnnouncedMessage = this._accessibilityAnnouncerDiv.innerHTML;
    var newMessage = this.numberOfResultsTemplateFct(results);

    // If the messages are the same, they won't get announced
    // add white space so it gets announced
    if (currentAnnouncedMessage === newMessage) {
      newMessage = newMessage + '&nbsp;';
    }

    this._accessibilityAnnouncerDiv.innerHTML = newMessage;
  };

  PredictiveSearchComponent.prototype._announceLoadingState = function() {
    this._accessibilityAnnouncerDiv.innerHTML = this.loadingResultsMessageTemplateFct();
  };

  PredictiveSearchComponent.prototype._handleInputKeyup = function(evt) {
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;
    var RETURN_KEY_CODE = 13;
    var ESCAPE_KEY_CODE = 27;

    if (isFunction(this.callbacks.onInputKeyup)) {
      var returnedValue = this.callbacks.onInputKeyup(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this._toggleClearButtonVisibility();

    if (this.isResultVisible && this.nodes !== null) {
      if (evt.keyCode === UP_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'UP');
        return true;
      }

      if (evt.keyCode === DOWN_ARROW_KEY_CODE) {
        this._navigateOption(evt, 'DOWN');
        return true;
      }

      if (evt.keyCode === RETURN_KEY_CODE) {
        this._selectOption();
        return true;
      }

      if (evt.keyCode === ESCAPE_KEY_CODE) {
        this.close();
      }
    }

    if (evt.target.value.length <= 0) {
      this.close();
      this._setKeyword('');
    } else if (evt.target.value.length > 0) {
      this._search();
    }

    return true;
  };

  PredictiveSearchComponent.prototype._handleInputKeydown = function(evt) {
    var RETURN_KEY_CODE = 13;
    var UP_ARROW_KEY_CODE = 38;
    var DOWN_ARROW_KEY_CODE = 40;

    // Prevent the form default submission if there is a selected option
    if (evt.keyCode === RETURN_KEY_CODE && this._getSelectedOption() !== null) {
      evt.preventDefault();
    }

    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      evt.keyCode === UP_ARROW_KEY_CODE ||
      evt.keyCode === DOWN_ARROW_KEY_CODE
    ) {
      evt.preventDefault();
    }
  };

  PredictiveSearchComponent.prototype._handleInputReset = function(evt) {
    evt.preventDefault();

    if (isFunction(this.callbacks.onInputReset)) {
      var returnedValue = this.callbacks.onInputReset(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.input.value = '';
    this.nodes.input.focus();
    this._toggleClearButtonVisibility();
    this.close();

    return true;
  };

  PredictiveSearchComponent.prototype._navigateOption = function(
    evt,
    direction
  ) {
    var currentOption = this._getSelectedOption();

    if (!currentOption) {
      var firstOption = this.nodes.result.querySelector(
        this.selectors.searchResult
      );
      firstOption.classList.add(this.classes.itemSelected);
      this._updateAccessibilityAttributesAfterSelectingElement(
        null,
        firstOption
      );
    } else {
      if (direction === 'DOWN') {
        var nextOption = currentOption.nextElementSibling;
        if (nextOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          nextOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            nextOption
          );
        }
      } else {
        var previousOption = currentOption.previousElementSibling;
        if (previousOption) {
          currentOption.classList.remove(this.classes.itemSelected);
          previousOption.classList.add(this.classes.itemSelected);
          this._updateAccessibilityAttributesAfterSelectingElement(
            currentOption,
            previousOption
          );
        }
      }
    }
  };

  PredictiveSearchComponent.prototype._getSelectedOption = function() {
    return this.nodes.result.querySelector('.' + this.classes.itemSelected);
  };

  PredictiveSearchComponent.prototype._selectOption = function() {
    var selectedOption = this._getSelectedOption();

    if (selectedOption) {
      selectedOption.querySelector('a, button').click();
    }
  };

  PredictiveSearchComponent.prototype._search = function() {
    var newSearchKeyword = this.nodes.input.value;

    if (this._searchKeyword === newSearchKeyword) {
      return;
    }

    clearTimeout(this._latencyTimer);
    this._latencyTimer = setTimeout(
      function() {
        this.results.isLoading = true;

        // Annonuce that we're loading the results
        this._announceLoadingState();

        this.nodes.result.classList.add(this.classes.visibleVariant);
        // NOTE: We could benifit in using DOMPurify.
        // https://github.com/cure53/DOMPurify
        this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      }.bind(this),
      500
    );

    this.predictiveSearch.query(newSearchKeyword);
    this._setKeyword(newSearchKeyword);
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchSuccess = function(
    json
  ) {
    clearTimeout(this._latencyTimer);
    this.results = json.resources.results;

    this.results.isLoading = false;
    this.results.products = this.results.products.slice(
      0,
      this.numberOfResults
    );
    this.results.canLoadMore =
      this.numberOfResults <= this.results.products.length;
    this.results.searchQuery = this.nodes.input.value;

    if (this.results.products.length > 0 || this.results.searchQuery) {
      this.nodes.result.innerHTML = this.resultTemplateFct(this.results);
      this._announceNumberOfResultsFound(this.results);
      this.open();
    } else {
      this.nodes.result.innerHTML = '';

      this._closeOnNoResults();
    }
  };

  PredictiveSearchComponent.prototype._handlePredictiveSearchError = function() {
    clearTimeout(this._latencyTimer);
    this.nodes.result.innerHTML = '';

    this._closeOnNoResults();
  };

  PredictiveSearchComponent.prototype._closeOnNoResults = function() {
    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.isResultVisible = false;
  };

  PredictiveSearchComponent.prototype._setKeyword = function(keyword) {
    this._searchKeyword = keyword;
  };

  PredictiveSearchComponent.prototype._toggleClearButtonVisibility = function() {
    if (!this.nodes.reset) {
      return;
    }

    if (this.nodes.input.value.length > 0) {
      this.nodes.reset.classList.add(this.classes.clearButtonVisible);
    } else {
      this.nodes.reset.classList.remove(this.classes.clearButtonVisible);
    }
  };

  /**
   * Public methods
   */
  PredictiveSearchComponent.prototype.open = function() {
    if (this.isResultVisible) {
      return;
    }

    if (isFunction(this.callbacks.onBeforeOpen)) {
      var returnedValue = this.callbacks.onBeforeOpen(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.add(this.classes.visibleVariant);
    this.nodes.input.setAttribute('aria-expanded', true);
    this.isResultVisible = true;

    if (isFunction(this.callbacks.onOpen)) {
      return this.callbacks.onOpen(this.nodes) || true;
    }

    return true;
  };

  PredictiveSearchComponent.prototype.close = function() {
    if (!this.isResultVisible) {
      return true;
    }

    if (isFunction(this.callbacks.onBeforeClose)) {
      var returnedValue = this.callbacks.onBeforeClose(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    if (this.nodes) {
      this.nodes.result.classList.remove(this.classes.visibleVariant);
    }

    this.nodes.input.setAttribute('aria-expanded', false);
    this._clearAriaActiveDescendant();
    this._setKeyword('');

    if (isFunction(this.callbacks.onClose)) {
      this.callbacks.onClose(this.nodes);
    }

    this.isResultVisible = false;
    this.results = {};

    return true;
  };

  PredictiveSearchComponent.prototype.destroy = function() {
    this.close();

    if (isFunction(this.callbacks.onBeforeDestroy)) {
      var returnedValue = this.callbacks.onBeforeDestroy(this.nodes);
      if (isBoolean(returnedValue) && !returnedValue) {
        return false;
      }
    }

    this.nodes.result.classList.remove(this.classes.visibleVariant);
    removeInputAttributes(this.nodes.input);
    this._removeInputEventListeners();
    this._removeBodyEventListener();
    this._removeAccessibilityAnnouncer();
    this._removeClearButtonEventListener();

    if (isFunction(this.callbacks.onDestroy)) {
      this.callbacks.onDestroy(this.nodes);
    }

    return true;
  };

  PredictiveSearchComponent.prototype.clearAndClose = function() {
    this.nodes.input.value = '';
    this.close();
  };

  /**
   * Utilities
   */
  function getTypeOf(value) {
    return Object.prototype.toString.call(value);
  }

  function isString(value) {
    return getTypeOf(value) === '[object String]';
  }

  function isBoolean(value) {
    return getTypeOf(value) === '[object Boolean]';
  }

  function isFunction(value) {
    return getTypeOf(value) === '[object Function]';
  }

  return PredictiveSearchComponent;
})(Shopify.theme.PredictiveSearch);


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var DEFAULT_OPEN_CLASS = 'js-drawer-open';
    var DEFAULT_CLOSE_CLASS = 'js-drawer-close';

    var defaults = {
      selectors: {
        openVariant: '.' + DEFAULT_OPEN_CLASS + '-' + position,
        close: '.' + DEFAULT_CLOSE_CLASS
      },
      classes: {
        open: DEFAULT_OPEN_CLASS,
        openVariant: DEFAULT_OPEN_CLASS + '-' + position
      },
      withPredictiveSearch: false
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;
    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.selectors.openVariant).on('click', $.proxy(this.open, this));
    this.$drawer.on(
      'click',
      this.config.selectors.close,
      $.proxy(this.close, this)
    );
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    if (!this.config.withPredictiveSearch) {
      this.$drawer.prepareTransition();
    }

    this.nodes.$parent.addClass(
      this.config.classes.open + ' ' + this.config.classes.openVariant
    );
    this.drawerIsOpen = true;

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Set focus on drawer
    var trapFocusConfig = {
      $container: this.$drawer,
      namespace: 'drawer_focus'
    };
    if (this.config.$elementToFocusOnOpen) {
      trapFocusConfig.$elementToFocus = this.config.$elementToFocusOnOpen;
    }

    slate.a11y.trapFocus(trapFocusConfig);

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    if (!this.config.withPredictiveSearch) {
      this.$drawer.prepareTransition();
    }

    this.nodes.$parent.removeClass(
      this.config.classes.open + ' ' + this.config.classes.openVariant
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

theme.Helpers = (function() {
  var touchDevice = false;

  function setTouch() {
    touchDevice = true;
  }

  function isTouch() {
    return touchDevice;
  }
  return {
    setTouch: setTouch,
    isTouch: isTouch
  };
})();

theme.LibraryLoader = (function() {
  var types = {
    link: 'link',
    script: 'script'
  };

  var status = {
    requested: 'requested',
    loaded: 'loaded'
  };

  var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

  var libraries = {
    youtubeSdk: {
      tagId: 'youtube-sdk',
      src: 'https://www.youtube.com/iframe_api',
      type: types.script
    },
    plyrShopifyStyles: {
      tagId: 'plyr-shopify-styles',
      src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
      type: types.link
    },
    modelViewerUiStyles: {
      tagId: 'shopify-model-viewer-ui-styles',
      src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
      type: types.link
    }
  };

  function load(libraryName, callback) {
    var library = libraries[libraryName];

    if (!library) return;
    if (library.status === status.requested) return;

    callback = callback || function() {};
    if (library.status === status.loaded) {
      callback();
      return;
    }

    library.status = status.requested;

    var tag;

    switch (library.type) {
      case types.script:
        tag = createScriptTag(library, callback);
        break;
      case types.link:
        tag = createLinkTag(library, callback);
        break;
    }

    tag.id = library.tagId;
    library.element = tag;

    var firstScriptTag = document.getElementsByTagName(library.type)[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  function createScriptTag(library, callback) {
    var tag = document.createElement('script');
    tag.src = library.src;
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  function createLinkTag(library, callback) {
    var tag = document.createElement('link');
    tag.href = library.src;
    tag.rel = 'stylesheet';
    tag.type = 'text/css';
    tag.addEventListener('load', function() {
      library.status = status.loaded;
      callback();
    });
    return tag;
  }

  return {
    load: load
  };
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns($(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();
/*
   cache.$parents.on('click.siteNav', function() {
      var $el = $(this);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });
*/
    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    $(window).resize(
      $.debounce(50, function() {
        styleDropdowns($(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
      })
    );
  }
  
  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteHeader: $(selectors.siteHeader)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function styleDropdowns($dropdownListItems) {
    $dropdownListItems.each(function() {
      var $dropdownLi = $(this).find(selectors.siteNavDropdown);
      if (!$dropdownLi.length) {
        return;
      }
      var isRightOfLogo =
        Math.ceil($(this).offset().left) >
        Math.floor(cache.$siteHeader.outerWidth()) / 2
          ? true
          : false;
      if (isRightOfLogo) {
        $dropdownLi
          .removeClass(config.leftDropdownClass)
          .addClass(config.rightDropdownClass);
      } else {
        $dropdownLi
          .removeClass(config.rightDropdownClass)
          .addClass(config.leftDropdownClass);
      }
    });
  }

  function positionFullWidthDropdowns() {
    var $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);

    $listWithCenteredDropdown.each(function() {
      var $hasCenteredDropdown = $(this);
      var $fullWidthDropdown = $hasCenteredDropdown.find(
        selectors.siteNavCenteredDropdown
      );

      var fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 24;
      $fullWidthDropdown.css('top', fullWidthDropdownOffset);
    });
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
     
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);


    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    pauseButton: '.slideshow__pause',
    dots: '.slick-dots',
    arrows: '.slideshow__arrows',
    arrowsMobile: '.slideshow__arrows--mobile',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$arrows = this.$section.find(selectors.arrows);
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
    this.$pause = this.$controls.find(selectors.pauseButton);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: false,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      appendDots: this.$arrows,
      customPaging: function(slick, index) {
        return (
          '<a href="' +
          selectors.wrapper +
          sectionId +
          '" aria-label="' +
          loadSlideA11yString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '"></a>'
        );
      }
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    // Stop the autorotate when you scroll past the mobile controls, resume when
    // they are scrolled back into view
    if (this.autorotate) {
      $(document).scroll(
        $.debounce(
          250,
          function() {
            if (
              this.$arrowsMobile.offset().top +
                this.$arrowsMobile.outerHeight() <
              window.pageYOffset
            ) {
              $slideshow.slick('slickPause');
            } else if (!this.$pause.hasClass(classes.isPaused)) {
              $slideshow.slick('slickPlay');
            }
          }.bind(this)
        )
      );
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();

    this.$arrows.find(selectors.arrowLeft).on('click', function() {
      $slideshow.slick('slickPrev');
    });
    this.$arrows.find(selectors.arrowRight).on('click', function() {
      $slideshow.slick('slickNext');
    });

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    this.$wrapper.on('keyup', keyboardNavigation.bind(this));
    this.$controls.on('keyup', keyboardNavigation.bind(this));
    this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          if (this.autorotate) {
            // Only resume playing if the user hasn't paused using the pause
            // button
            if (!this.$pause.is('.is-paused')) {
              $slider.slick('slickPlay');
            }
          }
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');

    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

  function keyboardNavigation() {
    if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
      this.$slideshow.slick('slickPrev');
    }
    if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
      this.$slideshow.slick('slickNext');
    }
  }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPlay');
      }
    } else {
      this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPause');
      }
    }
  };

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

theme.Video = (function() {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };

  var selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause',
    pauseVideoStop: '.video__pause-stop',
    pauseVideoResume: '.video__pause-resume',
    fallbackText: '.icon__fallback-text'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status:
        $video.data('type') === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      $video: $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data('type') === 'background' ? 0 : 1
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $videoWrapper = videoData.$videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement)
      .removeClass(classes.supportsAutoplay)
      .removeClass(classes.supportsNoAutoplay)
      .addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    var videoTitle = evt.target.getVideoData().title;
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();
    setButtonLabels(videoData.$videoWrapper, videoTitle);

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.$videoWrapper.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === 'background' &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.$videoWrapper.removeClass(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function() {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'image_with_play':
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $videoWrapper = videoData.$videoWrapper;
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);

    $videoWrapper.removeClass(classes.loading);

    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    if (videoData.type === 'image_with_play') {
      $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function() {
      $videoWrapper.find(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var $videoWrapper = videoData.$videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        $videoWrapper.removeClass(classes.paused);
      } else {
        $videoWrapper.addClass(classes.paused);
      }
    }

    $videoWrapper.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $videoWrapper = videoData.$videoWrapper;
    var classesToRemove = [classes.paused, classes.playing].join(' ');

    if (isMobile()) {
      $videoWrapper.removeAttr('style');
    }

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case 'background':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    $videoWrapper.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    var id = evt.target.getIframe().id;
    return videos[id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop = video.$videoWrapper.offset().top;
    var $playButton = video.$videoWrapper.find(selectors.playVideoBtn);
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
       // video.$videoWrapper.parent().toggleClass('page-width', !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = $(window).width() / videoOptions.ratio;
      } else {
        newHeight = video.$videoWrapper.width() / videoOptions.ratio;
      }
      offset = ($(window).height() - newHeight) / 2;

      video.$videoWrapper
        .removeClass(classes.wrapperMinHeight)
        .animate({ height: newHeight }, 600);

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        $('html, body').animate(
          {
            scrollTop: elementTop - offset
          },
          videoOptions.scrollAnimationDuration
        );
      }
    } else {
      if (isMobile()) {
        newHeight = video.$videoWrapper.data('mobile-height');
      } else {
        newHeight = video.$videoWrapper.data('desktop-height');
      }

      video.$videoWrapper
        .height(video.$videoWrapper.width() / videoOptions.ratio)
        .animate({ height: newHeight }, 600);
      setTimeout(function() {
        video.$videoWrapper.addClass(classes.wrapperMinHeight);
      }, 600);
      $playButton.focus();
    }
  }

  function togglePause(playerId) {
    var $pauseButton = videos[playerId].$videoWrapper.find(
      selectors.pauseVideoBtn
    );
    var paused = $pauseButton.hasClass(classes.userPaused);
    if (paused) {
      $pauseButton.removeClass(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      $pauseButton.addClass(classes.userPaused);
      pauseVideo(playerId);
    }
    $pauseButton.attr('aria-pressed', !paused);
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.$videoWrapper.addClass(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.$videoWrapper.attr(
      'style',
      'height: ' + video.$videoWrapper.height() + 'px'
    );

    video.status = 'open';

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true);
        break;
      case 'background':
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      var playerId = $(document.activeElement).data('controls');
      if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
        return;
      }

      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.backgroundVideo).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      $videoPlayer.removeAttr('style');
    } else {
      var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = $videoWrapper.width();
      var playerWidth = $videoPlayer.width();
      var desktopHeight = $videoWrapper.data('desktop-height');

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        $videoPlayer
          .width(playerWidth)
          .height(desktopHeight)
          .css({
            left: (videoWidth - playerWidth) / 2,
            top: 0
          }); // player width is greater, offset left; reset top
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        $videoPlayer
          .width(videoWidth)
          .height(desktopHeight)
          .css({
            left: 0,
            top: (desktopHeight - desktopHeight) / 2
          }); // player height is greater, offset top; reset left
      }

      $videoPlayer.prepareTransition();
      $videoWrapper.addClass(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    $('#' + playerId)
      .removeClass(classes.backgroundVideo)
      .addClass(classes.videoWithImage);

    setTimeout(function() {
      $('#' + playerId).removeAttr('style');
    }, 600);

    videos[playerId].$videoWrapper
      .removeClass(classes.backgroundVideoWrapper)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    $('#' + playerId)
      .removeClass(classes.videoWithImage)
      .addClass(classes.backgroundVideo);

    videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($('#' + playerId));
  }

  function isMobile() {
    return $(window).width() < 750 || window.mobileCheck();
  }

  function initEvents() {
    $(document).on('click.videoPlayer', selectors.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', selectors.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      $(evt.currentTarget).blur();
      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });

    $(document).on('click.videoPlayer', selectors.pauseVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      togglePause(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(200, function() {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;

        sizeBackgroundVideos();

        if (isMobile()) {
          for (key in videos) {
            if (videos.hasOwnProperty(key)) {
              if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key);
                  setAsPaused(videos[key]);
                }
              }
              videos[key].$videoWrapper.height(
                $(document).width() / videoOptions.ratio
              );
            }
          }
          setAutoplaySupport(false);
        } else {
          setAutoplaySupport(true);
          for (key in videos) {
            if (
              videos[key].$videoWrapper.find('.' + classes.videoWithImage)
                .length
            ) {
              continue;
            }
            videoPlayers[key].playVideo();
            setAsPlaying(videos[key]);
          }
        }
      })
    );

    $(window).on(
      'scroll.videoPlayer',
      $.debounce(50, function() {
        if (!youtubeLoaded) return;

        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var $videoWrapper = videos[key].$videoWrapper;

            // Close the video if more than 75% of it is scrolled out of view
            if (
              $videoWrapper.hasClass(classes.playing) &&
              ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
                $(window).scrollTop() ||
                $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
                  $(window).scrollTop() + $(window).height())
            ) {
              closeVideo(key);
              toggleExpandVideo(key, false);
            }
          }
        }
      })
    );
  }

  function createPlayer(key) {
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  function setButtonLabels($videoWrapper, title) {
    var $playButtons = $videoWrapper.find(selectors.playVideoBtn);
    var $closeButton = $videoWrapper.find(selectors.closeVideoBtn);
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);
    var $closeButtonText = $closeButton.find(selectors.fallbackText);
    var $pauseButtonStopText = $pauseButton
      .find(selectors.pauseVideoStop)
      .find(selectors.fallbackText);
    var $pauseButtonResumeText = $pauseButton
      .find(selectors.pauseVideoResume)
      .find(selectors.fallbackText);

    // Insert the video title retrieved from YouTube into the instructional text
    // for each button
    $playButtons.each(function() {
      var $playButton = $(this);
      var $playButtonText = $playButton.find(selectors.fallbackText);

      $playButtonText.text(
        $playButtonText.text().replace('[video_title]', title)
      );
    });
    $closeButtonText.text(
      $closeButtonText.text().replace('[video_title]', title)
    );
    $pauseButtonStopText.text(
      $pauseButtonStopText.text().replace('[video_title]', title)
    );
    $pauseButtonResumeText.text(
      $pauseButtonResumeText.text().replace('[video_title]', title)
    );
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

theme.ProductVideo = (function() {
  var videos = {};

  var hosts = {
    html5: 'html5',
    youtube: 'youtube'
  };

  var selectors = {
    productMediaWrapper: '[data-product-single-media-wrapper]'
  };

  var attributes = {
    enableVideoLooping: 'enable-video-looping',
    videoId: 'video-id'
  };

  function init(videoContainer, sectionId) {
    if (!videoContainer.length) {
      return;
    }

    var videoElement = videoContainer.find('iframe, video')[0];
    var mediaId = videoContainer.data('mediaId');

    if (!videoElement) {
      return;
    }

    videos[mediaId] = {
      mediaId: mediaId,
      sectionId: sectionId,
      host: hostFromVideoElement(videoElement),
      container: videoContainer,
      element: videoElement,
      ready: function() {
        createPlayer(this);
      }
    };

    var video = videos[mediaId];

    switch (video.host) {
      case hosts.html5:
        window.Shopify.loadFeatures([
          {
            name: 'video-ui',
            version: '1.0',
            onLoad: setupPlyrVideos
          }
        ]);
        theme.LibraryLoader.load('plyrShopifyStyles');
        break;
      case hosts.youtube:
        theme.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
        break;
    }
  }

  function setupPlyrVideos(errors) {
    if (errors) {
      fallbackToNativeVideo();
      return;
    }

    loadVideos(hosts.html5);
  }

  function setupYouTubeVideos() {
    if (!window.YT.Player) return;

    loadVideos(hosts.youtube);
  }

  function createPlayer(video) {
    if (video.player) {
      return;
    }

    var productMediaWrapper = video.container.closest(
      selectors.productMediaWrapper
    );
    var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

    switch (video.host) {
      case hosts.html5:
        // eslint-disable-next-line no-undef
        video.player = new Shopify.Plyr(video.element, {
          loop: { active: enableLooping }
        });
        break;
      case hosts.youtube:
        var videoId = productMediaWrapper.data(attributes.videoId);

        video.player = new YT.Player(video.element, {
          videoId: videoId,
          events: {
            onStateChange: function(event) {
              if (event.data === 0 && enableLooping) event.target.seekTo(0);
            }
          }
        });
        break;
    }

    productMediaWrapper.on('mediaHidden xrLaunch', function() {
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.pause();
      }

      if (video.host === hosts.youtube && video.player.pauseVideo) {
        video.player.pauseVideo();
      }
    });

    productMediaWrapper.on('mediaVisible', function() {
      if (theme.Helpers.isTouch()) return;
      if (!video.player) return;

      if (video.host === hosts.html5) {
        video.player.play();
      }

      if (video.host === hosts.youtube && video.player.playVideo) {
        video.player.playVideo();
      }
    });
  }

  function hostFromVideoElement(video) {
    if (video.tagName === 'VIDEO') {
      return hosts.html5;
    }

    if (video.tagName === 'IFRAME') {
      if (
        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
          video.src
        )
      ) {
        return hosts.youtube;
      }
    }
    return null;
  }

  function loadVideos(host) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];
        if (video.host === host) {
          video.ready();
        }
      }
    }
  }

  function fallbackToNativeVideo() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.nativeVideo) continue;

        if (video.host === hosts.html5) {
          video.element.setAttribute('controls', 'controls');
          video.nativeVideo = true;
        }
      }
    }
  }

  function removeSectionVideos(sectionId) {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var video = videos[key];

        if (video.sectionId === sectionId) {
          if (video.player) video.player.destroy();
          delete videos[key];
        }
      }
    }
  }

  return {
    init: init,
    hosts: hosts,
    loadVideos: loadVideos,
    removeSectionVideos: removeSectionVideos
  };
})();

theme.ProductModel = (function() {
  var modelJsonSections = {};
  var models = {};
  var xrButtons = {};

  var selectors = {
    mediaGroup: '[data-product-single-media-group]',
    xrButton: '[data-shopify-xr]'
  };

  function init(modelViewerContainers, sectionId) {
    modelJsonSections[sectionId] = {
      loaded: false
    };

    modelViewerContainers.each(function(index) {
      var $modelViewerContainer = $(this);
      var mediaId = $modelViewerContainer.data('media-id');
      var $modelViewerElement = $(
        $modelViewerContainer.find('model-viewer')[0]
      );
      var modelId = $modelViewerElement.data('model-id');

      if (index === 0) {
        var $xrButton = $modelViewerContainer
          .closest(selectors.mediaGroup)
          .find(selectors.xrButton);
        xrButtons[sectionId] = {
          $element: $xrButton,
          defaultId: modelId
        };
      }

      models[mediaId] = {
        modelId: modelId,
        sectionId: sectionId,
        $container: $modelViewerContainer,
        $element: $modelViewerElement
      };
    });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: setupShopifyXr
      },
      {
        name: 'model-viewer-ui',
        version: '1.0',
        onLoad: setupModelViewerUi
      }
    ]);
    theme.LibraryLoader.load('modelViewerUiStyles');
  }

  function setupShopifyXr(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', function() {
        setupShopifyXr();
      });
      return;
    }

    for (var sectionId in modelJsonSections) {
      if (modelJsonSections.hasOwnProperty(sectionId)) {
        var modelSection = modelJsonSections[sectionId];

        if (modelSection.loaded) continue;
        var $modelJson = $('#ModelJson-' + sectionId);

        window.ShopifyXR.addModels(JSON.parse($modelJson.html()));
        modelSection.loaded = true;
      }
    }
    window.ShopifyXR.setupXRElements();
  }

  function setupModelViewerUi(errors) {
    if (errors) return;

    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (!model.modelViewerUi) {
          model.modelViewerUi = new Shopify.ModelViewerUI(model.$element);
        }
        setupModelViewerListeners(model);
      }
    }
  }

  function setupModelViewerListeners(model) {
    var xrButton = xrButtons[model.sectionId];

    model.$container.on('mediaVisible', function() {
      xrButton.$element.attr('data-shopify-model3d-id', model.modelId);
      if (theme.Helpers.isTouch()) return;
      model.modelViewerUi.play();
    });

    model.$container
      .on('mediaHidden', function() {
        xrButton.$element.attr('data-shopify-model3d-id', xrButton.defaultId);
        model.modelViewerUi.pause();
      })
      .on('xrLaunch', function() {
        model.modelViewerUi.pause();
      });
  }

  function removeSectionModels(sectionId) {
    for (var key in models) {
      if (models.hasOwnProperty(key)) {
        var model = models[key];
        if (model.sectionId === sectionId) {
          models[key].modelViewerUi.destroy();
          delete models[key];
        }
      }
    }
    delete modelJsonSections[sectionId];
  }

  return {
    init: init,
    removeSectionModels: removeSectionModels
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.attr('tabindex', -1).focus();

    this.$statusMessage.on('blur', handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr('tabindex');
  }

  return {
    init: init
  };
})();

theme.Hero = (function() {
  var classes = {
    indexSectionFlush: 'index-section--flush'
  };

  var selectors = {
    heroFixedWidthContent: '.hero-fixed-width__content',
    heroFixedWidthImage: '.hero-fixed-width__image'
  };

  function hero(el, sectionId) {
    this.$hero = $(el);
    this.layout = this.$hero.data('layout');
    var $parentSection = $('#shopify-section-' + sectionId);
    var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
    var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);

    if (this.layout !== 'fixed_width') {
      return;
    }

    $parentSection.removeClass(classes.indexSectionFlush);
    heroFixedHeight();
    $(window).resize(
      $.debounce(50, function() {
        heroFixedHeight();
      })
    );

    function heroFixedHeight() {
      var contentHeight = $heroContent.height() + 50;
      var imageHeight = $heroImage.height();

      if (contentHeight > imageHeight) {
        $heroImage.css('min-height', contentHeight);
      }
    }
  }

  return hero;
})();

// prettier-ignore
window.theme = window.theme || {};

// START DEPRICTATED SEARCH
theme.SearchResultsTemplate = (function() {
  function renderResults(products, isLoading, searchQuery) {
    return [
      '<div class="predictive-search">',
      renderHeader(products, isLoading),
      renderProducts(products, searchQuery),
      '</div>'
    ].join('');
  }

  function renderHeader(products, isLoading) {
    if (products.length === 0) {
      return '';
    }

    return [
      '<div class="predictive-search-title">',
      '<h3 id="predictive-search" class="predictive-search-title__content">' +
        theme.strings.products +
        '</h3>',
      '<span class="predictive-search-title__loading-spinner">' +
        (isLoading
          ? '<span class= "icon-predictive-search-spinner" ></span >'
          : '') +
        '</span>',
      '</div>'
    ].join('');
  }

  function loadingState() {
    return [
      '<div class="predictive-search">',
      '<div class="predictive-search-loading">',
      '<span class="visually-hidden">' + theme.strings.loading + '</span>',
      '<span class="predictive-search-loading__icon">',
      '<span class="icon-predictive-search-spinner"></span>',
      '</span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function renderViewAll(searchQuery) {
    return [
      '<button type="submit" class="predictive-search-view-all__button" tabindex="-1">',
      theme.strings.searchFor +
        '<span class="predictive-search-view-all__query"> &ldquo;' +
        _htmlEscape(searchQuery) +
        '&rdquo;</span>',
      '</button>'
    ].join('');
  }

  function renderProducts(products, searchQuery) {
    var resultsCount = products.length;

    return [
      '<ul id="predictive-search-results" class="predictive-search__list" role="listbox" aria-labelledby="predictive-search">',
      products
        .map(function(product, index) {
          return renderProduct(normalizeProduct(product), index, resultsCount);
        })
        .join(''),
      '<li id="search-all" class="predictive-search-view-all" role="option" data-search-result>' +
        renderViewAll(searchQuery) +
        '</li>',
      '</ul>'
    ].join('');
  }

  function renderProduct(product, index, resultsCount) {
    return [
      '<li id="search-result-' +
        index +
        '" class="predictive-search-item" role="option" data-search-result>',
      '<a class="predictive-search-item__link" href="' +
        product.url +
        '" tabindex="-1">',
      '<div class="predictive-search__column predictive-search__column--image" data-image-with-placeholder-wrapper>',
      renderProductImage(product),
      '</div>',
      '<div class="predictive-search__column predictive-search__column--content ' +
        (getDetailsCount() ? '' : 'predictive-search__column--center') +
        '">',
      '<span class="predictive-search-item__title">',
      '<span class="predictive-search-item__title-text">' +
        product.title +
        '</span>',
      '</span>' + (getDetailsCount() ? renderProductDetails(product) : ''),
      '<span class="visually-hidden">, </span>',
      '<span class="visually-hidden">' +
        getNumberOfResultsString(index + 1, resultsCount) +
        '</span>',
      '</div>',
      '</a>',
      '</li>'
    ].join('');
  }

  function renderProductImage(product) {
    if (product.image === null) {
      return '';
    }

    return [
      '<div class="placeholder-background placeholder-background--animation" data-image-placeholder aria-hidden="true"></div>',
      '<img class="predictive-search-item__image lazyload" src="' +
        product.image.url +
        '" data-src="' +
        product.image.url +
        '" data-image alt="' +
        product.image.alt +
        '" />'
    ].join('');
  }

  function renderProductDetails(product) {
    return [
      '<dl class="predictive-search-item__details price' +
        (product.isOnSale ? ' price--on-sale' : '') +
        (!product.available ? ' price--sold-out' : '') +
        (!product.isPriceVaries && product.isCompareVaries
          ? ' price--compare-price-hidden'
          : '') +
        '">',
      '<div class="predictive-search-item__detail">',
      renderVendor(product),
      '</div>',
      '<div class="predictive-search-item__detail predictive-search-item__detail--inline">' +
        renderProductPrice(product),
      '</div>',
      '</dl>'
    ].join('');
  }
  function renderProductPrice(product) {
    if (!theme.settings.predictiveSearchShowPrice) {
      return '';
    }

    var accessibilityAnnounceComma = '<span class="visually-hidden">, </span>';

    var priceMarkup =
      '<div class="price__regular">' + renderPrice(product) + '</div>';

    var salePriceMarkup =
      '<div class="price__sale">' + renderSalePrice(product) + '</div>';

    return (
      accessibilityAnnounceComma +
      '<div class="price__pricing-group">' +
      (product.isOnSale ? salePriceMarkup : priceMarkup) +
      '</div>'
    );
  }

  function renderSalePrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.salePrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--sale">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>',
      '<div class="price__compare">' + renderCompareAtPrice(product) + '</div>'
    ].join('');
  }

  function renderCompareAtPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' +
        theme.strings.regularPrice +
        '</span> ',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price predictive-search-item__price--compare">' +
        product.compareAtPrice +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderPrice(product) {
    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.regularPrice + '</span>',
      '</dt>',
      '<dd>',
      '<span class="predictive-search-item__price">' +
        (product.isPriceVaries
          ? theme.strings.fromLowestPrice.replace('[price]', product.price)
          : product.price) +
        '</span>',
      '</dd>'
    ].join('');
  }

  function renderVendor(product) {
    if (!theme.settings.predictiveSearchShowVendor || product.vendor === '') {
      return '';
    }

    return [
      '<dt>',
      '<span class="visually-hidden">' + theme.strings.vendor + '</span>',
      '</dt>',
      '<dd class="predictive-search-item__vendor">' + product.vendor + '</dd>'
    ].join('');
  }

  function normalizeProduct(product) {
    var productOrVariant =
      product.variants.length > 0 ? product.variants[0] : product;

    return {
      url: productOrVariant.url,
      image: getProductImage(product),
      title: product.title,
      vendor: product.vendor || '',
      price: theme.Currency.formatMoney(product.price_min, theme.moneyFormat),
      compareAtPrice: theme.Currency.formatMoney(
        product.compare_at_price_min,
        theme.moneyFormat
      ),
      available: product.available,
      isOnSale: isOnSale(product),
      isPriceVaries: isPriceVaries(product),
      isCompareVaries: isCompareVaries(product)
    };
  }

  function getProductImage(product) {
    var image;
    var featuredImage;

    if (product.variants.length > 0 && product.variants[0].image !== null) {
      featuredImage = product.variants[0].featured_image;
    } else if (product.image) {
      featuredImage = product.featured_image;
    } else {
      image = null;
    }

    if (image !== null) {
      image = {
        url: theme.Images.getSizedImageUrl(featuredImage.url, '100x'),
        alt: featuredImage.alt
      };
    }

    return image;
  }

  function isOnSale(product) {
    return (
      product.compare_at_price_min !== null &&
      parseInt(product.compare_at_price_min, 10) >
        parseInt(product.price_min, 10)
    );
  }

  function isPriceVaries(product) {
    return product.price_max !== product.price_min;
  }

  function isCompareVaries(product) {
    return product.compare_at_price_max !== product.compare_at_price_min;
  }

  // Returns the number of optional product details to be shown,
  // values of the detailsList need to be boolean.
  function getDetailsCount() {
    var detailsList = [
      theme.settings.predictiveSearchShowPrice,
      theme.settings.predictiveSearchShowVendor
    ];

    var detailsCount = detailsList.reduce(function(acc, detail) {
      return acc + (detail ? 1 : 0);
    }, 0);

    return detailsCount;
  }

  function getNumberOfResultsString(resultNumber, resultsCount) {
    return theme.strings.number_of_results
      .replace('[result_number]', resultNumber)
      .replace('[results_count]', resultsCount);
  }

  function _htmlEscape(input) {
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  return function(data) {
    var products = data.products || [];
    var isLoading = data.isLoading;
    var searchQuery = data.searchQuery || '';

    if (isLoading && products.length === 0) {
      return loadingState();
    }

    return renderResults(products, isLoading, searchQuery);
  };
})();
// END DEPRICTATED SEARCH

window.theme = window.theme || {};

(function() {
  // (a11y) This function will be used by the Predictive Search Component
  // to announce the number of search results
  function numberOfResultsTemplateFct(data) {
    if (data.products.length === 1) {
      return theme.strings.one_result_found;
    } else {
      return theme.strings.number_of_results_found.replace(
        '[results_count]',
        data.products.length
      );
    }
  }

  // (a11y) This function will be used by the Predictive Search Component
  // to announce that it's loading results
  function loadingResultsMessageTemplateFct() {
    return theme.strings.loading;
  }

  function isPredictiveSearchSupported() {
    var shopifyFeatures = JSON.parse($('#shopify-features').text());

    return shopifyFeatures.predictiveSearch;
  }

  function isPredictiveSearchEnabled() {
    return window.theme.settings.predictiveSearchEnabled;
  }

  function canInitializePredictiveSearch() {
    return isPredictiveSearchSupported() && isPredictiveSearchEnabled();
  }

  // listen for search submits and validate query
  function validateSearchHandler(searchEl, submitEl) {
    submitEl.addEventListener(
      'click',
      validateSearchInput.bind(this, searchEl)
    );
  }

  // if there is nothing in the search field, prevent submit
  function validateSearchInput(searchEl, evt) {
    var isInputValueEmpty = searchEl.value.trim().length === 0;
    if (!isInputValueEmpty) {
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchEl.focus();
  }

  window.theme.SearchPage = (function() {
    var selectors = {
      searchReset: '[data-search-page-predictive-search-clear]',
      searchInput: '[data-search-page-predictive-search-input]',
      searchSubmit: '[data-search-page-predictive-search-submit]',
      searchResults: '[data-predictive-search-mount="default"]'
    };

    var componentInstance;
    var searchInput = document.querySelector(selectors.searchInput);
    var searchSubmit = document.querySelector(selectors.searchSubmit);

    function init(config) {
      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          reset: selectors.searchReset,
          result: selectors.searchResults
        },
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onOpen: function(nodes) {
          if (config.isTabletAndUp) {
            return;
          }

          var searchInputBoundingRect = $(
            selectors.searchInput
          )[0].getBoundingClientRect();
          var bodyHeight = $('body').height();
          var offset = 50;
          var resultsMaxHeight =
            bodyHeight - searchInputBoundingRect.bottom - offset;
          $(nodes.result).css({
            maxHeight: resultsMaxHeight
          });
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          $(nodes.result).css({
            maxHeight: ''
          });
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }
      componentInstance.destroy();
      componentInstance = null;
    }

    return {
      init: init,
      unload: unload
    };
  })();

  window.theme.SearchHeader = (function() {
    var selectors = {
      searchInput: '[data-predictive-search-drawer-input]',
      searchResults: '[data-predictive-search-mount="drawer"]',
      searchFormContainer: '[data-search-form-container]',
      searchSubmit: '[data-search-form-submit]'
    };

    var componentInstance;
    var searchInput = document.querySelector(selectors.searchInput);
    var searchSubmit = document.querySelector(selectors.searchSubmit);

    function init(config) {
      componentInstance = new window.Shopify.theme.PredictiveSearchComponent({
        selectors: {
          input: selectors.searchInput,
          result: selectors.searchResults
        },
        resultTemplateFct: window.theme.SearchResultsTemplate,
        numberOfResultsTemplateFct: numberOfResultsTemplateFct,
        numberOfResults: config.numberOfResults,
        loadingResultsMessageTemplateFct: loadingResultsMessageTemplateFct,
        onInputBlur: function() {
          return false;
        },
        onOpen: function(nodes) {
          var searchInputBoundingRect = $(
            searchInput
          )[0].getBoundingClientRect();

          // For tablet screens and up, stop the scroll area from extending past
          // the bottom of the screen because we're locking the body scroll
          var maxHeight =
            window.innerHeight -
            searchInputBoundingRect.bottom -
            (config.isTabletAndUp ? 20 : 0);

          $(nodes.result).css({
            top: config.isTabletAndUp ? '' : searchInputBoundingRect.bottom,
            maxHeight: maxHeight
          });
        },
        onClose: function(nodes) {
          $(nodes.result).css({
            maxHeight: ''
          });
        },
        onBeforeDestroy: function(nodes) {
          // If the viewport width changes from mobile to tablet
          // reset the top position of the results
          $(nodes.result).css({
            top: ''
          });
        }
      });

      validateSearchHandler(searchInput, searchSubmit);
    }

    function unload() {
      if (!componentInstance) {
        return;
      }

      componentInstance.destroy();
      componentInstance = null;
    }

    function clearAndClose() {
      if (!componentInstance) {
        return;
      }

      componentInstance.clearAndClose();
    }

    return {
      init: init,
      unload: unload,
      clearAndClose: clearAndClose
    };
  })();

  window.theme.Search = (function() {
    var classes = {
      searchTemplate: 'template-search'
    };
    var selectors = {
      siteHeader: '.site-header'
    };
    var mediaQueryList = {
      mobile: window.matchMedia('(max-width: 749px)'),
      tabletAndUp: window.matchMedia('(min-width: 750px)')
    };

    function init() {
      if (!$(selectors.siteHeader).length) {
        return;
      }

      if (!canInitializePredictiveSearch()) {
        return;
      }

      Object.keys(mediaQueryList).forEach(function(device) {
        mediaQueryList[device].addListener(initSearchAccordingToViewport);
      });

      initSearchAccordingToViewport();
    }

    function initSearchAccordingToViewport() {
      theme.SearchDrawer.close();
      theme.SearchHeader.unload();
      theme.SearchPage.unload();

      if (mediaQueryList.mobile.matches) {
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: false
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: false });
        }
      } else {
        // Tablet and up
        theme.SearchHeader.init({
          numberOfResults: 4,
          isTabletAndUp: true
        });

        if (isSearchPage()) {
          theme.SearchPage.init({ isTabletAndUp: true });
        }
      }
    }

    function isSearchPage() {
      return $('body').hasClass(classes.searchTemplate);
    }

    function unload() {
      theme.SearchHeader.unload();
      theme.SearchPage.unload();
    }

    return {
      init: init,
      unload: unload
    };
  })();
})();

window.theme = window.theme || {};

theme.SearchDrawer = (function() {
  var selectors = {
    headerSection: '[data-header-section]',
    drawer: '[data-predictive-search-drawer]',
    drawerOpenButton: '[data-predictive-search-open-drawer]',
    headerSearchInput: '[data-predictive-search-drawer-input]',
    predictiveSearchWrapper: '[data-predictive-search-mount="drawer"]'
  };

  var drawerInstance;

  function init() {
    setAccessibilityProps();

    drawerInstance = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: function() {
        setHeight();
        theme.MobileNav.closeMobileNav();
        lockBodyScroll();
      },
      onDrawerClose: function() {
        theme.SearchHeader.clearAndClose();
        $(selectors.drawerOpenButton).focus();
        unlockBodyScroll();
      },
      withPredictiveSearch: true,
      $elementToFocusOnOpen: $(selectors.headerSearchInput)
    });
  }

  function setAccessibilityProps() {
    $(selectors.drawerOpenButton)
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');
  }

  function setHeight() {
    $(selectors.drawer).css({
      height: $(selectors.headerSection).outerHeight()
    });
  }

  function close() {
    drawerInstance.close();
  }

  function lockBodyScroll() {
    // Disable scroll except on the predictive search container.
    window.bodyScrollLock.disableBodyScroll(
      document.querySelector(selectors.predictiveSearchWrapper),
      {
        allowTouchMove: function(element) {
          return (
            // If the touch event is in an element under the predictive search
            // we allow don't prevent default.
            $(element).parents(selectors.predictiveSearchWrapper).length === 1
          );
        }
      }
    );
  }

  function unlockBodyScroll() {
    window.bodyScrollLock.clearAllBodyScrollLocks();
  }

  return {
    init: init,
    close: close
  };
})();

theme.Disclosure = (function() {
  var selectors = {
    disclosureList: '[data-disclosure-list]',
    disclosureToggle: '[data-disclosure-toggle]',
    disclosureInput: '[data-disclosure-input]',
    disclosureOptions: '[data-disclosure-option]'
  };

  var classes = {
    listVisible: 'disclosure-list--visible'
  };

  function Disclosure($disclosure) {
    this.$container = $disclosure;
    this.cache = {};
    this._cacheSelectors();
    this._connectOptions();
    this._connectToggle();
    this._onFocusOut();
  }

  Disclosure.prototype = _.assignIn({}, Disclosure.prototype, {
    _cacheSelectors: function() {
      this.cache = {
        $disclosureList: this.$container.find(selectors.disclosureList),
        $disclosureToggle: this.$container.find(selectors.disclosureToggle),
        $disclosureInput: this.$container.find(selectors.disclosureInput),
        $disclosureOptions: this.$container.find(selectors.disclosureOptions)
      };
    },

    _connectToggle: function() {
      this.cache.$disclosureToggle.on(
        'click',
        function(evt) {
          var ariaExpanded =
            $(evt.currentTarget).attr('aria-expanded') === 'true';
          $(evt.currentTarget).attr('aria-expanded', !ariaExpanded);

          this.cache.$disclosureList.toggleClass(classes.listVisible);
        }.bind(this)
      );
    },

    _connectOptions: function() {
      this.cache.$disclosureOptions.on(
        'click',
        function(evt) {
          this._submitForm($(evt.currentTarget).data('value'));
        }.bind(this)
      );
    },

    _onFocusOut: function() {
      this.cache.$disclosureToggle.on(
        'focusout',
        function(evt) {
          var disclosureLostFocus =
            this.$container.has(evt.relatedTarget).length === 0;

          if (disclosureLostFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.cache.$disclosureList.on(
        'focusout',
        function(evt) {
          var childInFocus =
            $(evt.currentTarget).has(evt.relatedTarget).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !childInFocus) {
            this._hideList();
          }
        }.bind(this)
      );

      this.$container.on(
        'keyup',
        function(evt) {
          if (evt.which !== slate.utils.keyboardKeys.ESCAPE) return;
          this._hideList();
          this.cache.$disclosureToggle.focus();
        }.bind(this)
      );

      $('body').on(
        'click',
        function(evt) {
          var isOption = this.$container.has(evt.target).length > 0;
          var isVisible = this.cache.$disclosureList.hasClass(
            classes.listVisible
          );

          if (isVisible && !isOption) {
            this._hideList();
          }
        }.bind(this)
      );
    },

    _submitForm: function(value) {
      this.cache.$disclosureInput.val(value);
      this.$container.parents('form').submit();
    },

    _hideList: function() {
      this.cache.$disclosureList.removeClass(classes.listVisible);
      this.cache.$disclosureToggle.attr('aria-expanded', false);
    },

    unload: function() {
      this.cache.$disclosureOptions.off();
      this.cache.$disclosureToggle.off();
      this.cache.$disclosureList.off();
      this.$container.off();
    }
  });

  return Disclosure;
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading);
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginHeading = $(selectors.LoginHeading);

    // Show reset password form
    $('#RecoverPassword').on(
      'click',
      function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
        this.$RecoverHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    // Hide reset password form
    $('#HideRecoverPasswordLink').on(
      'click',
      function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
        this.$LoginHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    this.$RecoverHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });

    this.$LoginHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('hide');
    $('#CustomerLoginForm').addClass('hide');

    if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
      this.$RecoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess')
      .removeClass('hide')
      .focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');
    var $newAddressFormButton = $('#AddressNewButton');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      var isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';

      $newAddressForm.toggleClass('hide');
      $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      var $editButton = $('#EditFormButton_' + formId);
      var $editAddress = $('#EditAddress_' + formId);
      var isExpanded = $editButton.attr('aria-expanded') === 'true';

      $editAddress.toggleClass('hide');
      $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    cartCount: '[data-cart-count]',
    cartCountBubble: '[data-cart-count-bubble]',
    cartDiscount: '[data-cart-discount]',
    cartDiscountTitle: '[data-cart-discount-title]',
    cartDiscountAmount: '[data-cart-discount-amount]',
    cartDiscountWrapper: '[data-cart-discount-wrapper]',
    cartErrorMessage: '[data-cart-error-message]',
    cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
    cartItem: '[data-cart-item]',
    cartItemDetails: '[data-cart-item-details]',
    cartItemDiscount: '[data-cart-item-discount]',
    cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
    cartItemDiscountTitle: '[data-cart-item-discount-title]',
    cartItemDiscountAmount: '[data-cart-item-discount-amount]',
    cartItemDiscountList: '[data-cart-item-discount-list]',
    cartItemFinalPrice: '[data-cart-item-final-price]',
    cartItemImage: '[data-cart-item-image]',
    cartItemLinePrice: '[data-cart-item-line-price]',
    cartItemOriginalPrice: '[data-cart-item-original-price]',
    cartItemPrice: '[data-cart-item-price]',
    cartItemPriceList: '[data-cart-item-price-list]',
    cartItemProperty: '[data-cart-item-property]',
    cartItemPropertyName: '[data-cart-item-property-name]',
    cartItemPropertyValue: '[data-cart-item-property-value]',
    cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
    cartItemRegularPrice: '[data-cart-item-regular-price]',
    cartItemTitle: '[data-cart-item-title]',
    cartItemOption: '[data-cart-item-option]',
    cartLineItems: '[data-cart-line-items]',
    cartNote: '[data-cart-notes]',
    cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
    cartQuantityErrorMessageWrapper:
      '[data-cart-quantity-error-message-wrapper]',
    cartRemove: '[data-cart-remove]',
    cartStatus: '[data-cart-status]',
    cartSubtotal: '[data-cart-subtotal]',
    cartTableCell: '[data-cart-table-cell]',
    cartWrapper: '[data-cart-wrapper]',
    emptyPageContent: '[data-empty-page-content]',
    quantityInput: '[data-quantity-input]',
    quantityInputMobile: '[data-quantity-input-mobile]',
    quantityInputDesktop: '[data-quantity-input-desktop]',
    quantityLabelMobile: '[data-quantity-label-mobile]',
    quantityLabelDesktop: '[data-quantity-label-desktop]',
    inputQty: '[data-quantity-input]',
    thumbnails: '.cart__image',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    unitPriceGroup: '[data-unit-price-group]'
  };

  var classes = {
    cartNoCookies: 'cart--no-cookies',
    cartRemovedProduct: 'cart__removed-product',
    hide: 'hide',
    inputError: 'input--error'
  };

  var attributes = {
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item'
  };

  theme.breakpoints = theme.breakpoints || {};

  if (
    isNaN(theme.breakpoints.medium) ||
    theme.breakpoints.medium === undefined
  ) {
    theme.breakpoints.medium = 750;
  }

  var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

  function Cart(container) {
    this.$container = $(container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);
    this.ajaxEnabled = this.$container.data('ajax-enabled');

    if (!this.cookiesEnabled()) {
      this.$container.addClass(classes.cartNoCookies);
    }

    this.$thumbnails.css('cursor', 'pointer');
    this.$container.on(
      'click',
      selectors.thumbnails,
      this._handleThumbnailClick
    );

    this.$container.on(
      'change',
      selectors.inputQty,
      $.debounce(500, this._handleInputQty.bind(this))
    );

    this.mql = window.matchMedia(mediumUpQuery);
    this.mql.addListener(this.setQuantityFormControllers.bind(this));
    this.setQuantityFormControllers();

    if (this.ajaxEnabled) {
      /**
       * Because the entire cart is recreated when a cart item is updated,
       * we cannot cache the elements in the cart. Instead, we add the event
       * listeners on the cart's container to allow us to retain the event
       * listeners after rebuilding the cart when an item is updated.
       */

      this.$container.on(
        'change',
        selectors.cartNote,
        this._onNoteChange.bind(this)
      );

      this.$container.on(
        'click',
        selectors.cartRemove,
        this._onRemoveItem.bind(this)
      );

      this._setupCartTemplates();
    }
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    _setupCartTemplates: function() {
      this.$itemTemplate = $(selectors.cartItem, this.$container)
        .first()
        .clone();
      this.$itemDiscountTemplate = $(
        selectors.cartItemDiscount,
        this.$itemTemplate
      ).clone();
      this.$itemOptionTemplate = $(
        selectors.cartItemOption,
        this.$itemTemplate
      ).clone();
      this.$itemPropertyTemplate = $(
        selectors.cartItemProperty,
        this.$itemTemplate
      ).clone();
      this.$itemPriceListTemplate = $(
        selectors.cartItemPriceList,
        this.$itemTemplate
      ).clone();
      this.$itemLinePriceTemplate = $(
        selectors.cartItemLinePrice,
        this.$itemTemplate
      ).clone();
      this.$cartDiscountTemplate = $(
        selectors.cartDiscount,
        this.$container
      ).clone();
    },

    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var itemIndex = $input.data('quantity-item');
      var $itemElement = $input.closest(selectors.cartItem);
      var $itemQtyInputs = $('[data-quantity-item=' + itemIndex + ']');
      var value = parseInt($input.val());
      var isValidValue = !(value < 0 || isNaN(value));
      $itemQtyInputs.val(value);

      this._hideCartError();
      this._hideQuantityErrorMessage();

      if (!isValidValue) {
        this._showQuantityErrorMessages($itemElement);
        return;
      }

      if (isValidValue && this.ajaxEnabled) {
        this._updateItemQuantity(
          itemIndex,
          $itemElement,
          $itemQtyInputs,
          value
        );
      }
    },

    _updateItemQuantity: function(
      itemIndex,
      $itemElement,
      $itemQtyInputs,
      value
    ) {
      var key = $itemElement.attr(attributes.cartItemKey);
      var index = $itemElement.attr(attributes.cartItemIndex);

      var params = {
        url: '/cart/change.js',
        data: { quantity: value, line: index },
        dataType: 'json'
      };

      $.post(params)
        .done(
          function(state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);

              if (value === 0) {
                this._showRemoveMessage($itemElement.clone());
              } else {
                var $lineItem = $('[data-cart-item-key="' + key + '"]');
                var item = this.getItem(key, state);

                $(selectors.quantityInput, $lineItem).focus();
                this._updateLiveRegion(item);
              }
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function() {
            this._showCartError($itemQtyInputs);
          }.bind(this)
        );
    },

    getItem: function(key, state) {
      return state.items.find(function(item) {
        return item.key === key;
      });
    },

    _liveRegionText: function(item) {
      // Dummy content for live region
      var liveRegionText =
        theme.strings.update +
        ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';

      // Update Quantity
      liveRegionText = liveRegionText
        .replace('[QuantityLabel]', theme.strings.quantity)
        .replace('[Quantity]', item.quantity);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        item.original_line_price,
        theme.moneyFormat
      );
      var discountLabel = '';
      var discountPrice = '';
      var discountInformation = '';

      if (item.original_line_price > item.final_line_price) {
        regularLabel = theme.strings.regularTotal;

        discountLabel = theme.strings.discountedTotal;
        discountPrice = theme.Currency.formatMoney(
          item.final_line_price,
          theme.moneyFormat
        );

        discountInformation = theme.strings.priceColumn;
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[DiscountedPrice]', discountLabel)
        .replace('[$]', discountPrice)
        .replace('[PriceInformation]', discountInformation)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(item) {
      var $liveRegion = $(selectors.cartStatus);
      $liveRegion.html(this._liveRegionText(item)).attr('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        $liveRegion.attr('aria-hidden', true);
      }, 1000);
    },

    _createCart: function(state) {
      var cartDiscountList = this._createCartDiscountList(state);

      $(selectors.cartLineItems, this.$container).html(
        this._createLineItemList(state)
      );

      this.setQuantityFormControllers();

      $(selectors.cartNote, this.$container).val(state.note);

      if (cartDiscountList.length === 0) {
        $(selectors.cartDiscountWrapper, this.$container)
          .html('')
          .addClass(classes.hide);
      } else {
        $(selectors.cartDiscountWrapper, this.$container)
          .html(cartDiscountList)
          .removeClass(classes.hide);
      }

      $(selectors.cartSubtotal, this.$container).html(
        theme.Currency.formatMoney(
          state.total_price,
          theme.moneyFormatWithCurrency
        )
      );
    },

    _createCartDiscountList: function(cart) {
      return $.map(
        cart.cart_level_discount_applications,
        function(discount) {
          var $discount = this.$cartDiscountTemplate.clone();
          $discount.find(selectors.cartDiscountTitle).text(discount.title);
          $discount
            .find(selectors.cartDiscountAmount)
            .html(
              theme.Currency.formatMoney(
                discount.total_allocated_amount,
                theme.moneyFormat
              )
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _createLineItemList: function(state) {
      return $.map(
        state.items,
        function(item, index) {
          var $item = this.$itemTemplate.clone();
          var $itemPriceList = this.$itemPriceListTemplate.clone();

          this._setLineItemAttributes($item, item, index);
          this._setLineItemImage($item, item.featured_image);

          $(selectors.cartItemTitle, $item)
            .text(item.product_title)
            .attr('href', item.url);

          var productDetailsList = this._createProductDetailsList(
            item.product_has_only_default_variant,
            item.options_with_values,
            item.properties
          );
          this._setProductDetailsList($item, productDetailsList);

          this._setItemRemove($item, item.title);

          $itemPriceList.html(
            this._createItemPrice(
              item.original_price,
              item.final_price,
              this.$itemPriceListTemplate
            )
          );

          if (item.unit_price_measurement) {
            $itemPriceList.append(
              this._createUnitPrice(
                item.unit_price,
                item.unit_price_measurement,
                this.$itemPriceListTemplate
              )
            );
          }

          this._setItemPrice($item, $itemPriceList);

          var itemDiscountList = this._createItemDiscountList(item);
          this._setItemDiscountList($item, itemDiscountList);

          this._setQuantityInputs($item, item, index);

          var itemLinePrice = this._createItemPrice(
            item.original_line_price,
            item.final_line_price,
            this.$itemLinePriceTemplate
          );
          this._setItemLinePrice($item, itemLinePrice);

          return $item[0];
        }.bind(this)
      );
    },

    _setLineItemAttributes: function($item, item, index) {
      $item
        .attr(attributes.cartItemKey, item.key)
        .attr(attributes.cartItemUrl, item.url)
        .attr(attributes.cartItemTitle, item.title)
        .attr(attributes.cartItemIndex, index + 1)
        .attr(attributes.cartItemQuantity, item.quantity);
    },

    _setLineItemImage: function($item, featuredImage) {
      var $image = $(selectors.cartItemImage, $item);

      var sizedImageUrl =
        featuredImage.url !== null
          ? theme.Images.getSizedImageUrl(featuredImage.url, 'x190')
          : null;

      if (sizedImageUrl) {
        $image
          .attr('alt', featuredImage.alt)
          .attr('src', sizedImageUrl)
          .removeClass(classes.hide);
      } else {
        $image.remove();
      }
    },

    _setProductDetailsList: function($item, productDetailsList) {
      var $itemDetails = $(selectors.cartItemDetails, $item);

      if (productDetailsList.length === 0) {
        $itemDetails.addClass(classes.hide).text('');
      } else {
        $itemDetails.removeClass(classes.hide).html(productDetailsList);
      }
    },

    _setItemPrice: function($item, price) {
      $(selectors.cartItemPrice, $item).html(price);
    },

    _setItemDiscountList: function($item, discountList) {
      var $itemDiscountList = $(selectors.cartItemDiscountList, $item);

      if (discountList.length === 0) {
        $itemDiscountList.html('').addClass(classes.hide);
      } else {
        $itemDiscountList.html(discountList).removeClass(classes.hide);
      }
    },

    _setItemRemove: function($item, title) {
      $(selectors.cartRemove, $item).attr(
        'aria-label',
        theme.strings.removeLabel.replace('[product]', title)
      );
    },

    _setQuantityInputs: function($item, item, index) {
      $(selectors.quantityInputMobile, $item)
        .attr('id', 'updates_' + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityInputDesktop, $item)
        .attr('id', 'updates_large_' + item.key)
        .attr(attributes.quantityItem, index + 1)
        .val(item.quantity);

      $(selectors.quantityLabelMobile, $item).attr(
        'for',
        'updates_' + item.key
      );

      $(selectors.quantityLabelDesktop, $item).attr(
        'for',
        'updates_large_' + item.key
      );
    },

    setQuantityFormControllers: function() {
      if (this.mql.matches) {
        $(selectors.quantityInputDesktop).attr('name', 'updates[]');
        $(selectors.quantityInputMobile).removeAttr('name');
      } else {
        $(selectors.quantityInputMobile).attr('name', 'updates[]');
        $(selectors.quantityInputDesktop).removeAttr('name');
      }
    },

    _setItemLinePrice: function($item, price) {
      $(selectors.cartItemLinePrice, $item).html(price);
    },

    _createProductDetailsList: function(
      product_has_only_default_variant,
      options,
      properties
    ) {
      var optionsPropertiesHTML = [];

      if (!product_has_only_default_variant) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getOptionList(options)
        );
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        optionsPropertiesHTML = optionsPropertiesHTML.concat(
          this._getPropertyList(properties)
        );
      }

      return optionsPropertiesHTML;
    },

    _getOptionList: function(options) {
      return $.map(
        options,
        function(option) {
          var $optionElement = this.$itemOptionTemplate.clone();

          $optionElement
            .text(option.name + ': ' + option.value)
            .removeClass(classes.hide);

          return $optionElement[0];
        }.bind(this)
      );
    },

    _getPropertyList: function(properties) {
      var propertiesArray =
        properties !== null ? Object.entries(properties) : [];

      return $.map(
        propertiesArray,
        function(property) {
          var $propertyElement = this.$itemPropertyTemplate.clone();

          // Line item properties prefixed with an underscore are not to be displayed
          if (property[0].charAt(0) === '_') return;

          // if the property value has a length of 0 (empty), don't display it
          if (property[1].length === 0) return;

          $propertyElement
            .find(selectors.cartItemPropertyName)
            .text(property[0]);

          if (property[0].indexOf('/uploads/') === -1) {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .text(': ' + property[1]);
          } else {
            $propertyElement
              .find(selectors.cartItemPropertyValue)
              .html(
                ': <a href="' +
                  property[1] +
                  '"> ' +
                  property[1].split('/').pop() +
                  '</a>'
              );
          }

          $propertyElement.removeClass(classes.hide);

          return $propertyElement[0];
        }.bind(this)
      );
    },

    _createItemPrice: function(original_price, final_price, $priceTemplate) {
      if (original_price !== final_price) {
        var $discountedPrice = $(
          selectors.cartItemDiscountedPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemOriginalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );
        $(selectors.cartItemFinalPrice, $discountedPrice).html(
          theme.Currency.formatMoney(final_price, theme.moneyFormat)
        );
        $discountedPrice.removeClass(classes.hide);

        return $discountedPrice[0];
      } else {
        var $regularPrice = $(
          selectors.cartItemRegularPriceGroup,
          $priceTemplate
        ).clone();

        $(selectors.cartItemRegularPrice, $regularPrice).html(
          theme.Currency.formatMoney(original_price, theme.moneyFormat)
        );

        $regularPrice.removeClass(classes.hide);

        return $regularPrice[0];
      }
    },

    _createUnitPrice: function(
      unitPrice,
      unitPriceMeasurement,
      $itemPriceGroup
    ) {
      var $unitPriceGroup = $(
        selectors.unitPriceGroup,
        $itemPriceGroup
      ).clone();

      var unitPriceBaseUnit =
        (unitPriceMeasurement.reference_value !== 1
          ? unitPriceMeasurement.reference_value
          : '') + unitPriceMeasurement.reference_unit;

      $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit);
      $(selectors.unitPrice, $unitPriceGroup).html(
        theme.Currency.formatMoney(unitPrice, theme.moneyFormat)
      );

      $unitPriceGroup.removeClass(classes.hide);

      return $unitPriceGroup[0];
    },

    _createItemDiscountList: function(item) {
      return $.map(
        item.line_level_discount_allocations,
        function(discount) {
          var $discount = this.$itemDiscountTemplate.clone();
          $discount
            .find(selectors.cartItemDiscountTitle)
            .text(discount.discount_application.title);
          $discount
            .find(selectors.cartItemDiscountAmount)
            .html(
              theme.Currency.formatMoney(discount.amount, theme.moneyFormat)
            );
          return $discount[0];
        }.bind(this)
      );
    },

    _showQuantityErrorMessages: function(itemElement) {
      $(selectors.cartQuantityErrorMessage, itemElement).text(
        theme.strings.quantityMinimumMessage
      );

      $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
        classes.hide
      );

      $(selectors.inputQty, itemElement)
        .addClass(classes.inputError)
        .focus();
    },

    _hideQuantityErrorMessage: function() {
      var $errorMessages = $(
        selectors.cartQuantityErrorMessageWrapper
      ).addClass(classes.hide);

      $(selectors.cartQuantityErrorMessage, $errorMessages).text('');

      $(selectors.inputQty, this.$container).removeClass(classes.inputError);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target)
        .closest(selectors.cartItem)
        .data('cart-item-url');

      window.location.href = url;
    },

    _onNoteChange: function(evt) {
      var note = evt.currentTarget.value;
      this._hideCartError();
      this._hideQuantityErrorMessage();

      var params = {
        url: '/cart/update.js',
        data: { note: note },
        dataType: 'json'
      };

      $.post(params).fail(
        function() {
          this._showCartError(evt.currentTarget);
        }.bind(this)
      );
    },

    _showCartError: function(elementToFocus) {
      $(selectors.cartErrorMessage).text(theme.strings.cartError);

      $(selectors.cartErrorMessageWrapper).removeClass(classes.hide);

      elementToFocus.focus();
    },

    _hideCartError: function() {
      $(selectors.cartErrorMessageWrapper).addClass(classes.hide);
      $(selectors.cartErrorMessage).text('');
    },

    _onRemoveItem: function(evt) {
      evt.preventDefault();
      var $remove = $(evt.target);
      var $lineItem = $remove.closest(selectors.cartItem);
      var index = $lineItem.attr(attributes.cartItemIndex);
      this._hideCartError();

      var params = {
        url: '/cart/change.js',
        data: { quantity: 0, line: index },
        dataType: 'json'
      };

      $.post(params)
        .done(
          function(state) {
            if (state.item_count === 0) {
              this._emptyCart();
            } else {
              this._createCart(state);
              this._showRemoveMessage($lineItem.clone());
            }

            this._setCartCountBubble(state.item_count);
          }.bind(this)
        )
        .fail(
          function() {
            this._showCartError(null);
          }.bind(this)
        );
    },

    _showRemoveMessage: function(lineItem) {
      var index = lineItem.data('cart-item-index');
      var removeMessage = this._getRemoveMessage(lineItem);
      var $lineItemAtIndex;

      if (index - 1 === 0) {
        $lineItemAtIndex = $('[data-cart-item-index="1"]', this.$container);
        $(removeMessage).insertBefore($lineItemAtIndex);
      } else {
        $lineItemAtIndex = $(
          '[data-cart-item-index="' + (index - 1) + '"]',
          this.$container
        );
        removeMessage.insertAfter($lineItemAtIndex);
      }
      removeMessage.focus();
    },

    _getRemoveMessage: function(lineItem) {
      var formattedMessage = this._formatRemoveMessage(lineItem);

      var $tableCell = $(selectors.cartTableCell, lineItem).clone();
      $tableCell
        .removeClass()
        .addClass(classes.cartRemovedProduct)
        .attr('colspan', '4')
        .html(formattedMessage);

      lineItem
        .attr('role', 'alert')
        .html($tableCell)
        .attr('tabindex', '-1');

      return lineItem;
    },

    _formatRemoveMessage: function(lineItem) {
      var quantity = lineItem.data('cart-item-quantity');
      var url = lineItem.attr(attributes.cartItemUrl);
      var title = lineItem.attr(attributes.cartItemTitle);

      return theme.strings.removedItemMessage
        .replace('[quantity]', quantity)
        .replace(
          '[link]',
          '<a ' +
            'href="' +
            url +
            '" class="text-link text-link--accent">' +
            title +
            '</a>'
        );
    },

    _setCartCountBubble: function(quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(selectors.cartCount);

      if (quantity > 0) {
        this.$cartCountBubble.removeClass(classes.hide);
        this.$cartCount.html(quantity);
      } else {
        this.$cartCountBubble.addClass(classes.hide);
        this.$cartCount.html('');
      }
    },

    _emptyCart: function() {
      this.$emptyPageContent =
        this.$emptyPageContent ||
        $(selectors.emptyPageContent, this.$container);
      this.$cartWrapper =
        this.$cartWrapper || $(selectors.cartWrapper, this.$container);

      this.$emptyPageContent.removeClass(classes.hide);
      this.$cartWrapper.addClass(classes.hide);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy'
  };

  var data = {
    sortBy: 'data-default-sortby'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this._initBreakpoints();
    this._initParams();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          slate.utils.resizeSelects(self.$selects);
        }
      });
    },

    _initParams: function() {
      self.queryParams = {};
      if (location.search.length) {
        var aKeyValue;
        var aCouples = location.search.substr(1).split('&');
        for (var i = 0; i < aCouples.length; i++) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            self.queryParams[
              decodeURIComponent(aKeyValue[0])
            ] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }
    },

    _onSortChange: function() {
      self.queryParams.sort_by = this._getSortValue();

      if (self.queryParams.page) {
        delete self.queryParams.page;
      }
      window.location.search = decodeURIComponent($.param(self.queryParams));
    },

    _onFilterChange: function() {
      document.location.href = this._getFilterValue();
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.$sortSelect.attr(data.sortBy);
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.SearchDrawer.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
      theme.Search.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();



function validateRequiredFields($form) {
  let allFieldsValid = true;
  const requiredFields = $form.find('[data-required="true"]');
  const errorMessageContainer = $('#add-to-cart-error');

  requiredFields.each(function() {
    const field = $(this);

    // Check if the field is a checkbox that isn't checked or an empty input field
    if ((field.is(':checkbox') && !field.is(':checked')) || (!field.is(':checkbox') && (!field.val() || field.val().trim() === ""))) {
      field.addClass('input--error'); // Add error class for styling
      allFieldsValid = false;
    } else {
      field.removeClass('input--error'); // Remove error class if valid
    }
  });

  // Display or hide the error message based on validation result
  if (!allFieldsValid) {
    errorMessageContainer.css('display', 'block');
  } else {
    errorMessageContainer.css('display', 'none');
  }

  return allFieldsValid;
}



// ADD TO CART NOTIFICATION


/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.ajaxEnabled = $container.data('ajax-enabled');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      cartCount: '[data-cart-count]',
      cartCountBubble: '[data-cart-count-bubble]',
      cartPopup: '[data-cart-popup]',
      cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
      cartPopupClose: '[data-cart-popup-close]',
      cartPopupDismiss: '[data-cart-popup-dismiss]',
      cartPopupImage: '[data-cart-popup-image]',
      cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
      cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
      cartPopupPlaceholderSize: '[data-placeholder-size]',
      cartPopupProductDetails: '[data-cart-popup-product-details]',
      cartPopupQuantity: '[data-cart-popup-quantity]',
      cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
      cartPopupTitle: '[data-cart-popup-title]',
      cartPopupWrapper: '[data-cart-popup-wrapper]',
      loader: '[data-loader]',
      loaderStatus: '[data-loader-status]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      imageZoomWrapper: '[data-image-zoom-wrapper]',
      productMediaWrapper: '[data-product-single-media-wrapper]',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      productMediaTypeVideo: '[data-product-media-type-video]',
      productMediaTypeModel: '[data-product-media-type-model]',
      backInStockBlocks: '[data-back-in-stock-block]',
      backInStockSelectedVariant: '[data-back-in-stock-selected-variant]',
      backInStockSelectedVariantRow: '[data-back-in-stock-selected-variant-row]',
      backInStockTags: '[data-back-in-stock-tags]',
      buyButtons: '[data-product-buy-buttons]',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]',
      productPolicies: '[data-product-policies]'
    };

    this.classes = {
      cartPopupWrapperHidden: 'cart-popup-wrapper--hidden', // NOTIFICATION
      hidden: 'hide',
      visibilityHidden: 'visibility-hidden',
      inputError: 'input--error',
      jsZoomEnabled: 'js-zoom-enabled',
      productOnSale: 'price--on-sale',
      productUnitAvailable: 'price--unit-available',
      productUnavailable: 'price--unavailable',
      productSoldOut: 'price--sold-out',
      cartImage: 'cart-popup-item__image',
      productFormErrorMessageWrapperHidden:
        'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb',
      variantSoldOut: 'product-form--variant-sold-out'
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );
    this.$addToCart = $(this.selectors.addToCart, $container);
    this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
    this.$shopifyPaymentButton = $(
      this.selectors.shopifyPaymentButton,
      $container
    );
    this.$productPolicies = $(this.selectors.productPolicies, $container);

    this.$loader = $(this.selectors.loader, this.$addToCart);
    this.$loaderStatus = $(this.selectors.loaderStatus, $container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.imageZoomWrapper).hasClass(
      this.classes.jsZoomEnabled
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initMediaSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
    this._initProductVideo();
    this._initModelViewerLibraries();
    this._initShopifyXrLaunch();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than four thumbnails
          if ($(self.selectors.productThumbImages).length > 4) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.imageZoomWrapper).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateMedia.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initMediaSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var mediaId = $el.data('thumbnail-id');

          self._switchMedia(mediaId);
          self._setActiveThumbnail(mediaId);
        })
        .on('keyup', self._handleMediaFocus.bind(self));
    },

_initAddToCart: function() {
  const self = this;

  $(this.selectors.productForm, this.$container).on('submit', function(evt) {
    evt.preventDefault(); // Always prevent default to control behavior here

    const submitter = evt.originalEvent && evt.originalEvent.submitter
      ? evt.originalEvent.submitter
      : document.activeElement;
    self._useSkyrocketDrawer = !!(submitter && submitter.hasAttribute('data-skyrocket-cart-open-on-submit'));

    if (self.$addToCart.is('[aria-disabled]')) {
      return; // Stop if the Add to Cart button is disabled
    }

    // Run custom validation
    const allFieldsValid = validateRequiredFields($(this));

    // If validation fails, stop form submission and show the error message
    if (!allFieldsValid) {
      return; // Exit the function early if fields are invalid
    }

    // If AJAX is not enabled, submit the form normally
    if (!self.ajaxEnabled) {
      const addOnItems = self._getProductAddOnItems();
      if (addOnItems.length) {
        self._addCrossSellItems(addOnItems).always(function() {
          this.submit();
        }.bind(this));
        return;
      }
      this.submit(); // Allow regular form submission
      return;
    }

    // Proceed with AJAX if all checks pass
    self.$previouslyFocusedElement = $(':focus');

    const isInvalidQuantity = self.$quantityInput.val() <= 0;
    if (isInvalidQuantity) {
      self._showErrorMessage(theme.strings.quantityMinimumMessage);
      return;
    }

    // Handle button loading state and add item via AJAX
    self._handleButtonLoadingState(true);
    const $data = $(self.selectors.productForm, self.$container);
    self._addItemToCart($data);
  });
},



    _initProductVideo: function() {
      var sectionId = this.settings.sectionId;

      $(this.selectors.productMediaTypeVideo, this.$container).each(function() {
        var $el = $(this);
        theme.ProductVideo.init($el, sectionId);
      });
    },

    _initModelViewerLibraries: function() {
      var $modelViewerElements = $(
        this.selectors.productMediaTypeModel,
        this.$container
      );
      if ($modelViewerElements.length < 1) return;
      theme.ProductModel.init($modelViewerElements, this.settings.sectionId);
    },

    _initShopifyXrLaunch: function() {
      var self = this;
      $(document).on('shopify_xr_launch', function() {
        var $currentMedia = $(
          self.selectors.productMediaWrapper +
            ':not(.' +
            self.classes.hidden +
            ')',
          self.$container
        );
        $currentMedia.trigger('xrLaunch');
      });
    },

    _getCrossSellItems: function() {
      var $checked = this.$container.find('.cross-sell-bundle__checkbox:checked');
      if ($checked.length === 0) {
        return [];
      }

      var $bundle = this.$container.find('.js-cross-sell-bundle').first();
      var currentProductId = $bundle.length ? String($bundle.data('current-product-id')) : null;
      var items = [];
      var seen = {};

      $checked.each(function() {
        var $checkbox = $(this);
        var $bundle = $checkbox.closest('.js-cross-sell-bundle');
        if ($bundle.hasClass('cross-sell-bundle--hidden')) {
          return;
        }
        var variantId = parseInt($checkbox.data('variant-id'), 10);
        if (!variantId) {
          return;
        }

        var productId = $checkbox.data('product-id');
        if (currentProductId && productId && String(productId) === currentProductId) {
          return;
        }

        if (!seen[variantId]) {
          seen[variantId] = true;
          items.push({ id: variantId, quantity: 1 });
        }
      });

      return items;
    },



    _getOneClickUpsellItems: function() {
      var items = [];

      this.$container.find('[data-product-oneclick-upsell]').each(function() {
        var $card = $(this);
        if (!$card.length || $card.attr('data-available') !== 'true') {
          return;
        }

        var quantity = 1;
        if ($card.attr('data-control-type') === 'quantity') {
          quantity = parseInt($card.find('[data-product-oneclick-qty]').val(), 10);
        } else if (!$card.find('[data-product-oneclick-toggle]').is(':checked')) {
          return;
        }

        if (!quantity || quantity < 1) {
          return;
        }

        var variantId = parseInt($card.attr('data-variant-id'), 10);
        if (!variantId) {
          return;
        }

        items.push({
          id: variantId,
          quantity: quantity,
          properties: {
            _skyrocket_product_page_upsell: 'true'
          }
        });
      });

      return items;
    },

    _getProductRecommendationItems: function() {
      var items = [];

      this.$container.find('[data-product-recommendation-item][data-mode="staged"].is-selected').each(function() {
        var $card = $(this);
        if (!$card.length || $card.attr('data-available') !== 'true') {
          return;
        }

        var variantId = parseInt($card.attr('data-variant-id'), 10);
        if (!variantId) {
          return;
        }

        var quantity = parseInt($card.find('[data-product-recommendation-qty]').val(), 10);
        quantity = isNaN(quantity) || quantity < 1 ? 1 : quantity;

        items.push({
          id: variantId,
          quantity: quantity,
          properties: {
            _skyrocket_product_recommendation: 'true'
          }
        });
      });

      return items;
    },

    _getProductAddOnItems: function() {
      var items = this._getCrossSellItems().concat(this._getOneClickUpsellItems(), this._getProductRecommendationItems());
      var seen = {};
      return items.filter(function(item) {
        var key = String(item.id) + ':' + JSON.stringify(item.properties || {});
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    },

    _addCrossSellItems: function(items) {
      if (!items || !items.length) {
        return $.Deferred().resolve().promise();
      }

      return $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ items: items })
      });
    },

    _addItemToCart: function(data) {
      var params = {
        url: '/cart/add.js',
        data: $(data).serialize(),
        dataType: 'json'
        
      };
     
// ADD TO CART NOTIFICATION
      $.post(params)
        .done(
          function(item) {
            var addOnItems = this._getProductAddOnItems();
            var finalize = function() {
              this._hideErrorMessage();
              this._setupCartPopup(item);
              setTimeout(() => this._handleButtonLoadingState(false), 200);
            }.bind(this);

            if (!addOnItems.length) {
              finalize();
              return;
            }

            this._addCrossSellItems(addOnItems)
              .fail(function() {
                console.warn('Product add-on add failed.');
              })
              .always(finalize);
          }.bind(this)
        )
        .fail(
          function(response) {
            this.$previouslyFocusedElement.focus();
            var errorMessage = response.responseJSON
              ? response.responseJSON.description
              : theme.strings.cartError;
            this._showErrorMessage(errorMessage);
            this._handleButtonLoadingState(false);
          }.bind(this)
        );
    },

    _handleButtonLoadingState: function(isLoading) {
      if (isLoading) {
        this.$addToCart.attr('aria-disabled', true);
        this.$addToCartText.addClass(this.classes.hidden);
        this.$loader.removeClass(this.classes.hidden);
        this.$shopifyPaymentButton.attr('disabled', true);
        this.$loaderStatus.attr('aria-hidden', false);
      } else {
        this.$addToCart.removeAttr('aria-disabled');
        this.$addToCartText.removeClass(this.classes.hidden);
        this.$loader.addClass(this.classes.hidden);
        this.$shopifyPaymentButton.removeAttr('disabled');
        this.$loaderStatus.attr('aria-hidden', true);
      }
    },

    _showErrorMessage: function(errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
        .removeClass(this.classes.productFormErrorMessageWrapperHidden)
        .attr('aria-hidden', true)
        .removeAttr('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },
    
_setupCartPopup: function(item) {
  var cartDrawerApi = window.SkyrocketCartDrawer || window.SkyrocketCartDrawer || window.cartDrawer;
  var useSkyrocketDrawer =
    cartDrawerApi &&
    typeof cartDrawerApi.openAndRefresh === 'function';
  this._useSkyrocketDrawer = false;

  $.ajax({
    type: 'GET', 
    url: '/cart',
    dataType: 'html',
    success: function(cart_html) {
      var cartdrawer_content = $(cart_html).find('.cart-value').html();
      $('.cart-value').html(cartdrawer_content);

      var cart_count = $(cart_html).find('#CartCount').html();
      $('#CartCount').html(cart_count);

      var cartCount = $(cart_html).find('.cart-value .drawer__title').attr('data-count');
      console.log(cartCount);
      
      if(cartCount == 0){
        $('#CartCount').addClass('hide');
      } else {
        $('#CartCount').removeClass('hide');
      }

      if (useSkyrocketDrawer) {
        cartDrawerApi.openAndRefresh();
        return;
      }

      // Custom code to open the cart drawer with your styles and animation:
      const cartDrawer = document.getElementById('cartDrawer');
      const cartContent = document.getElementById('cartContent');
      const cartShadow = document.getElementById('cartShadow');
      const cartClosebtn = document.getElementById('cartDrawerCloseButton');

      // Set the drawer size based on screen width
      if (typeof adjustCartDrawerSize === 'function') {
        adjustCartDrawerSize();
      }

      // Mark drawer as open (if you have a global state variable, update it)
      isCartDrawerOpen = true;

      // Show the shadow/overlay
      if (cartShadow) {
        cartShadow.style.visibility = "visible";
        cartShadow.style.opacity = "1";
      }

      document.documentElement.classList.add('js-drawer-open');

      // Wait until the drawer is open before showing content
      setTimeout(() => {
        if (cartContent) {
          cartContent.style.opacity = "1";
        }
        if (cartClosebtn) {
          cartClosebtn.style.opacity = "1";
        }
      }, 300); // Matches the drawer's width transition
      
      // Ensure the cart drawer is shown
      $('.cart-drawer').addClass('open_cartdrawer');

      
      if (document.getElementById("accept_terms")) {
        initializeAcceptTerms();
      }

      if (document.getElementById('cartReservedTimer')) {
        initializeCartTimer();
      }
    }
  });

  const cartCountEl = document.querySelector('span[data-cart-count]');
  if (cartCountEl) {
    const count = parseInt(cartCountEl.innerHTML);
    if (!isNaN(count)) {
      cartCountEl.innerHTML = count + 1;
    }
  }
},

    
    
    

    _updateCartPopupContent: function(item) {
      var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

      this.$cartPopupTitle.text(item.product_title);
      this.$cartPopupQuantity.text(quantity);
      this.$cartPopupQuantityLabel.text(
        theme.strings.quantityLabel.replace('[count]', quantity)
      );

      this._setCartPopupPlaceholder(
        item.featured_image.url,
        item.featured_image.aspect_ratio
      );
      this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
      this._setCartPopupProductDetails(
        item.product_has_only_default_variant,
        item.options_with_values,
        item.properties
      );

      $.getJSON('/cart.js').then(
        function(cart) {
          this._setCartQuantity(cart.item_count);
          this._setCartCountBubble(cart.item_count);
          this._showCartPopup();
        }.bind(this)
      );
    },

    _setupCartPopupEventListeners: function() {
      this.$cartPopupWrapper.on(
        'keyup',
        function(event) {
          if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
            this._hideCartPopup(event);
          }
        }.bind(this)
      );

      this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
      this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
      $('body').on('click', this._onBodyClick.bind(this));
    },

    _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
      this.$cartPopupImageWrapper =
        this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

      if (imageUrl === null) {
        this.$cartPopupImageWrapper.addClass(this.classes.hidden);
        return;
      }

      var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
      var maxWidth = 95 * imageAspectRatio;
      var heightRatio = 100 / imageAspectRatio;

      this.$cartPopupImagePlaceholder.css('max-width', maxWidth);

      $placeholder.css('padding-top', heightRatio + '%');
    },

    _setCartPopupImage: function(imageUrl, imageAlt) {
      if (imageUrl === null) return;

      this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
      var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '600x');
      var image = document.createElement('img');
      image.src = sizedImageUrl;
      image.alt = imageAlt;
      image.classList.add(this.classes.cartImage);
      image.dataset.cartPopupImage = '';

      image.onload = function() {
        this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
        this.$cartPopupImageWrapper.append(image);
      }.bind(this);
    },

    _setCartPopupProductDetails: function(
      product_has_only_default_variant,
      options,
      properties
    ) {
      this.$cartPopupProductDetails =
        this.$cartPopupProductDetails ||
        $(this.selectors.cartPopupProductDetails);
      var variantPropertiesHTML = '';

      if (!product_has_only_default_variant) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getVariantOptionList(options);
      }

      if (properties !== null && Object.keys(properties).length !== 0) {
        variantPropertiesHTML =
          variantPropertiesHTML + this._getPropertyList(properties);
      }

      if (variantPropertiesHTML.length === 0) {
        this.$cartPopupProductDetails.html('');
        this.$cartPopupProductDetails.attr('hidden', '');
      } else {
        this.$cartPopupProductDetails.html(variantPropertiesHTML);
        this.$cartPopupProductDetails.removeAttr('hidden');
      }
    },

    _getVariantOptionList: function(variantOptions) {
      var variantOptionListHTML = '';

      variantOptions.forEach(function(variantOption) {
        variantOptionListHTML =
          variantOptionListHTML +
          '<li class="product-details__item product-details__item--variant-option">' +
          variantOption.name +
          ': ' +
          variantOption.value.split(' - ')[0] +
          '</li>';
      });

      return variantOptionListHTML;
    },

    _getPropertyList: function(properties) {
      var propertyListHTML = '';
      var propertiesArray = Object.entries(properties);

      propertiesArray.forEach(function(property) {
        // Line item properties prefixed with an underscore are not to be displayed
        if (property[0].charAt(0) === '_') return;

        // if the property value has a length of 0 (empty), don't display it
        if (property[1].length === 0) return;

        propertyListHTML =
          propertyListHTML +
          '<li class="product-details__item product-details__item--property">' +
          '<span class="product-details__property-label">' +
          property[0] +
          ': </span>' +
          property[1];
        ': ' + '</li>';
      });

      return propertyListHTML;
    },

    _setCartQuantity: function(quantity) {
      this.$cartPopupCartQuantity =
        this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
      var ariaLabel;

      if (quantity === 1) {
        ariaLabel = theme.strings.oneCartCount;
      } else if (quantity > 1) {
        ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
      }

      this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
    },

    _setCartCountBubble: function(quantity) {
      this.$cartCountBubble =
        this.$cartCountBubble || $(this.selectors.cartCountBubble);
      this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

      this.$cartCountBubble.removeClass(this.classes.hidden);
      this.$cartCount.text(quantity);
    },

    _showCartPopup: function() {
      this.$cartPopupWrapper
        .prepareTransition()
        .removeClass(this.classes.cartPopupWrapperHidden);
      this._handleButtonLoadingState(false);

      slate.a11y.trapFocus({
        $container: this.$cartPopupWrapper,
        $elementToFocus: this.$cartPopup,
        namespace: 'cartPopupFocus'
      });
    },

    _hideCartPopup: function(event) {
      var setFocus = event.detail === 0 ? true : false;
      this.$cartPopupWrapper
        .prepareTransition()
        .addClass(this.classes.cartPopupWrapperHidden);

      $(this.selectors.cartPopupImage).remove();
      this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

      slate.a11y.removeTrapFocus({
        $container: this.$cartPopupWrapper,
        namespace: 'cartPopupFocus'
      });

      if (setFocus) this.$previouslyFocusedElement[0].focus();

      this.$cartPopupWrapper.off('keyup');
      this.$cartPopupClose.off('click');
      this.$cartPopupDismiss.off('click');
      $('body').off('click');
    },

    _onBodyClick: function(event) {
      var $target = $(event.target);

      if (
        $target[0] !== this.$cartPopupWrapper[0] &&
        !$target.parents(this.selectors.cartPopup).length
      ) {
        this._hideCartPopup(event);
      }
    },

    _setActiveThumbnail: function(mediaId) {
      // If there is no element passed, find it by the current product image
      if (typeof mediaId === 'undefined') {
        mediaId = $(
          this.selectors.productMediaWrapper + ':not(.hide)',
          this.$container
        ).data('media-id');
      }
      
      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          mediaId +
          "']"
      );
      
      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchMedia: function(mediaId) {
      var $currentMedia = $(
        this.selectors.productMediaWrapper +
          ':not(.' +
          this.classes.hidden +
          ')',
        this.$container
      );

      var $newMedia = $(
        this.selectors.productMediaWrapper +
          "[data-media-id='" +
          mediaId +
          "']",
        this.$container
      );

      var $otherMedia = $(
        this.selectors.productMediaWrapper +
          ":not([data-media-id='" +
          mediaId +
          "'])",
        this.$container
      );

      $currentMedia.trigger('mediaHidden');
      $newMedia.removeClass(this.classes.hidden).trigger('mediaVisible');
      $otherMedia.addClass(this.classes.hidden);
    },

    _handleMediaFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      var mediaId = $(evt.currentTarget).data('thumbnail-id');

      $(
        this.selectors.productMediaWrapper +
          "[data-media-id='" +
          mediaId +
          "']",
        this.$container
      ).focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 3,
        slidesToScroll: 2,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText =
        '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      var unitLabel = '';
      var unitPrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      if (variant.unit_price) {
        unitLabel = theme.strings.unitPrice;
        unitPrice =
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
          ' ' +
          theme.strings.unitPriceSeparator +
          ' ' +
          this._getBaseUnit(variant);
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .replace('[UnitPrice]', unitLabel)
        .replace('[$$$]', unitPrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.innerHTML = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    /*
    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          this.$addToCart
            .removeAttr('aria-disabled')
            .attr('aria-label', theme.strings.addToCart);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          
          $(this.selectors.productForm, this.container).removeClass(
            this.classes.variantSoldOut
          );
        } else {
          // Variant is sold out, disable submit button and change the text.
          this.$addToCart
            .attr('aria-disabled', true)
            .attr('aria-label', theme.strings.soldOut);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          $(this.selectors.productForm, this.container).addClass(
            this.classes.variantSoldOut
          );
        }
      } else {
        // The variant doesn't exist, disable submit button and change the text.
        this.$addToCart
          .attr('aria-disabled', true)
          .attr('aria-label', theme.strings.unavailable);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        $(this.selectors.productForm, this.container).addClass(
          this.classes.variantSoldOut
        );
      }
    },
    */


    _updateAddToCart: function(evt) {
      var variant = evt.variant;
    
      if (variant) {
        if (variant.available) {
          this.$addToCart
            .removeAttr('aria-disabled')
            .attr('aria-label', theme.strings.addToCart);
          
          // Update only the button text
          $(this.selectors.addToCartText, this.$container)
            .find('.button-text')
            .text(theme.strings.addToCart);
    
          $(this.selectors.productForm, this.container).removeClass(
            this.classes.variantSoldOut
          );
        } else {
          // Variant is sold out, disable submit button and change the text.
          this.$addToCart
            .attr('aria-disabled', true)
            .attr('aria-label', theme.strings.soldOut);
          
          // Update only the button text
          $(this.selectors.addToCartText, this.$container)
            .find('.button-text')
            .text(theme.strings.soldOut);
    
          $(this.selectors.productForm, this.container).addClass(
            this.classes.variantSoldOut
          );
        }
      } else {
        // The variant doesn't exist, disable submit button and change the text.
        this.$addToCart
          .attr('aria-disabled', true)
          .attr('aria-label', theme.strings.unavailable);
        
        // Update only the button text
        $(this.selectors.addToCartText, this.$container)
          .find('.button-text')
          .text(theme.strings.unavailable);
    
        $(this.selectors.productForm, this.container).addClass(
          this.classes.variantSoldOut
        );
      }
    },

    _updateBackInStock: function(evt) {
      var variant = evt.variant;
      var $blocks = $(this.selectors.backInStockBlocks, this.$container);
      var shouldHideBuyButtons = false;
      var self = this;

      if ($blocks.length === 0) {
        return;
      }

      var isSoldOut = !!(variant && variant.available === false);
      var variantTitle = '';

      if (variant) {
        variantTitle = variant.public_title || variant.title || '';
        if (variantTitle === 'Default Title') {
          variantTitle = '';
        }
      }

      $blocks.each(function() {
        var $block = $(this);
        var hideBuyButtons = $block.attr('data-hide-buy-buttons') === 'true';
        var showSelectedVariant = $block.attr('data-show-selected-variant') === 'true';
        var productHandle = $block.attr('data-product-handle') || '';
        var tags = ['back-in-stock'];

        if (productHandle) {
          tags.push('product-' + productHandle);
        }

        if (variant && variant.id) {
          tags.push('variant-id-' + variant.id);
        }

        $block.prop('hidden', !isSoldOut);
        $block.toggleClass('product-back-in-stock--hidden', !isSoldOut);
        $block.find(self.selectors.backInStockTags).val(tags.join(','));
        $block.find(self.selectors.backInStockSelectedVariant).text(variantTitle);
        $block.find(self.selectors.backInStockSelectedVariantRow)
          .prop('hidden', !(showSelectedVariant && variantTitle))
          .toggleClass('product-back-in-stock__variant--hidden', !(showSelectedVariant && variantTitle))
          .css('display', showSelectedVariant && variantTitle ? '' : 'none');

        if (hideBuyButtons && isSoldOut) {
          shouldHideBuyButtons = true;
        }
      });

      $(this.selectors.buyButtons, this.$container)
        .prop('hidden', shouldHideBuyButtons)
        .toggleClass('product-buy-buttons--hidden', shouldHideBuyButtons);
    },


    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      this._updateBackInStock(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateMedia: function(evt) {
      var variant = evt.variant;
      var mediaId = variant.featured_media.id;
      var sectionMediaId = this.settings.sectionId + '-' + mediaId;

      this._switchMedia(sectionMediaId);
      this._setActiveThumbnail(sectionMediaId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
      var $unitPriceBaseUnit = $(
        this.selectors.unitPriceBaseUnit,
        $priceContainer
      );

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeClass(this.classes.productUnitAvailable)
        .removeClass(this.classes.productSoldOut)
        .removeAttr('aria-hidden');

      this.$productPolicies.removeClass(this.classes.visibilityHidden);

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);

        this.$productPolicies.addClass(this.classes.visibilityHidden);
        return;
      }

      // Sold out
      if (!variant.available) {
        $priceContainer.addClass(this.classes.productSoldOut);
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }

      // Unit price
      if (variant.unit_price) {
        $unitPrice.html(
          theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
        );
        $unitPriceBaseUnit.html(this._getBaseUnit(variant));
        $priceContainer.addClass(this.classes.productUnitAvailable);
      }
    },

    _getBaseUnit: function(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
      theme.ProductModel.removeSectionModels(this.settings.sectionId);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

// END ADD TO CART NOTIFICATION

theme.ProductRecommendations = (function() {
  function ProductRecommendations(container) {
    this.$container = $(container);

    var baseUrl = this.$container.data('baseUrl');
    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      baseUrl +
      '?section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    $.get(recommendationsSectionUrl).then(
      function(section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);
        }
      }.bind(this)
    );
  }

  return ProductRecommendations;
})();

function skyrocketRecommendationEscapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function skyrocketRecommendationParseBool(value) {
  return String(value) === 'true';
}

function skyrocketRecommendationGetStoreRoot() {
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    return window.Shopify.routes.root;
  }

  return '/';
}

function skyrocketRecommendationGetImageSrc(image, width) {
  if (!image) return '';

  var src = '';
  if (typeof image === 'string') {
    src = image;
  } else if (image.src) {
    src = image.src;
  } else if (image.url) {
    src = image.url;
  }

  if (!src) return '';

  if (src.indexOf('//') === 0) {
    src = 'https:' + src;
  }

  if (width && src.indexOf('width=') === -1) {
    src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  return src;
}

function skyrocketRecommendationGetPrimaryVariant(productData) {
  if (!productData || !Array.isArray(productData.variants) || !productData.variants.length) {
    return null;
  }

  for (var i = 0; i < productData.variants.length; i += 1) {
    if (productData.variants[i] && productData.variants[i].available) {
      return productData.variants[i];
    }
  }

  return productData.variants[0];
}

function skyrocketRecommendationFetchSmartProducts(productId, limit) {
  return $.getJSON(
    skyrocketRecommendationGetStoreRoot() +
    'recommendations/products.json?product_id=' +
    encodeURIComponent(productId) +
    '&limit=' +
    encodeURIComponent(limit) +
    '&intent=related'
  )
    .then(function(response) {
      return response && Array.isArray(response.products) ? response.products : [];
    }, function() {
      return [];
    });
}

function skyrocketRecommendationFetchCollectionProducts(handle, limit) {
  if (!handle) return $.Deferred().resolve([]).promise();

  return $.getJSON(
    skyrocketRecommendationGetStoreRoot() +
    'collections/' +
    encodeURIComponent(handle) +
    '/products.json?limit=' +
    encodeURIComponent(limit)
  )
    .then(function(response) {
      return response && Array.isArray(response.products) ? response.products : [];
    }, function() {
      return [];
    });
}

function skyrocketRecommendationGetBlockConfig(container) {
  var dataset = container.dataset || {};

  return {
    addMode: dataset.addMode || 'staged',
    buttonLabel: dataset.buttonLabel || 'Add',
    addedLabel: dataset.addedLabel || 'Added',
    soldOutLabel: dataset.soldOutLabel || 'Sold out',
    supportingText: dataset.supportingText || '',
    showVariantSelector: skyrocketRecommendationParseBool(dataset.showVariantSelector),
    showQuantitySelector: skyrocketRecommendationParseBool(dataset.showQuantitySelector),
    minimalQuantitySelector: skyrocketRecommendationParseBool(dataset.minimalQuantitySelector),
    selectedByDefault: skyrocketRecommendationParseBool(dataset.selectedByDefault),
    cardLayout: dataset.cardLayout || 'compact',
    cardTextAlignment: dataset.cardTextAlignment || 'left',
    cardWidthDesktop: dataset.cardWidthDesktop || 'full-width',
    cardWidthMobile: dataset.cardWidthMobile || 'full-width',
    defaultQuantity: Math.max(parseInt(dataset.defaultQuantity, 10) || 1, 1),
    imageRenderWidth: Math.max(parseInt(dataset.imageRenderWidth, 10) || 512, 1)
  };
}

function skyrocketRecommendationBuildQuantityMarkup(config, available) {
  if (!config.showQuantitySelector) return '';

  var minimalClass = config.minimalQuantitySelector ? ' sky-product-recommendations__quantity-control--minimal' : '';
  var disabledClass = available ? '' : ' is-disabled';
  var minimalAttrs = config.minimalQuantitySelector ? ' data-product-recommendation-qty-minimal data-qty-expanded="false"' : '';
  var trackOpen = config.minimalQuantitySelector ? '<div class="sky-product-recommendations__quantity-track">' : '';
  var trackClose = config.minimalQuantitySelector ? '</div>' : '';

  return '' +
    '<div class="skyrocket-oneclick__quantity-control sky-product-recommendations__quantity-control' + minimalClass + disabledClass + '" data-product-recommendation-qty-control' + minimalAttrs + '>' +
      trackOpen +
        '<span class="btnqty qtyminus hover-effect btnqty--small" data-product-recommendation-qty-minus aria-label="Decrease recommendation quantity">' +
          '<span class="sky-icon" aria-hidden="true"><svg viewBox="0 0 448 512" focusable="false"><path fill="currentColor" d="M416 240c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 304C14.3 304 0 289.7 0 272s14.3-32 32-32l384 0z"></path></svg></span>' +
        '</span>' +
        '<input type="text" value="' + config.defaultQuantity + '" min="1" inputmode="numeric" pattern="[0-9]*" class="quantity-selector quantity-input quantity-input--small" data-product-recommendation-qty aria-label="Recommendation quantity">' +
        '<span class="btnqty qtyplus hover-effect btnqty--small" data-product-recommendation-qty-plus aria-label="Increase recommendation quantity">' +
          '<span class="sky-icon" aria-hidden="true"><svg viewBox="0 0 448 512" focusable="false"><path fill="currentColor" d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"></path></svg></span>' +
        '</span>' +
      trackClose +
    '</div>';
}

function skyrocketRecommendationBuildButtonMarkup(config, selected, available) {
  var buttonLabel = available
    ? (selected ? config.addedLabel : config.buttonLabel)
    : config.soldOutLabel;

  return '' +
    '<button type="button" class="btn btn-hover sky-product-recommendations__button' + (selected ? ' is-selected' : '') + '"' +
      ' data-product-recommendation-button' +
      ' data-label-add="' + skyrocketRecommendationEscapeHtml(config.buttonLabel) + '"' +
      ' data-label-added="' + skyrocketRecommendationEscapeHtml(config.addedLabel) + '"' +
      ' data-label-sold-out="' + skyrocketRecommendationEscapeHtml(config.soldOutLabel) + '"' +
      (available ? '' : ' disabled') +
    '>' +
      '<span class="sky-product-recommendations__button-icon" aria-hidden="true">' +
        '<span class="sky-icon" aria-hidden="true"><svg viewBox="0 0 448 512" focusable="false"><path fill="currentColor" d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"></path></svg></span>' +
      '</span>' +
      '<span class="sky-product-recommendations__button-label" data-product-recommendation-button-label>' + skyrocketRecommendationEscapeHtml(buttonLabel) + '</span>' +
    '</button>';
}

function skyrocketRecommendationBuildVariantMarkup(productData, selectedVariant, config, blockId, cardIndex) {
  if (!config.showVariantSelector || !productData || !Array.isArray(productData.variants) || productData.variants.length < 2) {
    return '';
  }

  var selectId = 'product-recommendation-variant-' + blockId + '-' + cardIndex;
  var optionsMarkup = productData.variants.map(function(variant) {
    var variantImage = skyrocketRecommendationGetImageSrc(
      variant.featured_image || variant.featured_media && variant.featured_media.preview_image || productData.featured_image,
      config.imageRenderWidth
    );

    return '' +
      '<option value="' + variant.id + '"' +
        ' data-price="' + (variant.price || 0) + '"' +
        ' data-compare-at-price="' + (variant.compare_at_price || 0) + '"' +
        ' data-available="' + (!!variant.available) + '"' +
        (variantImage ? ' data-image="' + skyrocketRecommendationEscapeHtml(variantImage) + '"' : '') +
        (String(variant.id) === String(selectedVariant.id) ? ' selected' : '') +
        (variant.available ? '' : ' disabled') +
      '>' +
        skyrocketRecommendationEscapeHtml(variant.title || 'Default title') +
        (variant.available ? '' : ' - Sold out') +
      '</option>';
  }).join('');

  return '' +
    '<div class="sky-input-wrapper sky-product-recommendations__variant-wrap">' +
      '<select class="sky-input sky-product-recommendations__variant" id="' + skyrocketRecommendationEscapeHtml(selectId) + '" data-product-recommendation-variant aria-label="Choose ' + skyrocketRecommendationEscapeHtml(productData.title || 'product') + ' variant">' +
        optionsMarkup +
      '</select>' +
      '<div class="sky-chevron"><span class="sky-icon" aria-hidden="true"><svg viewBox="0 0 320 512" focusable="false"><path fill="currentColor" d="M143 352.3L7 216.3C-2.4 206.9-2.4 191.1 7 181.7l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0L160 255.1l96.4-96c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.5 9.3-24.7 9.3-33.9-.1z"></path></svg></span></div>' +
    '</div>';
}

function skyrocketRecommendationBuildCardMarkup(productData, config, blockId, cardIndex) {
  if (!productData) return '';

  var selectedVariant = skyrocketRecommendationGetPrimaryVariant(productData);
  if (!selectedVariant) return '';

  var available = !!selectedVariant.available;
  var selected = config.addMode === 'staged' && config.selectedByDefault && available;
  var showVariantSelector = config.showVariantSelector && Array.isArray(productData.variants) && productData.variants.length > 1;
  var priceMarkup = '' +
    '<span class="skyrocket-oneclick__current-price" data-product-recommendation-price>' + (selectedVariant.price === 0 ? 'FREE' : skyrocketRecommendationFormatMoney(selectedVariant.price || 0)) + '</span>' +
    '<span class="skyrocket-oneclick__compare-price' + ((selectedVariant.compare_at_price || 0) > (selectedVariant.price || 0) ? '' : ' hide') + '" data-product-recommendation-compare>' + (((selectedVariant.compare_at_price || 0) > (selectedVariant.price || 0)) ? skyrocketRecommendationFormatMoney(selectedVariant.compare_at_price || 0) : '') + '</span>';
  var quantityMarkup = skyrocketRecommendationBuildQuantityMarkup(config, available);
  var buttonMarkup = skyrocketRecommendationBuildButtonMarkup(config, selected, available);
  var variantMarkup = skyrocketRecommendationBuildVariantMarkup(productData, selectedVariant, config, blockId, cardIndex);
  var imageSrc = skyrocketRecommendationGetImageSrc(selectedVariant.featured_image || selectedVariant.featured_media && selectedVariant.featured_media.preview_image || productData.featured_image, config.imageRenderWidth);
  var mediaMarkup = imageSrc
    ? '<img class="sky-product-recommendations__image" src="' + skyrocketRecommendationEscapeHtml(imageSrc) + '" alt="' + skyrocketRecommendationEscapeHtml((productData.featured_image && productData.featured_image.alt) || productData.title || '') + '" loading="lazy">'
    : '<div class="sky-product-recommendations__placeholder"></div>';

  return '' +
    '<article class="sky-product-recommendations__card sky-product-recommendations__card--desktop-' + skyrocketRecommendationEscapeHtml(config.cardWidthDesktop) + ' sky-product-recommendations__card--mobile-' + skyrocketRecommendationEscapeHtml(config.cardWidthMobile) + ' sky-product-recommendations__card--content-' + skyrocketRecommendationEscapeHtml(config.cardTextAlignment) + (selected ? ' is-selected' : '') + '"' +
      ' role="listitem"' +
      ' data-product-recommendation-item' +
      ' data-mode="' + skyrocketRecommendationEscapeHtml(config.addMode) + '"' +
      ' data-variant-id="' + selectedVariant.id + '"' +
      ' data-variant-price="' + (selectedVariant.price || 0) + '"' +
      ' data-variant-compare-at-price="' + (selectedVariant.compare_at_price || 0) + '"' +
      ' data-product-id="' + productData.id + '"' +
      ' data-available="' + available + '"' +
      ' data-selected="' + (selected ? 'true' : 'false') + '"' +
    '>' +
      '<a class="sky-product-recommendations__media" href="' + skyrocketRecommendationEscapeHtml(productData.url || '#') + '" aria-label="' + skyrocketRecommendationEscapeHtml(productData.title || 'Recommended product') + '">' +
        mediaMarkup +
      '</a>' +
      '<div class="sky-product-recommendations__body sky-product-recommendations__body--' + skyrocketRecommendationEscapeHtml(config.cardTextAlignment) + '">' +
        '<a class="skyrocket-oneclick__title sky-product-recommendations__title" href="' + skyrocketRecommendationEscapeHtml(productData.url || '#') + '">' + skyrocketRecommendationEscapeHtml(productData.title || '') + '</a>' +
        '<p class="skyrocket-oneclick__price sky-product-recommendations__price" data-product-recommendation-price-wrap>' + priceMarkup + '</p>' +
        (config.supportingText ? '<p class="skyrocket-oneclick__subtitle sky-product-recommendations__supporting">' + skyrocketRecommendationEscapeHtml(config.supportingText) + '</p>' : '') +
      '</div>' +
      (config.cardLayout === 'product-card'
        ? ((showVariantSelector || config.showQuantitySelector)
          ? '<div class="sky-product-recommendations__footer sky-product-recommendations__footer--product-card">' + variantMarkup + quantityMarkup + '</div>'
          : '') +
          '<div class="sky-product-recommendations__actions sky-product-recommendations__actions--product-card">' + buttonMarkup + '</div>'
        : '<div class="sky-product-recommendations__actions sky-product-recommendations__actions--compact">' +
            (showVariantSelector ? buttonMarkup : quantityMarkup + buttonMarkup) +
          '</div>' +
          (showVariantSelector ? '<div class="sky-product-recommendations__footer">' + variantMarkup + quantityMarkup + '</div>' : '')
      ) +
    '</article>';
}

function initProductRecommendationBlocks(root) {
  var scope = root && root.querySelectorAll ? root : document;

  scope.querySelectorAll('[data-product-recommendations-block][data-source-mode="shopify"]').forEach(function(container) {
    if (container.getAttribute('data-recommendations-requested') === 'true') return;

    var track = container.querySelector('.sky-product-recommendations__track');
    var productId = container.getAttribute('data-product-id');
    var limit = Math.max(parseInt(container.getAttribute('data-limit'), 10) || 4, 1);
    var fallbackCollectionHandle = container.getAttribute('data-fallback-collection-handle') || '';
    var fallbackSource = container.getAttribute('data-fallback-source') || 'none';

    if (!track || !productId) return;

    container.setAttribute('data-recommendations-requested', 'true');

    var config = skyrocketRecommendationGetBlockConfig(container);
    var hideCurrent = skyrocketRecommendationParseBool(container.getAttribute('data-hide-current-product'));
    var blockId = container.id || ('product-recommendations-block-' + productId);

    function normalizeProducts(products) {
      var normalized = Array.isArray(products) ? products.slice() : [];

      if (hideCurrent) {
        normalized = normalized.filter(function(productData) {
          return String(productData.id) !== String(productId);
        });
      }

      return normalized.slice(0, limit);
    }

    function renderProducts(products, source) {
      var normalized = normalizeProducts(products);
      if (!normalized.length) return false;

      var cardsMarkup = normalized.map(function(productData, index) {
        return skyrocketRecommendationBuildCardMarkup(productData, config, blockId, index + 1);
      }).join('');

      if (!cardsMarkup) return false;

      track.innerHTML = cardsMarkup;
      container.setAttribute('data-recommendations-loaded', 'true');
      container.setAttribute('data-recommendations-source', source);
      return true;
    }

    function clearRenderedFallback() {
      track.innerHTML = '';
      container.setAttribute('data-recommendations-empty', 'true');
      container.removeAttribute('data-recommendations-loaded');
      container.removeAttribute('data-recommendations-source');
    }

    skyrocketRecommendationFetchSmartProducts(productId, limit)
      .then(function(products) {
        if (renderProducts(products, 'shopify')) return true;

        if (fallbackCollectionHandle) {
          return skyrocketRecommendationFetchCollectionProducts(fallbackCollectionHandle, limit).then(function(collectionProducts) {
            return renderProducts(collectionProducts, 'collection');
          });
        }

        if (fallbackSource === 'manual' && track.querySelector('[data-product-recommendation-item]')) {
          container.setAttribute('data-recommendations-source', 'manual');
          return true;
        }

        clearRenderedFallback();
        return false;
      })
      .always(function() {
        container.removeAttribute('data-recommendations-requested');
      });
  });
}

$(document).ready(function() {
  initProductRecommendationBlocks(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initProductRecommendationBlocks(event.target);
});

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.VideoSection = (function() {
  function VideoSection(container) {
    var $container = (this.$container = $(container));

    $('.video', $container).each(function() {
      var $el = $(this);
      theme.Video.init($el);
      theme.Video.editorLoadVideo($el.attr('id'));
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function() {
    theme.Video.removeEvents();
  }
});

theme.heros = {};

theme.HeroSection = (function() {
  function HeroSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var hero = '#Hero-' + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();

window.theme = window.theme || {};

var selectors = {
  disclosureLocale: '[data-disclosure-locale]',
  disclosureCurrency: '[data-disclosure-currency]'
};

theme.FooterSection = (function() {
  function Footer(container) {
    this.$container = $(container);
    this.cache = {};
    this.cacheSelectors();

    if (this.cache.$localeDisclosure.length) {
      this.localeDisclosure = new theme.Disclosure(
        this.cache.$localeDisclosure
      );
    }

    if (this.cache.$currencyDisclosure.length) {
      this.currencyDisclosure = new theme.Disclosure(
        this.cache.$currencyDisclosure
      );
    }
  }

  Footer.prototype = _.assignIn({}, Footer.prototype, {
    cacheSelectors: function() {
      this.cache = {
        $localeDisclosure: this.$container.find(selectors.disclosureLocale),
        $currencyDisclosure: this.$container.find(selectors.disclosureCurrency)
      };
    },

    onUnload: function() {
      if (this.cache.$localeDisclosure.length) {
        this.localeDisclosure.unload();
      }

      if (this.cache.$currencyDisclosure.length) {
        this.currencyDisclosure.unload();
      }
    }
  });

  return Footer;
})();


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('quotes', theme.Quotes);
  sections.register('hero-section', theme.HeroSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
  sections.register('footer-section', theme.FooterSection);
});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)')
  });

  theme.FormStatus.init();

  var selectors = {
    image: '[data-image]',
    imagePlaceholder: '[data-image-placeholder]',
    imageWithPlaceholderWrapper: '[data-image-with-placeholder-wrapper]',
    lazyloaded: '.lazyloaded'
  };

  var classes = {
    hidden: 'hide'
  };

  $(document).on('lazyloaded', function(e) {
    var $target = $(e.target);

    if ($target.data('bgset')) {
      var $image = $target.find(selectors.lazyloaded);
      if ($image.length) {
        var alt = $target.data('alt');
        var src = $image.data('src') ? $image.data('src') : $target.data('bg');

        $image.attr('alt', alt ? alt : '');
        $image.attr('src', src ? src : '');
      }
    }

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    $(selectors.image + '.lazyloaded')
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  }

  onLoadHideLazysizesAnimation();
  $(document).one('touchstart', function() {
    theme.Helpers.setTouch();
  });
};



// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
  theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}

$(theme.init);

let lastVh = -Infinity;

const updateVhProperty = () => {
  const vh = window.innerHeight * 0.01;
  if (vh > lastVh) {
    lastVh = vh;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}

updateVhProperty();




$(document).ready(function(){
                  
 $('.collection-slider').each(function(){
   var num_slides = 2;
  if(window.innerWidth >= 750)
  {
   var num_slides = $(this).data('slides');
   }
  $(this).slick({slidesToShow:num_slides});
});
                  
});


   
$(function() {
    $(window).on("scroll", function() {
        if($(window).scrollTop() > 50) {
            $(".site-header_transparent").addClass("active");
        } else {
            //remove the background property so it comes transparent again (defined in your css)
           $(".site-header_transparent").removeClass("active");
        }
    });
});

/*
  function headerSize() {
  var $headerHeight = $('#myHeader').outerHeight();
    $('#PageContainer').css('margin-top', $headerHeight);
  document.getElementById("#PageContainer").style.marginTop = "-75px"; 
}

$(window).on("load", headerSize);
$(window).on("resize", $.debounce(500, headerSize));
*/






function countdown()
    {
        var interval = setInterval(function(){

            if(hr == 0 && mm == 0 && ss == 0)clearInterval(interval);
            ss--;
            if(ss == 0)
            {
                ss = 59;
                mm--;
                if(mm == 0)
                {
                    mm = 59;
                    hr--;
                }
            }

            if(hr.toString().length < 2) hr = "0"+hr;
            if(mm.toString().length < 2) mm = "0"+mm;
            if(ss.toString().length < 2) ss = "0"+ss;
            $("#time").html(hr+" : "+mm+" : "+ss);

        },1000)
    }

var selects = Array.from(document.getElementsByClassName("slim-select"));
selects.forEach(select => {
  new SlimSelect({
    select,
    showSearch: false,
  });
});

$(".custom-product-card").hover(function(){
  document.getElementByClassName("card-view").css.display = 'block';
});


$('#currency_form select').on('change',function() {  
  $('#currency_form').submit();
});


$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
}); 


/*
$(".childshow").click(function (e) {
    e.stopPropagation();
    $(".childshow").removeClass("openedMenu");
    jQuery(this).children('.childshow').toggle();
});
*/


var dropdown = document.getElementsByClassName("dropdown-btn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function() {
    this.classList.toggle("active-link");
    var dropdownContent = this.nextElementSibling;
    if (dropdownContent.style.maxHeight === "1000px") {
      dropdownContent.style.maxHeight = "0";
      dropdownContent.style.transition = "max-height 0.5s cubic-bezier(0, 1, 0, 1)";
      dropdownContent.style.marginBottom = "0";

    } else {
      dropdownContent.style.maxHeight = "1000px";
      dropdownContent.style.transition = "max-height 0.5s ease-in-out";
      dropdownContent.style.marginBottom = "12px";
    }
  });
}

/* Set the width of the side navigation to 250px */
function openNav() { 
  document.getElementById("menuDrawer").style.transition = "0.5s";
  document.getElementById("menuDrawer").style.transform = "translateX(0%)";
  document.getElementById("menuDrawer").style.overflowY = "auto";
  document.getElementById("menuDrawerShadow").style.visibility = "visible";
  document.getElementById("menuDrawerShadow").style.opacity = "1";
  document.getElementById("menuDrawerShadow").style.transition = "0.5s";
  document.body.style.overflow = 'hidden';

}

/* Set the width of the side navigation to 0 */
function closeNav() {
  document.getElementById("menuDrawerShadow").style.visibility = "hidden";
  document.getElementById("menuDrawerShadow").style.opacity = "0";
  document.getElementById("menuDrawerShadow").style.transition = "0.5s";
  document.getElementById("menuDrawer").style.transform = "translateX(-100%)";
  document.getElementById("menuDrawer").style.overflow = "hidden";
  document.body.style.overflow = 'auto';
}

function showMenuDrawer() {
  document.getElementById('menuDrawer').style.transform = "translateX(0)";
  document.getElementById('menuDrawerShadow').style.opacity = "1";
  document.getElementById('menuDrawerShadow').style.pointerEvents = "auto";
  document.body.style.overflow = "hidden";
}

function closeMenuDrawer() {
  document.getElementById('menuDrawer').style.transform = "translateX(-100%)";
  document.getElementById('menuDrawerShadow').style.opacity = "0";
  document.getElementById('menuDrawerShadow').style.pointerEvents = "none";
  document.body.style.overflow = "auto";
}



$(window).on('load', function(){
  $('.sky-slideshow').each(function slideshowSlick(){
    
    var num_slides = $(this).data('slides');
    var rotate_slides = $(this).data('autorotate');
    var slide_speed = $(this).data('speed');
    
    $(this).slick({
      slidesToShow: num_slides,
      autoplay: rotate_slides,
      autoplaySpeed: slide_speed,
      dots: true,
      arrows: false, 
    });
    
  });
  });
 


  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('#predictive-search');
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=4&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
      this.predictiveSearchResults.style.border = '1px solid #f1f1f1';
      this.predictiveSearchResults.style.overflow = 'scroll';
      
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
      this.predictiveSearchResults.style.border = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('predictive-search', PredictiveSearch);
  

var accordionBlock = document.getElementsByClassName("accordion-as-block");

for (var i = 0; i < accordionBlock.length; i++) {
  accordionBlock[i].addEventListener("click", function() {
    for (var j = 0; j < accordionBlock.length; j++) {
      if (accordionBlock[j] !== this) {
        accordionBlock[j].classList.remove("sky-accordion-block-active");
        accordionBlock[j].nextElementSibling.style.maxHeight = null;
      }
    }
    
    this.classList.toggle("sky-accordion-block-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

var accordionList = document.getElementsByClassName("accordion-as-list");

for (var i = 0; i < accordionList.length; i++) {
  accordionList[i].addEventListener("click", function() {
    for (var j = 0; j < accordionList.length; j++) {
      if (accordionList[j] !== this) {
        accordionList[j].classList.remove("sky-accordion-list-active");
        accordionList[j].nextElementSibling.style.maxHeight = null;
      }
    }
    
    this.classList.toggle("sky-accordion-list-active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

document.addEventListener("DOMContentLoaded", function() {
  // Function to open accordions by default
  function openAccordionsByDefault() {
    // Target both block and list accordion types with 'sky-accordion-active'
    var activeBlocks = document.querySelectorAll(".sky-accordion-active");

    activeBlocks.forEach(function (block) {
      // Check if it's a block or list type and add the appropriate active class
      if (block.classList.contains("accordion-as-block")) {
        block.classList.add("sky-accordion-block-active"); // Add active class for block type
      } else if (block.classList.contains("accordion-as-list")) {
        block.classList.add("sky-accordion-list-active"); // Add active class for list type
      }

      // Expand the panel
      var panel = block.nextElementSibling;
      if (panel) {
        panel.style.maxHeight = panel.scrollHeight + "px"; // Open the panel
      }
    });
  }

  // Run the function on load
  openAccordionsByDefault();
});

function initAccordion() {
  document.querySelectorAll('.accordion-section').forEach(function(section) {
    var tabs = section.querySelectorAll('.accordion-tab');
    if (tabs.length > 0) {
      tabs.forEach(function(tabButton) {
        tabButton.addEventListener('click', function() {
          var tabIndex = this.getAttribute('data-tab-index');
          tabs.forEach(function(btn) {
            btn.classList.remove('accordion-tab--active');
          });
          this.classList.add('accordion-tab--active');
          section.querySelectorAll('.accordion-item').forEach(function(item) {
            var group = item.getAttribute('data-tab-group');
            item.style.display = (group === "-1" || group === tabIndex) ? 'block' : 'none';
          });
        });
      });

      if (!section.querySelector('.accordion-tab.accordion-tab--active') && tabs.length > 0) {
        tabs[0].click();
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initAccordion);

document.addEventListener('shopify:section:load', initAccordion);
document.addEventListener('shopify:section:reorder', initAccordion);









function initializeSlick(slideshow) {
  var autoplayEnabled = String($(slideshow).data('autoplay')) === 'true';
  var autoplaySpeed = Number($(slideshow).data('autoplay-speed'));

  if (isNaN(autoplaySpeed)) {
    autoplaySpeed = 3000;
  } else {
    autoplaySpeed = Math.min(Math.max(autoplaySpeed, 3000), 45000);
  }

  // Initialize Slick slider
  $(slideshow).slick({
    slidesToShow: 1,
    dots: true,
    slidesToScroll: 1,
    arrows: false,
    autoplay: autoplayEnabled,
    autoplaySpeed: autoplaySpeed,
    mobileFirst: true,
    speed: 400,
    easing: 'ease-in-out',
    initialSlide: 0,
    touchThreshold: 8,
    cssEase: 'linear',
    fade: true,
    lazyLoad: 'ondemand',
  });

  // Manually trigger the animation for the first slide after Slick initializes
  var firstSlideElement = $(slideshow).find('.slick-slide[data-slick-index="0"]');

  firstSlideElement.find('.slideUp--Set').each(function(index) {
    $(this).removeClass('slideUp--Set').addClass('slideUp--' + (index + 1));
  });
}

function getSlideshowState($slideshow) {
  var state = $slideshow.data('skySlideshowState');

  if (!state) {
    state = {
      isTransitioning: false,
      isHoveringButton: false,
      hasPointer: false,
      lastMouseX: null,
      lastMouseY: null
    };
    $slideshow.data('skySlideshowState', state);
  }

  return state;
}

function getSlideshowArrowSettings($slideshow) {
  var $wrapper = $slideshow.closest('.slideshow-section');
  var isMobileViewport = window.matchMedia('(max-width: 749px)').matches;

  return {
    mode: isMobileViewport
      ? String($wrapper.data('arrow-display-mobile') || 'fixed')
      : String($wrapper.data('arrow-display-desktop') || 'follow-cursor'),
    fixedPosition: isMobileViewport
      ? String($wrapper.data('arrow-fixed-position-mobile') || 'middle')
      : String($wrapper.data('arrow-fixed-position-desktop') || 'middle')
  };
}

function getCurrentSlideshowSlide($slideshow) {
  var $currentSlide = $slideshow.find('.slick-current').first();

  if (!$currentSlide.length) {
    $currentSlide = $slideshow.find('.slick-active').first();
  }

  if (!$currentSlide.length) {
    $currentSlide = $slideshow.children('.sky-hero-content').first();
  }

  return $currentSlide;
}

function getCurrentSlideshowArrows($slideshow) {
  var $currentSlide = getCurrentSlideshowSlide($slideshow);

  return {
    left: $currentSlide.find('.sky-slide-arrow--left').first(),
    right: $currentSlide.find('.sky-slide-arrow--right').first()
  };
}

function getSlideshowArrowSize($slideshow) {
  var $arrow = getCurrentSlideshowArrows($slideshow).left;
  var arrowSize = parseFloat($arrow.outerWidth());

  if (!arrowSize || isNaN(arrowSize)) {
    arrowSize = 56;
  }

  return arrowSize;
}

function hideSlideshowArrows($slideshow, preserveTransform) {
  var hiddenStyles = {
    'visibility': 'hidden',
    'opacity': '0',
    'pointer-events': 'none'
  };

  if (!preserveTransform) {
    hiddenStyles.transform = 'scale(0)';
  }

  $slideshow.find('.sky-slide-arrow--left, .sky-slide-arrow--right').css(hiddenStyles);
}

function getFixedSlideshowArrowState($slideshow) {
  var state = getSlideshowState($slideshow);

  return {
    opacity: state.isTransitioning ? '0.5' : '1',
    pointerEvents: state.isTransitioning ? 'none' : 'auto'
  };
}

function showFixedSlideshowArrows($slideshow, fixedPosition) {
  var fixedArrowState = getFixedSlideshowArrowState($slideshow);
  var currentArrows = getCurrentSlideshowArrows($slideshow);
  var $leftArrow = currentArrows.left;
  var $rightArrow = currentArrows.right;
  var isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
  var sideOffsetLeft = isMobileViewport ? '20px' : '32px';
  var sideOffsetRight = isMobileViewport ? '24px' : '32px';
  var verticalOffset = isMobileViewport ? '32px' : '48px';
  var topValue = '';
  var bottomValue = '';
  var transformValue = 'scale(1)';
  var leftArrowPosition = {
    left: sideOffsetLeft,
    right: '',
    top: '',
    bottom: ''
  };
  var rightArrowPosition = {
    left: '',
    right: sideOffsetRight,
    top: '',
    bottom: ''
  };

  if (fixedPosition === 'top') {
    topValue = verticalOffset;
  } else if (fixedPosition === 'bottom') {
    bottomValue = verticalOffset;
  } else {
    topValue = '50%';
    transformValue = 'translateY(-50%) scale(1)';
  }

  leftArrowPosition.top = topValue;
  leftArrowPosition.bottom = bottomValue;
  rightArrowPosition.top = topValue;
  rightArrowPosition.bottom = bottomValue;

  hideSlideshowArrows($slideshow, true);

  $leftArrow.css({
    'left': leftArrowPosition.left,
    'right': leftArrowPosition.right,
    'top': leftArrowPosition.top,
    'bottom': leftArrowPosition.bottom,
    'transform': transformValue,
    'visibility': 'visible',
    'opacity': fixedArrowState.opacity,
    'pointer-events': fixedArrowState.pointerEvents
  });

  $rightArrow.css({
    'left': rightArrowPosition.left,
    'right': rightArrowPosition.right,
    'top': rightArrowPosition.top,
    'bottom': rightArrowPosition.bottom,
    'transform': transformValue,
    'visibility': 'visible',
    'opacity': fixedArrowState.opacity,
    'pointer-events': fixedArrowState.pointerEvents
  });
}

function positionSlideshowArrow($slideshow) {
  var state = getSlideshowState($slideshow);
  var arrowSettings = getSlideshowArrowSettings($slideshow);

  if (arrowSettings.mode === 'hide') {
    hideSlideshowArrows($slideshow);
    return;
  }

  if (arrowSettings.mode === 'fixed') {
    showFixedSlideshowArrows($slideshow, arrowSettings.fixedPosition);
    return;
  }

  if (
    state.isTransitioning ||
    state.isHoveringButton ||
    !state.hasPointer ||
    state.lastMouseX === null ||
    state.lastMouseY === null
  ) {
    hideSlideshowArrows($slideshow);
    return;
  }

  var arrowSize = getSlideshowArrowSize($slideshow);
  var arrowHalf = arrowSize / 2;
  var containerWidth = $slideshow.outerWidth() || 0;
  var containerHeight = $slideshow.outerHeight() || 0;

  if (!containerWidth || !containerHeight) {
    hideSlideshowArrows($slideshow);
    return;
  }

  var clampedX = Math.max(arrowHalf, Math.min(state.lastMouseX, containerWidth - arrowHalf));
  var clampedY = Math.max(arrowHalf, Math.min(state.lastMouseY, containerHeight - arrowHalf));
  var halfWidth = containerWidth / 2;
  var currentArrows = getCurrentSlideshowArrows($slideshow);
  var $leftArrow = currentArrows.left;
  var $rightArrow = currentArrows.right;

  hideSlideshowArrows($slideshow);

  if (clampedX <= halfWidth) {
    $leftArrow.css({
      'left': (clampedX - arrowHalf) + 'px',
      'right': '',
      'top': (clampedY - arrowHalf) + 'px',
      'bottom': '',
      'transform': 'scale(1)',
      'visibility': 'visible',
      'opacity': '1',
      'pointer-events': 'auto'
    });
    return;
  }

  $rightArrow.css({
    'left': (clampedX - arrowHalf) + 'px',
    'right': '',
    'top': (clampedY - arrowHalf) + 'px',
    'bottom': '',
    'transform': 'scale(1)',
    'visibility': 'visible',
    'opacity': '1',
    'pointer-events': 'auto'
  });
}

function setupSlideshow() {
  // Target all slideshows
  $('.sky-hero-content--slide').each(function() {
    // Destroy existing Slick instance if it exists
    if ($.fn.slick && $(this).hasClass('slick-initialized')) {
      $(this).slick('unslick');
    }

    // Initialize the slider
    initializeSlick(this);
  });
}

function bindSlideshowInteractions($slideshow) {
  var $wrapper = $slideshow.closest('.slideshow-section');
  var state = getSlideshowState($slideshow);

  $slideshow.off('.skySlideshow');
  $wrapper.off('.skySlideshow');
  $slideshow.find('.slider-prev, .slider-next').off('.skySlideshow');

  $slideshow.find('.slider-prev').on('click.skySlideshow', function() {
    $slideshow.slick('slickPrev');
  });

  $slideshow.find('.slider-next').on('click.skySlideshow', function() {
    $slideshow.slick('slickNext');
  });

  $slideshow.on('beforeChange.skySlideshow', function(event, slick, currentSlide, nextSlide) {
    if (currentSlide !== nextSlide) {
      $(slick.$slides).find('.slideUp--1, .slideUp--2, .slideUp--3, .slideUp--4').each(function() {
        $(this).removeClass('slideUp--1 slideUp--2 slideUp--3 slideUp--4').addClass('slideUp--Set');
      });
    }

    state.isTransitioning = true;
    if (getSlideshowArrowSettings($slideshow).mode === 'fixed') {
      positionSlideshowArrow($slideshow);
      return;
    }

    hideSlideshowArrows($slideshow);
  });

  $slideshow.on('afterChange.skySlideshow', function(event, slick, currentSlide) {
    var currentSlideElement = $(slick.$slides[currentSlide]);

    currentSlideElement.find('.slideUp--Set').each(function(index) {
      $(this).removeClass('slideUp--Set').addClass('slideUp--' + (index + 1));
    });

    state.isTransitioning = false;
    positionSlideshowArrow($slideshow);
  });

  $slideshow.on('mousemove.skySlideshow', function(event) {
    if (getSlideshowArrowSettings($slideshow).mode !== 'follow-cursor') {
      return;
    }

    var offset = $slideshow.offset();
    if (!offset) return;

    state.hasPointer = true;
    state.lastMouseX = event.pageX - offset.left;
    state.lastMouseY = event.pageY - offset.top;

    positionSlideshowArrow($slideshow);
  });

  $wrapper.on('mouseleave.skySlideshow', function() {
    state.hasPointer = false;
    if (getSlideshowArrowSettings($slideshow).mode === 'follow-cursor') {
      hideSlideshowArrows($slideshow);
      return;
    }

    positionSlideshowArrow($slideshow);
  });

  $wrapper.on('mouseenter.skySlideshow', '.slick-dots, .section-button-group', function() {
    state.isHoveringButton = true;
    if (getSlideshowArrowSettings($slideshow).mode === 'follow-cursor') {
      hideSlideshowArrows($slideshow);
    }
  });

  $wrapper.on('mouseleave.skySlideshow', '.slick-dots, .section-button-group', function() {
    state.isHoveringButton = false;
    positionSlideshowArrow($slideshow);
  });

  positionSlideshowArrow($slideshow);
}

// Initial setup
function initSlider() {
  setupSlideshow();

  $('.sky-hero-content--slide').each(function() {
    bindSlideshowInteractions($(this));
  });
}

$(window).off('resize.skySlideshow').on('resize.skySlideshow', function() {
  $('.sky-hero-content--slide').each(function() {
    positionSlideshowArrow($(this));
  });
});

// Use Shopify events to manage the slider on block changes
document.addEventListener("shopify:section:load", function() {
  initSlider();
});

// Call initSlider initially for live version
$(document).ready(initSlider);


function initializeSliderBar(sliderBar) {
  var $slider = $(sliderBar).find('.slider-bar-content');

  if ($slider.length > 0) {
    var slideCount = $slider.children().length;

    // Clone slides only if they haven't been cloned already
    if (!$slider.hasClass('slick-initialized')) {
      for (var i = 0; i < slideCount; i++) {
        $slider.append($slider.children().eq(i).clone());
      }
    }

    // Initialize Slick slider for this specific slider-bar section
    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: "cubic-bezier(.24, 1.1, .54, 1.01)",
      infinite: true,
      arrows: true,
      dots: false,
      prevArrow: $(sliderBar).find('.slider-bar--slider-prev'),
      nextArrow: $(sliderBar).find('.slider-bar--slider-next'),
      swipe: true,
      speed: 300,
      autoplay: $(sliderBar).data('autoplay') || false,
      autoplaySpeed: $(sliderBar).data('autoplay-speed') || 3000
    });
  }
}

// Initialize slider when the document is ready
$(document).ready(function(){
  $('.slider-bar').each(function() {
    initializeSliderBar(this);  // Pass the specific slider-bar section to the function
  });
});

// Initialize slider when a section is loaded in the Theme Editor
$(document).on('shopify:section:load', function(event) {
  initializeSliderBar($(event.target).find('.slider-bar')[0]);  // Ensure we're passing the right section
});

// Handle block selection in the Theme Editor
$(document).on('shopify:block:select', function(event) {
  initializeSliderBar($(event.target).closest('.slider-bar'));
});

// Handle block deselection in the Theme Editor
$(document).on('shopify:block:deselect', function(event) {
  initializeSliderBar($(event.target).closest('.slider-bar'));
});


function initializeSliderFeaturedReviews() {
  var $slider = $('.product-featured-reviews');
  
  // Get the values of the data attributes
  var showReview2 = $slider.attr('data-show-review-2') === 'true';
  var showReview3 = $slider.attr('data-show-review-3') === 'true';

  // Initialize the slider if either review 2 or review 3 is enabled
  if (showReview2 || showReview3) {
    $('.product-featured-reviews-slider').slick({
      dots: false,
      infinite: false,
      arrows: true,
      speed: 300,
      nextArrow: $('.product-featured-reviews').find('.product-featured-reviews--slider-next'),
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000
    });
  } else {

  }
}

// Ensure the slider initializes when the DOM is ready
$(document).ready(function() {
  initializeSliderFeaturedReviews();
});

function initializeSliderTestimonials() {
  var $slider = $('.testimonials-section');
  
  // Get the values of the data attributes
  var enableTestimonialsCarousel = $slider.attr('data-enable-testimonials-carousel') === 'carousel';
  var showTestimonialsDots = $slider.attr('data-show-testimonials-dots') === 'true';

  function getTestimonialsNumSlides() {
    if (window.innerWidth >= 750) {
      return {
        numSlides: 3,
        scrollSlides: 3
      };
    } else {
      return {
        numSlides: 1,
        scrollSlides: 1
      };
    }
  }

  function initTestimonialsSlider() {
    var sliderConfig = getTestimonialsNumSlides();

    if ($('.testimonials-slider').hasClass('slick-initialized')) {
      $('.testimonials-slider').slick('unslick');
    }

    if (enableTestimonialsCarousel) {
      $('.testimonials-slider').slick({
        dots: showTestimonialsDots,
        infinite: true,
        arrows: true,
        speed: 300,
        nextArrow: $('.testimonials-section').find('.testimonials--slider-next'),
        prevArrow: $('.testimonials-section').find('.testimonials--slider-prev'),
        slidesToShow: sliderConfig.numSlides,
        slidesToScroll: sliderConfig.scrollSlides,
        autoplay: false
      });
    }
  }

  initTestimonialsSlider();

  $(window).resize(function() {
    initTestimonialsSlider();
  });
}

$(document).ready(function() {
  initializeSliderTestimonials();
});




document.addEventListener("DOMContentLoaded", function() {
  // Function to move the label
  function updateLabelPosition(input) {
    // Check if the input is within either input or textarea wrapper
    const wrapper = input.closest('.sky-input-wrapper, .sky-textarea-wrapper');
    const label = wrapper ? wrapper.querySelector('.sky-label') : null;

    if (!label) return; // If no label is found, stop here to avoid errors

    const selectedOption = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : null;
    const hasDisplayedValue = input.value || input.placeholder || (selectedOption && selectedOption.text.trim());

    // Check if input has a value, placeholder, or selected option text
    if (hasDisplayedValue) {
      label.classList.add("label-up");
    } else {
      label.classList.remove("label-up");
    }
  }

  // Apply the behavior to all sky-input and sky-textarea fields
  const inputs = document.querySelectorAll(".sky-input, .sky-textarea");

  inputs.forEach(input => {
    // Check the input on page load
    updateLabelPosition(input);

    // Update label on input change
    input.addEventListener("input", function() {
      updateLabelPosition(input);
    });

    input.addEventListener("change", function() {
      updateLabelPosition(input);
    });

    // Optional: Update label on focus and blur to ensure smooth transition
    input.addEventListener("focus", function() {
      updateLabelPosition(input);
    });

    input.addEventListener("blur", function() {
      updateLabelPosition(input);
    });
  });
});

document.addEventListener("DOMContentLoaded", function() {
  // Function to move the label
  function updateLabelPosition(input, immediate = false) {
    const label = input.previousElementSibling;  // Get the previous sibling (label)

    if (label && label.classList.contains('sky-label')) {
      if (immediate) {
        label.style.transition = 'none';  // Disable transition on load
      }

      const selectedOption = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : null;
      const hasDisplayedValue = input.value || input.placeholder || (selectedOption && selectedOption.text.trim());

      // Check if input has a value, placeholder, selected option text, or is focused
      if (hasDisplayedValue || document.activeElement === input) {
        label.classList.add("label-up");
      } else {
        label.classList.remove("label-up");
      }

      if (immediate) {
        // Force a reflow and then re-enable the transition after load
        window.requestAnimationFrame(() => {
          label.style.transition = '';  // Re-enable transition
        });
      }
    }
  }

  // Get all sky-input and sky-textarea fields
  const inputs = document.querySelectorAll(".sky-input, .sky-textarea");

  inputs.forEach(input => {
    // Check the input on page load (disable animation during load)
    updateLabelPosition(input, true);

    // Update label on input change (with transition)
    input.addEventListener("input", function() {
      updateLabelPosition(input);
    });

    input.addEventListener("change", function() {
      updateLabelPosition(input);
    });

    // Move label up when focused (with transition)
    input.addEventListener("focus", function() {
      updateLabelPosition(input);
    });

    // Return label if input is empty on blur (with transition)
    input.addEventListener("blur", function() {
      updateLabelPosition(input);
    });
  });
});


function initBeforeAfterSliders(context) {
  if (!window.jQuery || !$.fn.slick) {
    return;
  }

  var $scope = context ? $(context) : $(document);

  $scope.find('.before-after-image-slider').each(function() {
    var $slider = $(this);
    var $wrapper = $slider.closest('.before-after-image-slider-wrapper');
    var transition = $slider.data('transition') || 'slide';
    var useFade = transition === 'fade';

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      draggable: false,
      swipe: false,
      touchMove: false,
      fade: useFade,
      infinite: false,
      speed: 400,
      easing: useFade ? 'linear' : 'ease-in-out',
      cssEase: useFade ? 'linear' : 'ease-in-out',
      touchThreshold: 8,
      appendDots: $wrapper.find('.before-after-slider-dots'),
      prevArrow: $wrapper.find('.before-after-slider-prev'),
      nextArrow: $wrapper.find('.before-after-slider-next')
    });
  });
}

function initBeforeAfterHandles(context) {
  var scope = context || document;
  var containers = scope.querySelectorAll(".before-after-image-section");
  
  containers.forEach((container) => {
    if (container.dataset.beforeAfterInit === "true") {
      return;
    }

    const beforeImage = container.querySelector(".before-image");
    const handle = container.querySelector(".before-after-image-section-handle");

    if (!beforeImage || !handle) {
      return;
    }

    container.dataset.beforeAfterInit = "true";
    let isDragging = false;

    var maxReveal = parseFloat(container.dataset.revealLimit || 100);
    if (isNaN(maxReveal)) {
      maxReveal = 100;
    }
    maxReveal = Math.min(Math.max(maxReveal, 50), 100);
    var minReveal = 100 - maxReveal;

    const updateSlider = (x) => {
      const rect = container.getBoundingClientRect();
      const offset = Math.max(0, Math.min(x - rect.left, rect.width)); // Clamp x within container bounds
      const rawPercentage = (offset / rect.width) * 100;
      const percentage = Math.max(minReveal, Math.min(rawPercentage, maxReveal));

      handle.style.left = `${percentage}%`;
      beforeImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
    };

    handle.addEventListener("mousedown", () => (isDragging = true));
    document.addEventListener("mouseup", () => (isDragging = false));
    document.addEventListener("mousemove", (e) => {
      if (isDragging) updateSlider(e.clientX);
    });

    // Touch events for mobile support
    container.addEventListener("touchstart", (e) => {
      isDragging = true;
      e.preventDefault(); // Prevent default scrolling behavior on touch start
    }, { passive: false });
    container.addEventListener("touchend", () => (isDragging = false));
    container.addEventListener("touchmove", (e) => {
      if (isDragging) {
        e.preventDefault(); // Prevent vertical scrolling while dragging
        updateSlider(e.touches[0].clientX);
      }
    }, { passive: false });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initBeforeAfterSliders(document);
  initBeforeAfterHandles(document);
});

document.addEventListener("shopify:section:load", (event) => {
  initBeforeAfterSliders(event.target);
  initBeforeAfterHandles(event.target);
});

document.addEventListener("shopify:block:select", (event) => {
  if (!window.jQuery || !$.fn.slick) {
    return;
  }

  var $block = $(event.target).closest('.before-after-image-section');
  if (!$block.length) {
    $block = $(event.target)
      .find('.before-after-image-section')
      .first();
  }
  if (!$block.length) {
    return;
  }

  var $slider = $block.closest('.before-after-image-slider');
  var slideIndex = $block.data('slick-index');

  if ($slider.length && $slider.hasClass('slick-initialized') && typeof slideIndex !== 'undefined') {
    $slider.slick('slickGoTo', slideIndex);
  }
});






function initializeMarqueeText(root = document) {
    root.querySelectorAll('.marquee-text').forEach(marquee => {
        if (marquee.dataset.marqueeInitialized === 'true') {
            return;
        }

        const marqueeTrack = marquee.querySelector('.marquee-text-track');
        if (!marqueeTrack) {
            return;
        }

        const items = Array.from(marqueeTrack.children);
        
        // Check if there are items to scroll
        if (items.length === 0) {
            console.warn("No marquee items found. Add blocks to enable scrolling.");
            return; // Exit the function if no items are found
        }

        let contentWidth = 0;

        // Calculate the total width of the original content, including separators
        items.forEach(item => { 
            contentWidth += item.offsetWidth; 
        });

        // Duplicate content to ensure enough width for seamless scrolling
        const containerWidth = marquee.clientWidth;
        while (contentWidth < containerWidth * 2) { 
            items.forEach(item => {
                const clone = item.cloneNode(true);
                marqueeTrack.appendChild(clone);
                contentWidth += clone.offsetWidth;
            });
        }

        // Retrieve scroll duration based on screen width
        const isMobile = window.innerWidth <= 768;
        const scrollDuration = parseFloat(
            marquee.dataset[isMobile ? 'scrollDurationMobile' : 'scrollDurationDesktop']
        ) || 20;

        // Calculate the pixels per second required for smooth scrolling
        const pixelsPerSecond = contentWidth / scrollDuration;
        const loopWidth = contentWidth / 2;
        let scrollPosition = 0;
        let isDragging = false;
        let lastPointerX = 0;

        marquee.dataset.marqueeInitialized = 'true';

        const isInteractive = marquee.dataset.marqueeInteractive === 'true';

        function normalizeScrollPosition() {
            if (!isInteractive) {
                if (Math.abs(scrollPosition) >= loopWidth) {
                    scrollPosition = 0;
                }
                return;
            }

            while (scrollPosition <= -loopWidth) {
                scrollPosition += loopWidth;
            }
            while (scrollPosition > 0) {
                scrollPosition -= loopWidth;
            }
        }

        if (isInteractive) {
            marquee.addEventListener('pointerdown', function(event) {
                if (event.button !== undefined && event.button !== 0) {
                    return;
                }

                isDragging = true;
                lastPointerX = event.clientX;
                marquee.classList.add('is-dragging');

                if (marquee.setPointerCapture) {
                    marquee.setPointerCapture(event.pointerId);
                }
            });

            marquee.addEventListener('pointermove', function(event) {
                if (!isDragging) {
                    return;
                }

                const deltaX = event.clientX - lastPointerX;
                lastPointerX = event.clientX;
                scrollPosition += deltaX;
                normalizeScrollPosition();
                marqueeTrack.style.transform = `translateX(${scrollPosition}px)`;

                if (event.cancelable) {
                    event.preventDefault();
                }
            });

            const endDrag = function(event) {
                if (!isDragging) {
                    return;
                }

                isDragging = false;
                marquee.classList.remove('is-dragging');

                if (marquee.releasePointerCapture) {
                    try {
                        marquee.releasePointerCapture(event.pointerId);
                    } catch (error) {
                        // Pointer capture can already be released by the browser.
                    }
                }
            };

            marquee.addEventListener('pointerup', endDrag);
            marquee.addEventListener('pointercancel', endDrag);
        }

        // Animation function for smooth, seamless scrolling
        function animateMarquee() {
            if (!document.documentElement.contains(marquee)) {
                return;
            }

            if (!isDragging) {
                scrollPosition -= pixelsPerSecond / 60; // Approximate 60 FPS
            }

            // Reset scroll position to ensure seamless looping
            normalizeScrollPosition();

            marqueeTrack.style.transform = `translateX(${scrollPosition}px)`;
            requestAnimationFrame(animateMarquee);
        }

        // Start the animation
        requestAnimationFrame(animateMarquee);
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initializeMarqueeText(document);
});

document.addEventListener('shopify:section:load', function(event) {
    initializeMarqueeText(event.target);
});







let isSearchDrawerOpen = false;

function showSearchDrawer() {
  const searchDrawer = document.getElementById('headerSearchDrawer');
  const searchContent = document.getElementById('headerSearchContent');
  const searchShadow = document.getElementById('headerSearchDrawerShadow');
  const searchClosebtn = document.getElementById('headerSearchClose');

  document.documentElement.classList.add('js-drawer-open');
  
  adjustSearchDrawerSize();

  isSearchDrawerOpen = true;

  searchDrawer.style.pointerEvents = "auto";
  searchShadow.style.pointerEvents = "auto";
  
  searchShadow.style.visibility = "visible";
  searchShadow.style.opacity = "1";

  setTimeout(() => {
    searchContent.style.opacity = "1";
    searchClosebtn.style.opacity = "1";
  }, 300);
}

function hideSearchDrawer() {
  const searchDrawer = document.getElementById('headerSearchDrawer');
  const searchContent = document.getElementById('headerSearchContent');
  const searchShadow = document.getElementById('headerSearchDrawerShadow');
  const searchClosebtn = document.getElementById('headerSearchClose');

  searchDrawer.style.pointerEvents = "none";
  searchShadow.style.pointerEvents = "none";
  
  searchContent.style.opacity = "0";

  document.documentElement.classList.remove('js-drawer-open');
  
  document.body.style.height = 'auto';
  document.documentElement.style.height = 'auto';

  setTimeout(() => {
    if (window.innerWidth <= 749) {
      searchDrawer.style.height = "0";
      searchShadow.style.opacity = "0";
      searchShadow.style.visibility = "hidden";
    } else {
      searchDrawer.style.height = "0";
      searchShadow.style.opacity = "0";
      searchShadow.style.visibility = "hidden";
    }   

    isSearchDrawerOpen = false;
  }, 300);
}

function adjustSearchDrawerSize() {
  const searchDrawer = document.getElementById('headerSearchDrawer');

  if (window.innerWidth <= 749) {
    searchDrawer.style.width = "calc(100% - 24px)";
    searchDrawer.style.height = "100px";
  } else {
    searchDrawer.style.height = "100px";
    searchDrawer.style.width = "calc(100% - 32px)";
  }
}

const textarea = document.querySelector('.sky-textarea');
if (textarea) {
  textarea.addEventListener('mousedown', () => {
    textarea.style.transition = 'none';
  });

  textarea.addEventListener('mouseup', () => {
    textarea.style.transition = 'border-color 0.2s ease, box-shadow 0.2s ease';
  });
}

let skyHeaderScrollHandler = null;
let skyHeaderResizeHandler = null;

function initializeHeader() {
  const header = document.querySelector('.sky-header');
  const mainContent = document.querySelector('.main-content');
  const element = document.querySelector('#skyHeader[data-header-section]');
  const stickyHost = element ? (element.closest('[id^="shopify-section-"]') || element) : null;

  if (!header || !element || !stickyHost) return; // Exit if necessary elements aren't available

  const stickyMode = element.dataset.stickyHeaderMode || 'not-sticky';

  if (skyHeaderScrollHandler) {
    window.removeEventListener('scroll', skyHeaderScrollHandler);
    skyHeaderScrollHandler = null;
  }
  if (skyHeaderResizeHandler) {
    window.removeEventListener('resize', skyHeaderResizeHandler);
    skyHeaderResizeHandler = null;
  }

  function getFirstVisibleSection() {
    const scope = mainContent || document;
    const sections = Array.prototype.slice.call(scope.querySelectorAll('.shopify-section'));

    for (let i = 0; i < sections.length; i += 1) {
      const section = sections[i];
      const style = window.getComputedStyle(section);
      const rect = section.getBoundingClientRect();

      if (style.display === 'none' || style.visibility === 'hidden' || rect.height === 0) {
        continue;
      }

      return section;
    }

    return null;
  }

  const firstSection = getFirstVisibleSection();
  const transparentHeaderAllowed = firstSection && firstSection.querySelector('.allow-transparent-header');

  const setTransparentState = () => {
    header.classList.add('sky-header-transparent');
    header.classList.remove('sky-header-solid');
  };

  const setSolidState = () => {
    header.classList.add('sky-header-solid');
    header.classList.remove('sky-header-transparent');
  };

  // Set initial header style based on transparency allowance
  if (transparentHeaderAllowed) {
    setTransparentState();
  } else {
    setSolidState();
  }

  stickyHost.classList.remove('sky-header-sticky-host', 'sky-header-sticky-host--hidden');
  header.classList.remove('sticky-header-blur');

  if (stickyMode === 'not-sticky') {
    return;
  }

  const headerOffsetTop = element.getBoundingClientRect().top + window.scrollY;
  let lastScrollY = window.scrollY;
  let hiddenScrollAnchorY = null;
  let visibleDownAnchorY = null;
  let stickyVisible = false;
  let headerAnimationFrame = null;
  let headerAnimationCleanupTimer = null;
  let isAnimatingOut = false;

  const clearHeaderAnimation = () => {
    if (headerAnimationFrame) {
      window.cancelAnimationFrame(headerAnimationFrame);
      headerAnimationFrame = null;
    }
    if (headerAnimationCleanupTimer) {
      window.clearTimeout(headerAnimationCleanupTimer);
      headerAnimationCleanupTimer = null;
    }
  };

  const resetHeaderAnimationStyles = () => {
    header.style.transition = '';
    header.style.transform = '';
    header.style.opacity = '';
  };

  const showStickyHeader = (animate) => {
    clearHeaderAnimation();
    isAnimatingOut = false;
    hiddenScrollAnchorY = null;
    visibleDownAnchorY = null;
    stickyVisible = true;

    stickyHost.classList.add('sky-header-sticky-host');
    stickyHost.classList.remove('sky-header-sticky-host--hidden');

    if (animate) {
      header.classList.remove('sticky-header-blur');
      header.style.transition = 'none';
      header.style.transform = 'translateY(calc(-100% - 8px))';
      header.style.opacity = '0';
      void header.offsetHeight;
      headerAnimationFrame = window.requestAnimationFrame(function () {
        headerAnimationFrame = window.requestAnimationFrame(function () {
          header.style.transition = 'transform 0.28s ease, opacity 0.28s ease';
          header.style.transform = 'translateY(0)';
          header.style.opacity = '1';
          header.classList.add('sticky-header-blur');
          headerAnimationCleanupTimer = window.setTimeout(function () {
            resetHeaderAnimationStyles();
            headerAnimationCleanupTimer = null;
          }, 320);
          headerAnimationFrame = null;
        });
      });
    } else {
      resetHeaderAnimationStyles();
      header.classList.add('sticky-header-blur');
    }
  };

  const hideStickyHeaderImmediate = (resetAnchors) => {
    clearHeaderAnimation();
    resetHeaderAnimationStyles();
    stickyHost.classList.remove('sky-header-sticky-host', 'sky-header-sticky-host--hidden');
    header.classList.remove('sticky-header-blur');
    stickyVisible = false;
    visibleDownAnchorY = null;
    isAnimatingOut = false;
    if (resetAnchors) {
      hiddenScrollAnchorY = null;
    }
  };

  const hideStickyHeaderAnimated = (currentScrollY) => {
    if (isAnimatingOut) {
      if (hiddenScrollAnchorY === null || currentScrollY > hiddenScrollAnchorY) {
        hiddenScrollAnchorY = currentScrollY;
      }
      return;
    }

    clearHeaderAnimation();
    isAnimatingOut = true;
    stickyVisible = false;
    visibleDownAnchorY = null;

    if (hiddenScrollAnchorY === null || currentScrollY > hiddenScrollAnchorY) {
      hiddenScrollAnchorY = currentScrollY;
    }

    stickyHost.classList.add('sky-header-sticky-host');
    stickyHost.classList.remove('sky-header-sticky-host--hidden');
    header.style.transition = 'transform 0.28s ease, opacity 0.28s ease';
    header.style.transform = 'translateY(calc(-100% - 8px))';
    header.style.opacity = '0';
    header.classList.remove('sticky-header-blur');

    headerAnimationCleanupTimer = window.setTimeout(function () {
      resetHeaderAnimationStyles();
      stickyHost.classList.remove('sky-header-sticky-host', 'sky-header-sticky-host--hidden');
      isAnimatingOut = false;
      headerAnimationCleanupTimer = null;
    }, 320);
  };

  const updateHiddenScrollAnchor = (currentScrollY) => {
    if (hiddenScrollAnchorY === null || currentScrollY > hiddenScrollAnchorY) {
      hiddenScrollAnchorY = currentScrollY;
    }
  };

  const onScroll = () => {
    const currentScrollY = window.scrollY;
    const isPastTop = currentScrollY > 0;
    const hasReachedStickyPoint = currentScrollY >= headerOffsetTop;
    const isScrollingUp = currentScrollY < lastScrollY;
    const isScrollingDown = currentScrollY > lastScrollY;

    if (stickyMode === 'always-sticky') {
      showStickyHeader(false);

      if (transparentHeaderAllowed && !isPastTop) {
        setTransparentState();
      } else {
        setSolidState();
      }
    } else if (stickyMode === 'scroll-up') {
      if (!hasReachedStickyPoint) {
        hideStickyHeaderImmediate(true);

        if (transparentHeaderAllowed) {
          setTransparentState();
        } else {
          setSolidState();
        }
      } else if (stickyVisible) {
        if (isScrollingDown) {
          if (visibleDownAnchorY === null) {
            visibleDownAnchorY = currentScrollY;
          }
          if ((currentScrollY - visibleDownAnchorY) >= 16) {
            hideStickyHeaderAnimated(currentScrollY);
          }
        } else if (isScrollingUp) {
          visibleDownAnchorY = null;
          showStickyHeader(false);
        }
        setSolidState();
      } else {
        if (isScrollingDown) {
          updateHiddenScrollAnchor(currentScrollY);
        }
        if (isScrollingUp && hiddenScrollAnchorY !== null && (hiddenScrollAnchorY - currentScrollY) >= 32) {
          showStickyHeader(true);
          setSolidState();
        } else if (!isAnimatingOut) {
          hideStickyHeaderImmediate(false);
          if (transparentHeaderAllowed) {
            setTransparentState();
          } else {
            setSolidState();
          }
        } else {
          setSolidState();
        }
      }
    } else {
      hideStickyHeaderImmediate(true);

      if (transparentHeaderAllowed && !isPastTop) {
        setTransparentState();
      } else {
        setSolidState();
      }
    }

    lastScrollY = currentScrollY;
  };

  if (stickyMode === 'always-sticky') {
    showStickyHeader(false);
  } else {
    hideStickyHeaderImmediate(true);
  }

  skyHeaderScrollHandler = onScroll;
  window.addEventListener('scroll', skyHeaderScrollHandler, { passive: true });
  skyHeaderResizeHandler = initializeHeader;
  window.addEventListener('resize', skyHeaderResizeHandler, { passive: true });
  onScroll();
}

// Reinitialize the header when sections are added or reloaded
document.addEventListener('shopify:section:load', initializeHeader);
document.addEventListener('shopify:section:unload', () => {
  if (skyHeaderScrollHandler) {
    window.removeEventListener('scroll', skyHeaderScrollHandler);
    skyHeaderScrollHandler = null;
  }
  if (skyHeaderResizeHandler) {
    window.removeEventListener('resize', skyHeaderResizeHandler);
    skyHeaderResizeHandler = null;
  }
});

// Initialize the header on page load
document.addEventListener("DOMContentLoaded", initializeHeader);


function initializeNavigation() {
  const headerSection = document.querySelector('#skyHeader[data-header-section]');
  const navigationWrapper = document.querySelector('.sky-header-navigation');
  const navigation = document.querySelector('.sky-navigation');
  const navigationList = document.querySelector('.sky-navigation-list');

  const desktopIcons = document.querySelector('.sky-header-icons');
  const mobileIconsLeft = document.querySelector('.sky-header-mobile-icons--left');
  const mobileIconsRight = document.querySelector('.sky-header-mobile-icons--right');
  const logo = document.querySelector('.sky-header-logo');

  if (!navigationWrapper || !navigation || !navigationList || !desktopIcons || !mobileIconsLeft || !mobileIconsRight || !logo) {
    return; // Exit if required elements are not found
  }

  function checkWidth() {
    const isDrawerLayout = headerSection && headerSection.dataset.headerLayout === 'drawer';

    if (isDrawerLayout || navigationList.offsetWidth >= navigation.offsetWidth) {
      navigationWrapper.style.position = 'absolute';
      navigationWrapper.style.left = '-9999px';
      navigationList.style.visibility = 'hidden';
      navigationList.style.opacity = '0';

      mobileIconsLeft.style.display = 'flex';
      mobileIconsRight.style.display = 'flex';
      desktopIcons.style.display = 'none';

      logo.classList.add('sky-header-logo--center');
    } else {
      navigationWrapper.style.position = 'static';
      navigationWrapper.style.left = '0';
      navigationList.style.visibility = 'visible';
      navigationList.style.opacity = '1';

      mobileIconsLeft.style.display = 'none';
      mobileIconsRight.style.display = 'none';
      desktopIcons.style.display = 'flex';

      logo.classList.remove('sky-header-logo--center');
    }
  }

  checkWidth();

  window.addEventListener('resize', checkWidth);

  // Cleanup function for the theme editor lifecycle
  return () => window.removeEventListener('resize', checkWidth);
}

// Initialize navigation when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', initializeNavigation);

// Handle Shopify theme editor lifecycle events
document.addEventListener('shopify:section:load', (event) => {
  const sectionId = event.detail.sectionId;
  const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);

  if (sectionElement && sectionElement.querySelector('.sky-header-navigation')) {
    initializeNavigation();
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const sectionId = event.detail.sectionId;
  const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);

  if (sectionElement && sectionElement.querySelector('.sky-header-navigation')) {
    // No specific cleanup needed here for now
  }
});




/********* Product Label + Selected Option *********/
function getGlobalSwatchSettings() {
  var settingsElement = document.getElementById('skyrocket-color-swatch-settings');
  if (!settingsElement) return null;

  try {
    return JSON.parse(settingsElement.textContent || '{}');
  } catch (error) {
    return null;
  }
}

function setSwatchButtonBackground(swatchButton, backgroundImage, backgroundColor) {
  swatchButton.style.backgroundImage = backgroundImage || 'none';
  swatchButton.style.backgroundColor = backgroundColor || 'transparent';
}

function applyGlobalSwatchSettings(root) {
  var swatchSettings = getGlobalSwatchSettings();
  if (!swatchSettings) return;

  var context = root && root.querySelectorAll ? root : document;
  var customColors = swatchSettings.customColors || {};
  var imageOverrides = swatchSettings.imageOverrides || {};
  var collectionSwatchSettings = swatchSettings.collectionSwatches || {};
  var collectionVisualMode = collectionSwatchSettings.visualMode || 'color';

  context.querySelectorAll('.color-swatch-button[data-swatch-handle]').forEach(function(swatchButton) {
    var swatchHandle = swatchButton.getAttribute('data-swatch-handle');
    var imageOverride = imageOverrides[swatchHandle];
    var hasLocalCustomColor = swatchButton.getAttribute('data-local-custom-color') === 'true';
    var variantImage = swatchButton.getAttribute('data-variant-image');
    var defaultColor = swatchButton.getAttribute('data-swatch-default-color') || '#CCCCCC';
    var defaultImage = swatchButton.getAttribute('data-swatch-default-image');
    var hasDefaultColorMatch = swatchButton.getAttribute('data-swatch-has-color-match') === 'true';
    var isProductGridSwatch = !!swatchButton.closest('.product-grid-swatches');
    var customColor = !hasLocalCustomColor && customColors[swatchHandle] ? customColors[swatchHandle] : null;
    var hasResolvedColor = hasDefaultColorMatch || !!customColor;
    var resolvedColor = customColor || defaultColor;

    if (imageOverride && imageOverride.type === 'svg' && imageOverride.svg) {
      setSwatchButtonBackground(
        swatchButton,
        'url("data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(imageOverride.svg) + '")',
        'transparent'
      );
      return;
    }

    if (imageOverride && imageOverride.type === 'image' && imageOverride.src) {
      setSwatchButtonBackground(swatchButton, 'url("' + imageOverride.src + '")', 'transparent');
      return;
    }

    if (isProductGridSwatch) {
      if (collectionVisualMode === 'variant_image' && variantImage) {
        setSwatchButtonBackground(swatchButton, 'url("' + variantImage + '")', 'transparent');
        return;
      }

      if (collectionVisualMode === 'variant_image_fallback' && variantImage && !hasResolvedColor) {
        setSwatchButtonBackground(swatchButton, 'url("' + variantImage + '")', 'transparent');
        return;
      }

      if (hasResolvedColor) {
        setSwatchButtonBackground(swatchButton, 'none', resolvedColor);
        return;
      }

      if (defaultImage) {
        setSwatchButtonBackground(swatchButton, 'url("' + defaultImage + '")', defaultColor);
        return;
      }

      setSwatchButtonBackground(swatchButton, 'none', defaultColor);
      return;
    }

    if (!variantImage && customColor) {
      setSwatchButtonBackground(swatchButton, 'none', customColor);
    }
  });
}

function applyProductGridSwatchSelection(button) {
  if (!button || !button.matches('[data-product-grid-swatch]')) return;

  var swatchWrapper = button.closest('[data-product-grid-swatches]');
  var swatchGroup = button.closest('[data-product-grid-swatch-group]');
  var productCard = button.closest('[data-product-grid-card]');
  var resolvedSelection = resolveProductGridSwatchSelection(button);
  var variantImage = resolvedSelection.mediaVariant && resolvedSelection.mediaVariant.image
    ? resolvedSelection.mediaVariant.image
    : button.getAttribute('data-variant-image');
  var variantUrl = resolvedSelection.targetVariant && resolvedSelection.targetVariant.url
    ? resolvedSelection.targetVariant.url
    : button.getAttribute('data-variant-url');

  if (swatchWrapper) {
    swatchWrapper.querySelectorAll('[data-product-grid-swatch]').forEach(function(swatchButton) {
      var isActive = swatchButton === button;
      swatchButton.classList.toggle('is-active', isActive);
      swatchButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  if (!productCard) return;

  if (resolvedSelection.targetVariant && resolvedSelection.targetVariant.id) {
    productCard.setAttribute('data-current-variant-id', resolvedSelection.targetVariant.id);
  }

  if (variantImage) {
    productCard.querySelectorAll('[data-product-grid-image]').forEach(function(imageElement) {
      imageElement.style.backgroundImage = 'url("' + variantImage + '")';
      imageElement.setAttribute('data-bg', variantImage);
    });
  }

  if (variantUrl) {
    productCard.querySelectorAll('[data-product-grid-link]').forEach(function(linkElement) {
      linkElement.setAttribute('href', variantUrl);
    });
  }

  if (swatchWrapper) {
    var collectionSwatchSettings = getCollectionSwatchSettings() || {};
    applyCollectionSwatchVisibility(swatchGroup, collectionSwatchSettings, productCard);
  }
}

function preloadProductGridImage(url) {
  if (!url) return;

  if (!window._productGridSwatchImageCache) {
    window._productGridSwatchImageCache = {};
  }

  if (window._productGridSwatchImageCache[url]) return;

  var image = new Image();
  image.decoding = 'async';
  image.src = url;
  window._productGridSwatchImageCache[url] = image;
}

function getProductGridVariantData(productCard) {
  if (!productCard) return [];
  if (productCard._productGridVariantData) return productCard._productGridVariantData;

  var swatchWrapper = productCard.querySelector('[data-product-grid-swatches]');
  var variantDataElement = swatchWrapper && swatchWrapper.querySelector('[data-product-grid-variants]');
  if (!variantDataElement) return [];

  try {
    productCard._productGridVariantData = JSON.parse(variantDataElement.textContent);
  } catch (error) {
    productCard._productGridVariantData = [];
  }

  return productCard._productGridVariantData;
}

function resolveProductGridSwatchSelection(button) {
  var emptyResult = {
    targetVariant: null,
    mediaVariant: null
  };
  if (!button || !button.matches('[data-product-grid-swatch]')) return emptyResult;

  var productCard = button.closest('[data-product-grid-card]');
  var swatchGroup = button.closest('[data-product-grid-swatch-group]');
  var variants = getProductGridVariantData(productCard);
  var optionIndex = swatchGroup ? parseInt(swatchGroup.getAttribute('data-option-index'), 10) : NaN;
  var swatchValue = button.getAttribute('data-swatch-value');

  if (!productCard || !swatchGroup || !variants.length || isNaN(optionIndex) || !swatchValue) {
    return emptyResult;
  }

  var currentVariantId = productCard.getAttribute('data-current-variant-id');
  var currentVariant = variants.find(function(variant) {
    return String(variant.id) === String(currentVariantId);
  }) || variants[0];

  var matchingVariants = variants.filter(function(variant) {
    return variant.options && variant.options[optionIndex] === swatchValue;
  });

  if (!matchingVariants.length) {
    return emptyResult;
  }

  var exactMatchingVariants = matchingVariants.filter(function(variant) {
    if (!currentVariant || !currentVariant.options) return true;

    return variant.options.every(function(optionValue, index) {
      if (index === optionIndex) return true;
      return optionValue === currentVariant.options[index];
    });
  });

  var targetVariant = exactMatchingVariants[0] || matchingVariants[0] || null;
  var mediaVariant = exactMatchingVariants.find(function(variant) {
    return !!variant.image;
  }) || matchingVariants.find(function(variant) {
    return !!variant.image;
  }) || targetVariant;

  return {
    targetVariant: targetVariant,
    mediaVariant: mediaVariant
  };
}

function preloadProductGridSwatchImages(productCard, swatchGroup) {
  if (!productCard) return;

  var variants = getProductGridVariantData(productCard);
  var urlsToPreload = {};

  if (Array.isArray(variants)) {
    variants.forEach(function(variant) {
      if (variant && variant.image) {
        urlsToPreload[variant.image] = true;
      }
    });
  }

  if (swatchGroup) {
    swatchGroup.querySelectorAll('[data-product-grid-swatch]').forEach(function(button) {
      var resolvedSelection = resolveProductGridSwatchSelection(button);
      var variantImage = resolvedSelection.mediaVariant && resolvedSelection.mediaVariant.image
        ? resolvedSelection.mediaVariant.image
        : button.getAttribute('data-variant-image');

      if (variantImage) {
        urlsToPreload[variantImage] = true;
      }
    });
  }

  Object.keys(urlsToPreload).forEach(preloadProductGridImage);
}

function getCollectionSwatchSettings() {
  var swatchSettings = getGlobalSwatchSettings();
  if (!swatchSettings) return null;

  var collectionSwatches = swatchSettings.collectionSwatches || null;
  if (!collectionSwatches) return null;

  if (collectionSwatches.size !== 'medium' && collectionSwatches.size !== 'small') {
    collectionSwatches.size = 'medium';
  }

  return collectionSwatches;
}

function normalizeSwatchTriggerList(optionTriggers) {
  if (!Array.isArray(optionTriggers)) return [];

  return optionTriggers
    .map(function(trigger) {
      return (trigger || '').toString().trim().toLowerCase();
    })
    .filter(Boolean);
}

function applyCollectionSwatchAppearance(swatchGroup, settings) {
  if (!swatchGroup || !settings) return;

  var swatchSize = settings.size || 'small';
  var useCircle = !!settings.circle;

  swatchGroup.querySelectorAll('.product-grid-swatch').forEach(function(swatchButton) {
    swatchButton.classList.remove('product-grid-swatch--small', 'product-grid-swatch--medium', 'product-grid-swatch--large');
    swatchButton.classList.add('product-grid-swatch--' + swatchSize);
  });

  swatchGroup.querySelectorAll('.color-swatch-button').forEach(function(swatchButton) {
    swatchButton.classList.remove('color-swatch-button--small', 'color-swatch-button--medium', 'color-swatch-button--large');
    swatchButton.classList.add('color-swatch-button--' + swatchSize);
    swatchButton.classList.toggle('color-swatch-button--circle', useCircle);
  });

  swatchGroup.querySelectorAll('.product-grid-swatch-overflow').forEach(function(overflowButton) {
    overflowButton.classList.remove(
      'product-grid-swatch-overflow--small',
      'product-grid-swatch-overflow--medium'
    );
    overflowButton.classList.add('product-grid-swatch-overflow--' + swatchSize);
  });
}

function applyCollectionSwatchPosition(productCard, swatchWrapper, settings) {
  if (!productCard || !swatchWrapper) return;

  var position = settings.position || 'below_price';
  var targetSlotName = 'below-price';

  if (position === 'above_title') {
    targetSlotName = 'above-title';
  } else if (position === 'below_title') {
    targetSlotName = 'below-title';
  } else if (position === 'overlay_image') {
    targetSlotName = 'overlay';
  }

  var targetSlot = productCard.querySelector('[data-product-grid-swatches-slot="' + targetSlotName + '"]');
  if (targetSlot && swatchWrapper.parentElement !== targetSlot) {
    targetSlot.appendChild(swatchWrapper);
  }

  swatchWrapper.classList.remove(
    'product-grid-swatches--position-above-title',
    'product-grid-swatches--position-below-title',
    'product-grid-swatches--position-below-price',
    'product-grid-swatches--position-overlay'
  );

  if (position === 'above_title') {
    swatchWrapper.classList.add('product-grid-swatches--position-above-title');
  } else if (position === 'below_title') {
    swatchWrapper.classList.add('product-grid-swatches--position-below-title');
  } else if (position === 'overlay_image') {
    swatchWrapper.classList.add('product-grid-swatches--position-overlay');
  } else {
    swatchWrapper.classList.add('product-grid-swatches--position-below-price');
  }
}

function applyCollectionSwatchVisibility(swatchGroup, settings, productCard) {
  if (!swatchGroup || !settings) return;

  var maxVisible = parseInt(settings.maxVisible, 10);
  var swatchButtons = Array.prototype.slice.call(
    swatchGroup.querySelectorAll('[data-product-grid-swatch]')
  );
  var existingOverflowButton = swatchGroup.querySelector('.product-grid-swatch-overflow');

  if (existingOverflowButton) {
    existingOverflowButton.remove();
  }

  swatchButtons.forEach(function(button) {
    button.hidden = false;
  });

  if (isNaN(maxVisible) || maxVisible <= 0 || swatchButtons.length <= maxVisible) {
    return;
  }

  var activeButton = swatchGroup.querySelector('[data-product-grid-swatch].is-active');
  var activeIndex = activeButton ? swatchButtons.indexOf(activeButton) : -1;
  var visibleButtons = swatchButtons.slice(0, maxVisible);

  if (activeIndex >= maxVisible && maxVisible > 0) {
    if (maxVisible === 1) {
      visibleButtons = [activeButton];
    } else {
      visibleButtons = swatchButtons.slice(0, maxVisible - 1);
      visibleButtons.push(activeButton);
    }
  }

  swatchButtons.forEach(function(button) {
    button.hidden = visibleButtons.indexOf(button) === -1;
  });

  var hiddenCount = swatchButtons.length - visibleButtons.length;
  if (hiddenCount <= 0) return;

  var overflowButton = document.createElement('button');
  var swatchSize = settings.size || 'small';
  var overflowLabel = document.createElement('span');
  overflowButton.type = 'button';
  overflowButton.className = 'product-grid-swatch-overflow product-grid-swatch-overflow--' + swatchSize;
  overflowButton.setAttribute('data-product-grid-swatch-overflow', '');
  overflowButton.setAttribute('aria-label', '+' + hiddenCount + ' more colors');
  overflowLabel.className = 'product-grid-swatch-overflow__label';
  overflowLabel.textContent = '+' + hiddenCount;
  overflowButton.appendChild(overflowLabel);
  swatchGroup.appendChild(overflowButton);
}

function initializeProductGridSwatches(root) {
  var context = root && root.querySelectorAll ? root : document;
  var collectionSwatchSettings = getCollectionSwatchSettings();
  var optionTriggers = normalizeSwatchTriggerList(collectionSwatchSettings && collectionSwatchSettings.optionTriggers);

  context.querySelectorAll('[data-product-grid-swatches]').forEach(function(swatchGroup) {
    var productCard = swatchGroup.closest('[data-product-grid-card]');
    var optionGroups = Array.prototype.slice.call(
      swatchGroup.querySelectorAll('[data-product-grid-swatch-group]')
    );
    var matchingGroup = optionGroups.find(function(group) {
      var optionName = (group.getAttribute('data-option-name') || '').trim().toLowerCase();
      return optionTriggers.indexOf(optionName) !== -1;
    });

    optionGroups.forEach(function(group) {
      group.hidden = group !== matchingGroup;
    });

    if (!matchingGroup) {
      swatchGroup.hidden = true;
      return;
    }

    swatchGroup.hidden = false;
    applyCollectionSwatchAppearance(matchingGroup, collectionSwatchSettings || {});
    applyCollectionSwatchPosition(productCard, swatchGroup, collectionSwatchSettings || {});
    preloadProductGridSwatchImages(productCard, matchingGroup);

    var activeButton =
      matchingGroup.querySelector('[data-product-grid-swatch].is-active') ||
      matchingGroup.querySelector('[data-product-grid-swatch]');

    if (activeButton) {
      applyProductGridSwatchSelection(activeButton);
    } else {
      applyCollectionSwatchVisibility(matchingGroup, collectionSwatchSettings || {}, productCard);
    }
  });
}

function scrollVariantCarouselOptionIntoView(input, instant) {
  if (!input || !input.matches('.variant-radio-option')) return;

  var button = input.closest('.variant-button');
  var wrapper = button && button.parentElement;
  if (!button || !wrapper || !wrapper.classList.contains('variant-button-wrapper--carousel')) return;

  var wrapperRect = wrapper.getBoundingClientRect();
  var buttonRect = button.getBoundingClientRect();
  var isOutOfView = buttonRect.left < wrapperRect.left || buttonRect.right > wrapperRect.right;

  if (!isOutOfView) return;

  var targetLeft =
    wrapper.scrollLeft +
    (buttonRect.left - wrapperRect.left) -
    (wrapper.clientWidth / 2) +
    (buttonRect.width / 2);
  var maxScrollLeft = Math.max(wrapper.scrollWidth - wrapper.clientWidth, 0);
  var clampedLeft = Math.min(Math.max(targetLeft, 0), maxScrollLeft);
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  wrapper.scrollTo({
    left: clampedLeft,
    behavior: instant || reduceMotion ? 'auto' : 'smooth'
  });
}

function syncVariantCarouselSelections(root, instant) {
  var context = root && root.querySelectorAll ? root : document;

  context.querySelectorAll('.variant-button-wrapper--carousel .variant-radio-option:checked').forEach(function(input) {
    scrollVariantCarouselOptionIntoView(input, instant);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  applyGlobalSwatchSettings(document);
  initializeProductGridSwatches(document);
  syncVariantCarouselSelections(document, true);
});

document.addEventListener('change', function(event) {
  if (!event.target.matches('.option-input, .variant-radio-option')) return;

  var optionIndex = event.target.getAttribute('data-index');
  var optionGroup = event.target.closest('.product-page-item');
  var productSection = event.target.closest('[data-section-type="product"]');
  var selectedValueElement = null;

  if (optionGroup) {
    selectedValueElement = optionGroup.querySelector('.selected-value[data-option-index="' + optionIndex + '"]');
  }

  if (!selectedValueElement && productSection) {
    selectedValueElement = productSection.querySelector('.selected-value[data-option-index="' + optionIndex + '"]');
  }

  if (!selectedValueElement) {
    selectedValueElement = document.querySelector('.selected-value[data-option-index="' + optionIndex + '"]');
  }

  if (selectedValueElement) {
    selectedValueElement.textContent = event.target.value;
  }

  if (event.target.matches('.variant-radio-option')) {
    scrollVariantCarouselOptionIntoView(event.target, false);
  }
});

document.addEventListener('click', function(event) {
  var swatchButton = event.target.closest('[data-product-grid-swatch]');
  if (swatchButton) {
    event.preventDefault();
    applyProductGridSwatchSelection(swatchButton);
    return;
  }

  var overflowButton = event.target.closest('[data-product-grid-swatch-overflow]');
  if (!overflowButton) return;

  event.preventDefault();
});

document.addEventListener('shopify:section:load', function(event) {
  applyGlobalSwatchSettings(document);
  initializeProductGridSwatches(document);
  syncVariantCarouselSelections(event.target, true);
});




document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form.add-to-cart-form').forEach((form) => {

    const button = form.querySelector('button[data-add-to-cart]');
    const addToCartText = button.querySelector('[data-add-to-cart-text]');



    form.addEventListener('submit', (event) => {
      event.preventDefault(); // Prevent default form submission

      const submitter = event.submitter || document.activeElement;
      const useSkyrocketDrawer = !!(submitter && submitter.hasAttribute('data-skyrocket-cart-open-on-submit'));

      const loader = button.querySelector('[data-loader]');
      const formData = new FormData(form);

      // Show the spinner and hide the text
      addToCartText.classList.add('hide');
      loader.classList.remove('hide');

      // Add to cart via Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log('Product added to cart:', data);

          setTimeout(() => {
            // Reset button state
            addToCartText.classList.remove('hide');
            loader.classList.add('hide');

            // Trigger cart drawer or other actions
            const cartDrawerApi = window.SkyrocketCartDrawer || window.SkyrocketCartDrawer || window.cartDrawer;
            if (useSkyrocketDrawer && cartDrawerApi && typeof cartDrawerApi.openAndRefresh === 'function') {
              cartDrawerApi.openAndRefresh();
              return;
            }
            if (typeof drawerOpen === 'function') {
              drawerOpen();
              carthtmldata();
            }
          }, 900);
        })
        .catch((error) => {
          console.error('Error adding product to cart:', error);

          // Reset button state in case of error
          addToCartText.classList.remove('hide');
          loader.classList.add('hide');
        });
    });
  });
});







/********* Scoped Newsletter Forms *********/
function initializeScopedNewsletterForms(root = document) {
  const wrappers = Array.from(root.querySelectorAll("[data-newsletter-form-wrapper]"));
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get("customer_posted") === "true";
  const submittedFormId = sessionStorage.getItem("newsletterSubmittedFormId");
  const singleWrapperId = wrappers.length === 1
    ? wrappers[0].getAttribute("data-newsletter-form-id")
    : null;

  wrappers.forEach((wrapper) => {
    const wrapperFormId = wrapper.getAttribute("data-newsletter-form-id");
    const form = wrapper.closest("form");
    const successMessage = wrapper.querySelector("[data-newsletter-success]");
    const fields = wrapper.querySelector("[data-newsletter-fields]");
    const errorMessage = wrapper.querySelector("[data-newsletter-error]");
    const emailInput = wrapper.querySelector("[data-newsletter-email]");
    const hasLiquidSuccess = wrapper.getAttribute("data-newsletter-posted-successfully") === "true";
    const hasLiquidError = wrapper.getAttribute("data-newsletter-has-error") === "true";
    const activeFormId = submittedFormId || singleWrapperId;
    const isSubmittedForm = activeFormId && wrapperFormId === activeFormId;
    const shouldShowSuccess = isSuccess && isSubmittedForm && hasLiquidSuccess;
    const shouldShowError = !isSuccess && isSubmittedForm && hasLiquidError;

    if (form && !form.dataset.newsletterScopedBound) {
      form.addEventListener("submit", () => {
        sessionStorage.setItem("newsletterSubmittedFormId", wrapperFormId);
      });
      form.dataset.newsletterScopedBound = "true";
    }

    if (successMessage) {
      successMessage.hidden = !shouldShowSuccess;
      successMessage.style.display = shouldShowSuccess ? "" : "none";
    }

    if (fields) {
      fields.style.display = shouldShowSuccess ? "none" : "";
    }

    if (errorMessage) {
      errorMessage.hidden = !shouldShowError;
      errorMessage.style.display = shouldShowError ? "" : "none";
    }

    if (emailInput && !shouldShowError) {
      emailInput.classList.remove("input--error");
      emailInput.removeAttribute("aria-invalid");
      emailInput.removeAttribute("aria-describedby");
      emailInput.removeAttribute("data-form-status");
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeScopedNewsletterForms();
});

document.addEventListener("shopify:section:load", (event) => {
  const sectionId = event.detail.sectionId;
  const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);

  if (sectionElement) {
    initializeScopedNewsletterForms(sectionElement);
  }
});

function initializeBackInStockForms(root = document) {
  const blocks = Array.from(root.querySelectorAll("[data-back-in-stock-block]"));
  if (!blocks.length) return;

  const stateMap = {};
  Array.from(root.querySelectorAll("[data-back-in-stock-form-state]")).forEach((node) => {
    const formId = node.getAttribute("data-back-in-stock-form-id");
    if (formId) stateMap[formId] = node;
  });

  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get("customer_posted") === "true";
  const submittedFormId = sessionStorage.getItem("backInStockSubmittedFormId");
  const singleBlockId = blocks.length === 1
    ? blocks[0].getAttribute("data-back-in-stock-form-id")
    : null;

  blocks.forEach((block) => {
    const formId = block.getAttribute("data-back-in-stock-form-id");
    const stateNode = formId ? stateMap[formId] : null;
    const proxyForm = formId ? document.getElementById(formId) : null;
    const successMessage = block.querySelector("[data-back-in-stock-success]");
    const fields = block.querySelector("[data-back-in-stock-fields]");
    const errorMessage = block.querySelector("[data-back-in-stock-error]");
    const errorText = block.querySelector("[data-back-in-stock-error-message]");
    const emailInput = block.querySelector("[data-back-in-stock-email]");
    const activeFormId = submittedFormId || singleBlockId;
    const isSubmittedForm = activeFormId && formId === activeFormId;
    const postedSuccessfully = stateNode && stateNode.getAttribute("data-posted-successfully") === "true";
    const hasError = stateNode && stateNode.getAttribute("data-has-error") === "true";
    const shouldShowSuccess = isSuccess && isSubmittedForm && postedSuccessfully;
    const shouldShowError = !isSuccess && isSubmittedForm && hasError;
    const errorValue = stateNode ? stateNode.getAttribute("data-error-message") || "" : "";
    const emailValue = stateNode ? stateNode.getAttribute("data-email") || "" : "";

    if (proxyForm && !proxyForm.dataset.backInStockBound) {
      proxyForm.addEventListener("submit", () => {
        sessionStorage.setItem("backInStockSubmittedFormId", formId);
      });
      proxyForm.dataset.backInStockBound = "true";
    }

    if (successMessage) {
      successMessage.hidden = !shouldShowSuccess;
      successMessage.style.display = shouldShowSuccess ? "" : "none";
    }

    if (fields) {
      fields.style.display = shouldShowSuccess ? "none" : "";
    }

    if (errorMessage) {
      errorMessage.hidden = !shouldShowError;
      errorMessage.style.display = shouldShowError ? "" : "none";
    }

    if (errorText) {
      errorText.textContent = shouldShowError ? errorValue : "";
    }

    if (emailInput) {
      if (shouldShowError) {
        emailInput.value = emailValue;
        emailInput.classList.add("input--error");
        emailInput.setAttribute("aria-invalid", "true");
        emailInput.setAttribute("aria-describedby", formId + "-email-error");
      } else {
        emailInput.classList.remove("input--error");
        emailInput.removeAttribute("aria-invalid");
        emailInput.removeAttribute("aria-describedby");
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeBackInStockForms();
});

document.addEventListener("shopify:section:load", (event) => {
  const sectionId = event.detail.sectionId;
  const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);

  if (sectionElement) {
    initializeBackInStockForms(sectionElement);
  }
});

/********* Newsletter Popup *********/
function initializeSkyPopupQueue() {
  if (window.SkyPopupQueue) {
    return window.SkyPopupQueue;
  }

  const queue = {
    items: new Map(),
    activeId: null,
    timer: null,
    timerId: null,

    register(item) {
      if (!item || !item.id || typeof item.show !== "function") {
        return;
      }

      if (item.storageKey && sessionStorage.getItem(item.storageKey)) {
        this.items.delete(item.id);
        this.schedule();
        return;
      }

      this.items.set(item.id, {
        ...item,
        delayMs: Math.max(0, Number(item.delayMs) || 0)
      });
      this.schedule();
    },

    complete(id) {
      if (this.activeId === id) {
        this.activeId = null;
      }

      this.items.delete(id);
      this.schedule();
    },

    schedule() {
      if (this.activeId) {
        return;
      }

      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
        this.timerId = null;
      }

      const nextItem = Array.from(this.items.values())
        .filter((item) => !item.storageKey || !sessionStorage.getItem(item.storageKey))
        .sort((a, b) => a.delayMs - b.delayMs)[0];

      if (!nextItem) {
        return;
      }

      this.timerId = nextItem.id;
      this.timer = setTimeout(() => {
        this.timer = null;
        this.timerId = null;

        const item = this.items.get(nextItem.id);
        if (!item || (item.storageKey && sessionStorage.getItem(item.storageKey))) {
          this.items.delete(nextItem.id);
          this.schedule();
          return;
        }

        if (this.activeId) {
          this.schedule();
          return;
        }

        this.activeId = item.id;
        item.show();
      }, nextItem.delayMs);
    }
  };

  window.SkyPopupQueue = queue;
  return queue;
}

function initializeNewsletterPopup() {
  const popup = document.getElementById("newsletter-popup-section");
  const overlay = document.getElementById("newsletter-popup-overlay");
  const formContainer = document.getElementById("newsletter-popup-form");
  const successContainer = document.getElementById("newsletter-popup-success");
  const closeButton = document.getElementById("newsletter-popup-close");
  const successCloseButton = document.getElementById("newsletter-popup-close-success");
  const popupForm = popup?.querySelector("form.newsletter-popup-form");
  const body = document.body;
  const hasPopupErrors = !!popupForm?.querySelector(".input-error-message");

  if (!popup || !overlay || !formContainer || !successContainer) {
    return;
  }

  if (popup.dataset.newsletterPopupInitialized === "true") {
    return;
  }

  popup.dataset.newsletterPopupInitialized = "true";

  requestAnimationFrame(() => {
    popup.classList.remove("newsletter-popup--initializing");
  });

  const popupDelay = parseInt(popup.getAttribute("data-popup-delay"), 10) || 3;

  const showPopup = (showSuccess = false, force = false) => {
    if (!force && sessionStorage.getItem("newsletterPopupShown")) {
      return;
    }

    overlay.classList.add("show");
    popup.classList.add("show");
    body.setAttribute("data-newsletter-popup-showing", "true");

    if (showSuccess) {
      formContainer.style.display = "none";
      successContainer.style.display = "block";
    } else {
      formContainer.style.display = "block";
      successContainer.style.display = "none";
    }
  };

  const closePopup = () => {
    overlay.classList.remove("show");
    popup.classList.remove("show", "instant");
    body.setAttribute("data-newsletter-popup-showing", "false");
    sessionStorage.setItem("newsletterPopupShown", "true");
    window.SkyPopupQueue?.complete("newsletter-popup");
  };

  if (window.location.pathname.includes("/challenge")) {
    return;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get("customer_posted") === "true";
  const wasPopupSubmission =
    sessionStorage.getItem("newsletterPopupSubmitted") === "true";

  if (isSuccess) {
    if (wasPopupSubmission) {
      initializeSkyPopupQueue().activeId = "newsletter-popup";
      showPopup(true, true);
      popup.classList.add("instant");
    }
    sessionStorage.removeItem("newsletterPopupSubmitted");
    sessionStorage.setItem("newsletterPopupShown", "true");
  } else if (hasPopupErrors && wasPopupSubmission) {
    initializeSkyPopupQueue().activeId = "newsletter-popup";
    showPopup(false, true);
    popup.classList.add("instant");
    sessionStorage.removeItem("newsletterPopupSubmitted");
  } else {
    initializeSkyPopupQueue().register({
      id: "newsletter-popup",
      delayMs: popupDelay * 1000,
      storageKey: "newsletterPopupShown",
      show: () => showPopup()
    });
  }

  const markPopupSubmission = () => {
    sessionStorage.setItem("newsletterPopupSubmitted", "true");
    sessionStorage.setItem("newsletterSubmittedFormId", popupForm?.id || "newsletter-popup");
  };

  popupForm?.addEventListener("submit", markPopupSubmission);

  closeButton?.addEventListener("click", closePopup);
  successCloseButton?.addEventListener("click", closePopup);

  window.showPopup = showPopup;
  window.closePopup = closePopup;

  return () => {
    popupForm?.removeEventListener("submit", markPopupSubmission);
    closeButton?.removeEventListener("click", closePopup);
    successCloseButton?.removeEventListener("click", closePopup);
  };
}

document.addEventListener("DOMContentLoaded", initializeNewsletterPopup);

document.addEventListener("shopify:section:load", (event) => {
  const sectionId = event.detail.sectionId;
  const sectionElement = document.querySelector(`[data-section-id="${sectionId}"]`);

  if (sectionElement && sectionElement.querySelector("#newsletter-popup-section")) {
    initializeNewsletterPopup();
  }
});



/********* Product icon with text alignment

function applyIconWithTextClasses(sectionElement = document) {
  // Select all elements with the class 'product-page-item--icon-with-text--list' within the given scope
  const iconWithTextLists = sectionElement.querySelectorAll('.product-page-item--icon-with-text--list');

  iconWithTextLists.forEach(list => {
    // Get all 'li' elements excluding those with the 'own-line' class
    const liItems = Array.from(list.querySelectorAll('li')).filter(
      li => !li.classList.contains('product-page-item--own-line')
    );
    const liCount = liItems.length; // Count the filtered 'li' elements

    // Map the number of 'li' elements to their corresponding class
    const sizeClasses = {
      1: 'product-page-item--icon-with-text--whole',
      2: 'product-page-item--icon-with-text--half',
      3: 'product-page-item--icon-with-text--third'
    };

    // Determine the appropriate class for the count
    const sizeClass = sizeClasses[Math.min(liCount, 3)] || '';

    // Apply the class to each filtered 'li' element
    liItems.forEach(li => {
      li.classList.add(sizeClass);
    });
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => applyIconWithTextClasses());

// Handle Shopify theme editor lifecycle events
document.addEventListener('shopify:section:load', (event) => {
  const sectionElement = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
  if (sectionElement) {
    applyIconWithTextClasses(sectionElement); // Reapply logic for the reloaded section
  }
});



document.addEventListener("DOMContentLoaded", function () {
  const cartNote = document.getElementById("cart-note");

  if (cartNote) {
    cartNote.addEventListener("input", function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: cartNote.value })
      })
      .then(response => {
        if (!response.ok) {
          console.error("Failed to update cart note.");
        }
      })
      .catch(error => console.error("Error:", error));
    });

    // Populate cart note field if there's already a note in the cart
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.note) {
          cartNote.value = cart.note;
        }
      })
      .catch(error => console.error("Error fetching cart data:", error));
  }
});
 *********/




/************* HOTSPOTS *************/
function positionHotspotPopupsInSection(section) {
  if (!section || window.innerWidth < 750) {
    return;
  }

  var indicators = section.querySelectorAll('[data-hotspot-indicator]');
  var viewportPadding = 24;
  var popupGap = 48;

  indicators.forEach(function(indicator) {
    var popupId = indicator.id.replace('indicator', 'popup');
    var popup = section.querySelector('#' + popupId);

    if (!popup) {
      return;
    }

    var indicatorRect = indicator.getBoundingClientRect();
    var anchorX = indicatorRect.left + (indicatorRect.width / 2);
    var popupWidth = popup.offsetWidth || Math.min(396, window.innerWidth - (viewportPadding * 2));
    var preferredRightOffset = popupGap;
    var preferredLeftOffset = -popupWidth - popupGap;
    var minOffset = viewportPadding - anchorX;
    var maxOffset = window.innerWidth - viewportPadding - popupWidth - anchorX;
    var canOpenRight = anchorX + preferredRightOffset + popupWidth <= window.innerWidth - viewportPadding;
    var canOpenLeft = anchorX + preferredLeftOffset >= viewportPadding;
    var offsetX = preferredRightOffset;

    if (canOpenRight) {
      offsetX = preferredRightOffset;
    } else if (canOpenLeft) {
      offsetX = preferredLeftOffset;
    } else {
      offsetX = Math.max(minOffset, Math.min(preferredRightOffset, maxOffset));
    }

    popup.style.transform = 'translate(' + offsetX + 'px, -50%)';
  });
}

function closeHotspotPopup(popup, indicator) {
  if (!popup) {
    return;
  }

  popup.style.transition = 'opacity 0.2s ease';
  popup.style.opacity = '0';

  window.setTimeout(function() {
    popup.classList.remove('visible-hotspot');
    popup.style.visibility = 'hidden';

    if (indicator) {
      indicator.classList.remove('rotate-plus');
    }
  }, 200);
}

function closeAllHotspotPopups(scope) {
  var root = scope || document;
  var popups = root.querySelectorAll('.hotspot-popup.visible-hotspot');
  var rotatingIndicators = root.querySelectorAll('.hotspot-indicator.rotate-plus');

  popups.forEach(function(popup) {
    closeHotspotPopup(popup);
  });

  rotatingIndicators.forEach(function(indicator) {
    indicator.classList.remove('rotate-plus');
  });
}

function initializeHotspotSection(section) {
  if (!section || section.dataset.hotspotInitialized === 'true') {
    positionHotspotPopupsInSection(section);
    return;
  }

  var indicators = section.querySelectorAll('[data-hotspot-indicator]');

  indicators.forEach(function(indicator) {
    indicator.addEventListener('click', function(event) {
      if (window.innerWidth < 750) {
        return;
      }

      var popupId = indicator.id.replace('indicator', 'popup');
      var popup = section.querySelector('#' + popupId);

      if (!popup) {
        return;
      }

      if (popup.classList.contains('visible-hotspot')) {
        closeHotspotPopup(popup, indicator);
      } else {
        closeAllHotspotPopups(section);
        popup.classList.add('visible-hotspot');
        popup.style.visibility = 'visible';
        popup.style.opacity = '1';
        indicator.classList.add('rotate-plus');
      }

      event.stopPropagation();
    });
  });

  section.dataset.hotspotInitialized = 'true';
  positionHotspotPopupsInSection(section);
}

function initializeHotspotSections(root) {
  var target = root || document;
  var sections = [];

  if (target.matches && target.matches('[data-hotspot-section]')) {
    sections.push(target);
  }

  sections = sections.concat(Array.prototype.slice.call(target.querySelectorAll ? target.querySelectorAll('[data-hotspot-section]') : []));

  sections.forEach(function(section) {
    initializeHotspotSection(section);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initializeHotspotSections(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initializeHotspotSections(event.target);
});

document.addEventListener('shopify:section:reorder', function(event) {
  initializeHotspotSections(event.target);
});

window.addEventListener('resize', function() {
  document.querySelectorAll('[data-hotspot-section]').forEach(function(section) {
    positionHotspotPopupsInSection(section);
  });
});

document.addEventListener('click', function (event) {
  var clickedInsidePopup = event.target.closest('.hotspot-popup') || event.target.closest('[data-hotspot-indicator]');

  if (!clickedInsidePopup) {
    closeAllHotspotPopups(document);
  }
});



/***************** CHECK PRODUCT GRID TAGS SETTINGS *****************/

document.addEventListener('DOMContentLoaded', function () {
  const tagsToDisplayElement = document.getElementById('tags-to-display');
  if (!tagsToDisplayElement) return;

  const tagsToDisplay = parseInt(tagsToDisplayElement.dataset.tagsToDisplay, 10);
  const showTagIcon = tagsToDisplayElement.dataset.showTagIcon === 'true';

  const productGrids = document.querySelectorAll('.product-grid-tags');
  if (!productGrids.length) return;

  productGrids.forEach((grid) => {
    const tags = grid.querySelectorAll('.product-grid-tags-item');
    const icons = grid.querySelectorAll('.product-grid-tags-icon');

    icons.forEach((icon) => {
      icon.style.display = showTagIcon ? 'inline-block' : 'none';
    });

    tags.forEach((tag, index) => {
      if (index >= tagsToDisplay) {
        tag.style.display = 'none';
      }
    });
  });
});

/***************** CHECK PRODUCT GRID SAVINGS SETTINGS *****************/

document.addEventListener('DOMContentLoaded', function () {
  const savingsSettingsElement = document.getElementById('product-grid-savings');
  if (!savingsSettingsElement) return;

  const showMoney = savingsSettingsElement.dataset.productGridSavingsShowMoney === 'true';
  const showPercent = savingsSettingsElement.dataset.productGridSavingsShowPercent === 'true';

  const savingsItems = document.querySelectorAll('.product-grid-savings-item');

  savingsItems.forEach((item) => {
    const moneySpan = item.querySelector('[data-product-grid-savings-money]');
    const percentSpan = item.querySelector('[data-product-grid-savings-percent]');
    const moneyPercentSpan = item.querySelector('[data-product-grid-savings-money-percent]');

    if (showMoney && showPercent) {
      if (moneySpan) moneySpan.style.display = 'none';
      if (percentSpan) percentSpan.style.display = 'none';
      if (moneyPercentSpan) moneyPercentSpan.style.display = 'inline-block';
    } else if (showMoney) {
      if (moneySpan) moneySpan.style.display = 'inline-block';
      if (percentSpan) percentSpan.style.display = 'none';
      if (moneyPercentSpan) moneyPercentSpan.style.display = 'none';
    } else if (showPercent) {
      if (moneySpan) moneySpan.style.display = 'none';
      if (percentSpan) percentSpan.style.display = 'inline-block';
      if (moneyPercentSpan) moneyPercentSpan.style.display = 'none';
    } else {
      if (moneySpan) moneySpan.style.display = 'none';
      if (percentSpan) percentSpan.style.display = 'none';
      if (moneyPercentSpan) moneyPercentSpan.style.display = 'none';
    }
  });
});



/***************** SKY VIDEO *****************/

function initSkyVideoSections() {
  document.querySelectorAll(".sky-video-container").forEach(container => {
    if (container.dataset.initialized) return;
    container.dataset.initialized = true;

    const video = container.querySelector(".sky-video");
    const playButton = container.querySelector(".video-play-button");
    const muteButton = container.querySelector(".mute-btn");
    const muteIcon = muteButton ? muteButton.querySelector("i") : null;
    const progressBar = container.querySelector(".progress-bar");
    const progressIndicator = container.querySelector(".progress-indicator");
    const fullscreenButton = container.querySelector(".fullscreen-btn");
    const canvas = container.querySelector(".video-canvas");
    const ctx = canvas ? canvas.getContext("2d") : null;

    const autoplayEnabled = container.dataset.autoplay === "true";
    const loopEnabled = container.dataset.loop === "true";
    const showMuteButton = container.dataset.showMute === "true";
    const muteVideo = container.dataset.mute === "true";
    const showProgressBar = container.dataset.showProgress === "true";
    const frameCaptureTime = parseFloat(container.dataset.frameTime) || 1;
    const showExpandButton = container.dataset.showExpand === "true";
    const videoDimensions = container.dataset.videoDimensions;

    if (videoDimensions === "original") {
      video.preload = "metadata"; 
      video.load();

      video.addEventListener("loadedmetadata", function () {
        let videoWidth = video.videoWidth;
        let videoHeight = video.videoHeight;

        if (videoWidth === 0 || videoHeight === 0) {
          setTimeout(() => {
            videoWidth = video.videoWidth;
            videoHeight = video.videoHeight;
            applyAspectRatio(videoWidth, videoHeight);
          }, 500);
        } else {
          applyAspectRatio(videoWidth, videoHeight);
        }
      });
    }

    video.addEventListener("play", () => {
      const placeholder = container.querySelector(".video-placeholder");
      if (placeholder) {
        placeholder.style.display = "none";
      }
    });

    function applyAspectRatio(width, height) {
      if (width > 0 && height > 0) {
        container.style.aspectRatio = width / height;
      }
    }

    if (!showExpandButton && fullscreenButton) {
      fullscreenButton.style.display = "none";
    } else if (fullscreenButton) {
      fullscreenButton.addEventListener("click", toggleFullscreen);
    }

    const preventToggle = container.dataset.preventToggle === "true";

    if (autoplayEnabled) {
      video.setAttribute("autoplay", "true");
      video.muted = true;
      if (playButton) playButton.style.opacity = "0";
    } else {
      video.removeAttribute("autoplay");
    }

    if (autoplayEnabled && preventToggle) {
      if (playButton) playButton.style.display = "none";
      video.removeEventListener("click", togglePlayPause);
      if (playButton) playButton.removeEventListener("click", togglePlayPause);

      video.addEventListener("play", () => video.controls = false);
      video.addEventListener("pause", () => video.play());
    }

    if (muteVideo && !showMuteButton && muteButton) {
      muteButton.style.display = "none";
    }

    function updateMuteIcon() {
      if (muteIcon) {
        muteIcon.classList.toggle("fa-volume", !video.muted);
        muteIcon.classList.toggle("fa-volume-slash", video.muted);
      }
    }

    function togglePlayPause() {
      if (video.paused) {
        video.play();
        if (playButton) playButton.style.opacity = "0";
      } else {
        video.pause();
        if (playButton) playButton.style.opacity = "1";
      }
    }

    function toggleMute() {
      video.muted = !video.muted;
      updateMuteIcon();
    }

    function updateProgressBar() {
      if (!progressIndicator) return;
      const progress = (video.currentTime / video.duration) * 100;
      progressIndicator.style.width = progress + "%";
    }

    function seekVideo(event) {
      if (!progressBar) return;
      const rect = progressBar.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const newTime = (offsetX / rect.width) * video.duration;
      video.currentTime = newTime;
    }

    let isDragging = false;

    function startDrag(event) {
      isDragging = true;
      seekVideo(event);
      document.addEventListener("mousemove", dragSeek);
      document.addEventListener("mouseup", stopDrag);
    }

    function dragSeek(event) {
      if (isDragging) {
        seekVideo(event);
      }
    }

    function stopDrag() {
      isDragging = false;
      document.removeEventListener("mousemove", dragSeek);
      document.removeEventListener("mouseup", stopDrag);
    }

    function toggleFullscreen() {
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.mozRequestFullScreen) {
          video.mozRequestFullScreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    }
    
    document.addEventListener("fullscreenchange", forceUIUpdate);
    document.addEventListener("webkitfullscreenchange", forceUIUpdate);
    
    function forceUIUpdate() {
      document.querySelectorAll(".sky-video-container").forEach(container => {
        const playButton = container.querySelector(".video-play-button");
        const muteButton = container.querySelector(".mute-btn");
        const progressBar = container.querySelector(".progress-bar");
        const fullscreenButton = container.querySelector(".fullscreen-btn");
    
        const showMuteButton = container.dataset.showMute === "true";
        const showProgressBar = container.dataset.showProgress === "true";
        const showExpandButton = container.dataset.showExpand === "true";
    
        if (!document.fullscreenElement && !document.webkitFullscreenElement) {
          if (playButton) {
            playButton.style.display = "none";
            setTimeout(() => (playButton.style.display = "flex"), 50);
          }
    
          if (fullscreenButton) {
            fullscreenButton.style.display = "none";
            setTimeout(() => (fullscreenButton.style.display = showExpandButton ? "flex" : "none"), 50);
          }
    
          if (muteButton) {
            muteButton.style.display = "none";
            setTimeout(() => (muteButton.style.display = showMuteButton ? "flex" : "none"), 50);
          }
    
          if (progressBar) {
            progressBar.style.display = "none";
            setTimeout(() => (progressBar.style.display = showProgressBar ? "block" : "none"), 50);
          }
        }
      });
    }

    const hasPoster = video.hasAttribute("poster") && video.getAttribute("poster") !== "";
    let posterCaptured = false;
    let posterSeekRequested = false;
    let generatedPoster = null;

    function showGeneratedPoster(src) {
      if (!generatedPoster) {
        generatedPoster = document.createElement("img");
        generatedPoster.className = "sky-video-generated-poster";
        generatedPoster.alt = "";
        generatedPoster.setAttribute("aria-hidden", "true");
        generatedPoster.style.position = "absolute";
        generatedPoster.style.inset = "0";
        generatedPoster.style.width = "100%";
        generatedPoster.style.height = "100%";
        generatedPoster.style.objectFit = "cover";
        generatedPoster.style.pointerEvents = "none";
        container.insertBefore(generatedPoster, canvas || video.nextSibling);
      }

      generatedPoster.src = src;
      generatedPoster.style.display = video.paused ? "block" : "none";
    }

    function captureFrame() {
      try {
        if (!ctx || posterCaptured || video.videoWidth === 0 || video.videoHeight === 0) return false;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        if (canvas.width === 0 || canvas.height === 0) {
          return false;
        }

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const posterSrc = canvas.toDataURL("image/jpeg", 0.86);
        video.setAttribute("poster", posterSrc);
        showGeneratedPoster(posterSrc);
        posterCaptured = true;
        return true;
      } catch (error) {
        console.error("Failed to capture video frame:", error);
        return false;
      }
    }

    if (!hasPoster) {
      function handlePosterFrameReady() {
        if (posterCaptured) return;

        if (posterSeekRequested && video.readyState >= 2 && captureFrame()) {
          return;
        }

        seekToPosterFrame();
      }

      function seekToPosterFrame() {
        if (posterCaptured || posterSeekRequested || video.readyState < 1) return;

        const duration = Number.isFinite(video.duration) ? video.duration : 0;
        const maxPosterTime = duration > 0 ? Math.max(0, duration - 0.1) : frameCaptureTime;
        const posterTime = Math.min(Math.max(frameCaptureTime, 0), maxPosterTime);

        try {
          posterSeekRequested = true;
          video.currentTime = posterTime;
          setTimeout(handlePosterFrameReady, 250);
        } catch (error) {
          posterSeekRequested = false;
        }
      }

      video.preload = "metadata";
      video.addEventListener("loadedmetadata", seekToPosterFrame);
      video.addEventListener("loadeddata", handlePosterFrameReady);
      video.addEventListener("canplay", handlePosterFrameReady);
      video.addEventListener("seeked", captureFrame);

      if (video.readyState >= 2) {
        handlePosterFrameReady();
      } else if (video.readyState >= 1) {
        seekToPosterFrame();
      } else {
        video.load();
      }
    }

    video.addEventListener("play", () => {
      if (generatedPoster) {
        generatedPoster.style.display = "none";
      }
    });

    if (playButton) playButton.addEventListener("click", togglePlayPause);
    video.addEventListener("click", togglePlayPause);
    video.addEventListener("ended", () => {
      if (playButton) playButton.style.opacity = "1";
    });

    if (muteButton) muteButton.addEventListener("click", toggleMute);
    video.addEventListener("timeupdate", updateProgressBar);
    video.addEventListener("play", updateProgressBar);
    video.addEventListener("seeked", updateProgressBar);

    if (progressBar) progressBar.addEventListener("mousedown", startDrag);
    if (progressIndicator) progressIndicator.addEventListener("mousedown", startDrag);

    if (fullscreenButton) fullscreenButton.addEventListener("click", toggleFullscreen);

    updateMuteIcon();
  });
}

document.addEventListener("DOMContentLoaded", initSkyVideoSections);

if (Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:load", initSkyVideoSections);
  document.addEventListener("shopify:section:unload", initSkyVideoSections);
} 




/* ================ Cross-sell bundle add-on (copy/paste safe) ================ */
(function() {
  if (!window.theme || !theme.Product || !theme.Product.prototype) return;

  var proto = theme.Product.prototype;

  proto._getCrossSellItems = function() {
    var $checked = this.$container.find('.cross-sell-bundle__checkbox:checked');
    if ($checked.length === 0) {
      return [];
    }

    var $bundle = this.$container.find('.js-cross-sell-bundle').first();
    var currentProductId = $bundle.length ? String($bundle.data('current-product-id')) : null;
    var items = [];
    var seen = {};

    $checked.each(function() {
      var $checkbox = $(this);
      var $bundle = $checkbox.closest('.js-cross-sell-bundle');
      if ($bundle.hasClass('cross-sell-bundle--hidden')) {
        return;
      }
      var variantId = parseInt($checkbox.data('variant-id'), 10);
      if (!variantId) {
        return;
      }
      var productId = $checkbox.data('product-id');
      if (currentProductId && productId && String(productId) === currentProductId) {
        return;
      }
      if (!seen[variantId]) {
        seen[variantId] = true;
        items.push({ id: variantId, quantity: 1 });
      }
    });

    return items;
  };

  proto._getOneClickUpsellItems = function() {
    var items = [];

    this.$container.find('[data-product-oneclick-upsell]').each(function() {
      var $card = $(this);
      if (!$card.length || $card.attr('data-available') !== 'true') {
        return;
      }

      var quantity = 1;
      if ($card.attr('data-control-type') === 'quantity') {
        quantity = parseInt($card.find('[data-product-oneclick-qty]').val(), 10);
      } else if (!$card.find('[data-product-oneclick-toggle]').is(':checked')) {
        return;
      }

      if (!quantity || quantity < 1) {
        return;
      }

      var variantId = parseInt($card.attr('data-variant-id'), 10);
      if (!variantId) {
        return;
      }

      items.push({
        id: variantId,
        quantity: quantity,
        properties: {
          _skyrocket_product_page_upsell: 'true'
        }
      });
    });

    return items;
  };

  proto._getProductRecommendationItems = function() {
    var items = [];

    this.$container.find('[data-product-recommendation-item][data-mode="staged"].is-selected').each(function() {
      var $card = $(this);
      if (!$card.length || $card.attr('data-available') !== 'true') {
        return;
      }

      var variantId = parseInt($card.attr('data-variant-id'), 10);
      if (!variantId) {
        return;
      }

      var quantity = parseInt($card.find('[data-product-recommendation-qty]').val(), 10);
      quantity = isNaN(quantity) || quantity < 1 ? 1 : quantity;

      items.push({
        id: variantId,
        quantity: quantity,
        properties: {
          _skyrocket_product_recommendation: 'true'
        }
      });
    });

    return items;
  };

  proto._getProductAddOnItems = function() {
    var items = this._getCrossSellItems().concat(this._getOneClickUpsellItems(), this._getProductRecommendationItems());
    var seen = {};
    return items.filter(function(item) {
      var key = String(item.id) + ':' + JSON.stringify(item.properties || {});
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  function setOneClickQuantityState($control, quantity, immediateButtonsVisible) {
    if (!$control || !$control.length) return;

    var widthTimer = $control.data('oneclickQtyWidthTimer');
    var buttonsTimer = $control.data('oneclickQtyButtonsTimer');
    if (widthTimer) {
      window.clearTimeout(widthTimer);
      $control.removeData('oneclickQtyWidthTimer');
    }
    if (buttonsTimer) {
      window.clearTimeout(buttonsTimer);
      $control.removeData('oneclickQtyButtonsTimer');
    }

    var $input = $control.find('[data-product-oneclick-qty]').first();
    var $toggle = $control.find('[data-product-oneclick-toggle]').first();
    if ($input.length) $input.val(quantity);
    if ($toggle.length) $toggle.prop('checked', quantity > 0);

    if (quantity > 0) {
      $control.removeClass('is-empty');
      $control.addClass('is-expanded');

      if (immediateButtonsVisible) {
        $control.addClass('is-buttons-visible');
        return;
      }

      buttonsTimer = window.setTimeout(function() {
        $control.addClass('is-buttons-visible');
        $control.removeData('oneclickQtyButtonsTimer');
      }, 250);

      $control.data('oneclickQtyButtonsTimer', buttonsTimer);
      return;
    }

    $control.removeClass('is-buttons-visible');

    widthTimer = window.setTimeout(function() {
      $control.removeClass('is-expanded').addClass('is-empty');
      $control.removeData('oneclickQtyWidthTimer');
    }, 250);

    $control.data('oneclickQtyWidthTimer', widthTimer);
  }

  $(document).off('click.skyrocketOneClickQuantity').on('click.skyrocketOneClickQuantity', '[data-product-oneclick-qty-plus], [data-product-oneclick-qty-minus]', function(event) {
    event.preventDefault();

    var $button = $(this);
    var $control = $button.closest('[data-product-oneclick-quantity-control]');
    var $card = $button.closest('[data-product-oneclick-upsell]');
    if (!$control.length || !$card.length || $card.attr('data-available') !== 'true') {
      return;
    }

    var $input = $control.find('[data-product-oneclick-qty]');
    var quantity = parseInt($input.val(), 10);
    quantity = isNaN(quantity) ? 0 : quantity;

    if ($button.is('[data-product-oneclick-qty-plus]')) {
      quantity += 1;
    } else {
      quantity = Math.max(quantity - 1, 0);
    }

    setOneClickQuantityState($control, quantity, quantity > 0);
  });

  $(document).off('input.skyrocketOneClickQuantityInput').on('input.skyrocketOneClickQuantityInput', '[data-product-oneclick-qty]', function() {
    var $input = $(this);
    var sanitized = String($input.val() || '').replace(/[^\d]/g, '');
    $input.val(sanitized);
  });

  $(document).off('change.skyrocketOneClickQuantityInput blur.skyrocketOneClickQuantityInput').on('change.skyrocketOneClickQuantityInput blur.skyrocketOneClickQuantityInput', '[data-product-oneclick-qty]', function() {
    var $input = $(this);
    var $control = $input.closest('[data-product-oneclick-quantity-control]');
    var quantity = parseInt($input.val(), 10);
    quantity = isNaN(quantity) || quantity < 0 ? 0 : quantity;
    setOneClickQuantityState($control, quantity, quantity > 0);
  });

  $(document).off('click.skyrocketOneClickCardToggle').on('click.skyrocketOneClickCardToggle', '[data-product-oneclick-card-toggle]', function(event) {
    if ($(event.target).closest('a, button, input, label, select, textarea, [data-product-oneclick-quantity-control]').length) {
      return;
    }

    var $card = $(this);
    if ($card.attr('data-available') !== 'true' || $card.attr('data-control-type') === 'quantity') {
      return;
    }

    var $toggle = $card.find('[data-product-oneclick-toggle]').first();
    if (!$toggle.length || $toggle.prop('disabled')) {
      return;
    }

    $toggle.prop('checked', !$toggle.prop('checked')).trigger('change');
  });

  function skyrocketRecommendationFormatMoney(cents) {
    cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function updateRecommendationButton($card) {
    var $button = $card.find('[data-product-recommendation-button]').first();
    var $label = $button.find('[data-product-recommendation-button-label]').first();
    if (!$button.length) return;

    var available = $card.attr('data-available') === 'true';
    var selected = $card.hasClass('is-selected');
    var addLabel = $button.attr('data-label-add') || 'Add';
    var addedLabel = $button.attr('data-label-added') || 'Added';
    var soldOutLabel = $button.attr('data-label-sold-out') || 'Sold out';

    $button.prop('disabled', !available);
    $button.toggleClass('is-selected', selected);
    if ($label.length) {
      $label.text(available ? (selected ? addedLabel : addLabel) : soldOutLabel);
    } else {
      $button.text(available ? (selected ? addedLabel : addLabel) : soldOutLabel);
    }
  }

  function setRecommendationSelected($card, selected) {
    $card.toggleClass('is-selected', !!selected);
    $card.attr('data-selected', selected ? 'true' : 'false');
    updateRecommendationButton($card);
    $card.trigger('change');
  }

  function setRecommendationQuantityExpanded($control, expanded) {
    if (!$control || !$control.length || !$control.is('[data-product-recommendation-qty-minimal]')) return;
    var widthTimer = $control.data('qtyWidthTimer');
    var buttonsTimer = $control.data('qtyButtonsTimer');
    if (widthTimer) {
      window.clearTimeout(widthTimer);
      $control.removeData('qtyWidthTimer');
    }
    if (buttonsTimer) {
      window.clearTimeout(buttonsTimer);
      $control.removeData('qtyButtonsTimer');
    }

    if (expanded) {
      $control.addClass('is-expanded');
      $control.attr('data-qty-expanded', 'true');

      buttonsTimer = window.setTimeout(function() {
        $control.addClass('is-buttons-visible');
        $control.removeData('qtyButtonsTimer');
      }, 250);

      $control.data('qtyButtonsTimer', buttonsTimer);
      return;
    }

    $control.removeClass('is-buttons-visible');
    $control.attr('data-qty-expanded', 'false');

    widthTimer = window.setTimeout(function() {
      $control.removeClass('is-expanded');
      $control.removeData('qtyWidthTimer');
    }, 250);

    $control.data('qtyWidthTimer', widthTimer);
  }

  $(document).off('change.skyrocketProductRecommendationVariant').on('change.skyrocketProductRecommendationVariant', '[data-product-recommendation-variant]', function() {
    var $select = $(this);
    var $option = $select.find('option:selected');
    var $card = $select.closest('[data-product-recommendation-item]');
    if (!$card.length || !$option.length) return;
    var previousVariantId = String($card.attr('data-variant-id') || '');

    var price = parseInt($option.attr('data-price'), 10) || 0;
    var compare = parseInt($option.attr('data-compare-at-price'), 10) || 0;
    var available = $option.attr('data-available') === 'true';
    var image = $option.attr('data-image');
    var nextVariantId = String($option.val() || '');
    var variantChanged = previousVariantId !== '' && previousVariantId !== nextVariantId;

    $card.attr('data-variant-id', $option.val());
    $card.attr('data-variant-price', price);
    $card.attr('data-variant-compare-at-price', compare);
    $card.attr('data-available', available ? 'true' : 'false');

    $card.find('[data-product-recommendation-price]').text(price === 0 ? 'FREE' : skyrocketRecommendationFormatMoney(price));
    var $compare = $card.find('[data-product-recommendation-compare]');
    if (compare > price) {
      $compare.text(skyrocketRecommendationFormatMoney(compare)).removeClass('hide');
    } else {
      $compare.text('').addClass('hide');
    }
    $card.find('[data-product-recommendation-qty-control]').toggleClass('is-disabled', !available);

    if (image) {
      $card.find('.sky-product-recommendations__image').attr('src', image).attr('srcset', '');
    }

    if (!available) {
      setRecommendationSelected($card, false);
    } else if (variantChanged && $card.hasClass('is-selected')) {
      setRecommendationSelected($card, false);
    } else {
      updateRecommendationButton($card);
    }
  });

  $(document).off('click.skyrocketProductRecommendationQuantity').on('click.skyrocketProductRecommendationQuantity', '[data-product-recommendation-qty-plus], [data-product-recommendation-qty-minus]', function(event) {
    event.preventDefault();
    var $button = $(this);
    var $control = $button.closest('[data-product-recommendation-qty-control]');
    var $input = $control.find('[data-product-recommendation-qty]').first();
    if (!$input.length) return;

    setRecommendationQuantityExpanded($control, true);

    var quantity = parseInt($input.val(), 10);
    quantity = isNaN(quantity) || quantity < 1 ? 1 : quantity;
    if ($button.is('[data-product-recommendation-qty-plus]')) {
      quantity += 1;
    } else {
      quantity = Math.max(quantity - 1, 1);
    }
    $input.val(quantity).trigger('change');
  });

  $(document).off('click.skyrocketProductRecommendationQuantityMinimal').on('click.skyrocketProductRecommendationQuantityMinimal', '[data-product-recommendation-qty-minimal]', function(event) {
    if ($(event.target).closest('[data-product-recommendation-qty-plus], [data-product-recommendation-qty-minus]').length) return;
    var $control = $(this);
    if ($control.hasClass('is-disabled')) return;
    setRecommendationQuantityExpanded($control, true);
    $control.find('[data-product-recommendation-qty]').first().trigger('focus');
  });

  $(document).off('focusin.skyrocketProductRecommendationQuantityMinimal').on('focusin.skyrocketProductRecommendationQuantityMinimal', '[data-product-recommendation-qty-minimal] [data-product-recommendation-qty]', function() {
    var $control = $(this).closest('[data-product-recommendation-qty-minimal]');
    if ($control.hasClass('is-disabled')) return;
    setRecommendationQuantityExpanded($control, true);
  });

  $(document).off('input.skyrocketProductRecommendationQuantityInput').on('input.skyrocketProductRecommendationQuantityInput', '[data-product-recommendation-qty]', function() {
    var $input = $(this);
    var sanitized = String($input.val() || '').replace(/[^\d]/g, '');
    $input.val(sanitized);
  });

  $(document).off('change.skyrocketProductRecommendationQuantityInput blur.skyrocketProductRecommendationQuantityInput').on('change.skyrocketProductRecommendationQuantityInput blur.skyrocketProductRecommendationQuantityInput', '[data-product-recommendation-qty]', function() {
    var $input = $(this);
    var quantity = parseInt($input.val(), 10);
    quantity = isNaN(quantity) || quantity < 1 ? 1 : quantity;
    $input.val(quantity);
  });

  $(document).off('click.skyrocketProductRecommendationQuantityMinimalOutside').on('click.skyrocketProductRecommendationQuantityMinimalOutside', function(event) {
    $('[data-product-recommendation-qty-minimal].is-expanded').each(function() {
      var $control = $(this);
      if ($(event.target).closest($control).length) return;
      setRecommendationQuantityExpanded($control, false);
    });
  });

  $(document).off('keydown.skyrocketProductRecommendationQuantityMinimal').on('keydown.skyrocketProductRecommendationQuantityMinimal', function(event) {
    if (event.key !== 'Escape') return;
    $('[data-product-recommendation-qty-minimal].is-expanded').each(function() {
      setRecommendationQuantityExpanded($(this), false);
    });
  });

  $(document).off('click.skyrocketProductRecommendationButton').on('click.skyrocketProductRecommendationButton', '[data-product-recommendation-button]', function(event) {
    event.preventDefault();

    var $button = $(this);
    var $card = $button.closest('[data-product-recommendation-item]');
    if (!$card.length || $card.attr('data-available') !== 'true') return;

    if ($card.attr('data-mode') === 'staged') {
      setRecommendationSelected($card, !$card.hasClass('is-selected'));
      return;
    }

    var variantId = parseInt($card.attr('data-variant-id'), 10);
    if (!variantId) return;

    var quantity = parseInt($card.find('[data-product-recommendation-qty]').val(), 10);
    quantity = isNaN(quantity) || quantity < 1 ? 1 : quantity;

    $button.prop('disabled', true).addClass('is-loading');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity,
          properties: {
            _skyrocket_product_recommendation: 'true'
          }
        }]
      })
    })
      .done(function() {
        setRecommendationSelected($card, true);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
        if (window.cartDrawer && typeof window.cartDrawer.refresh === 'function') {
          window.cartDrawer.refresh();
        } else if (window.SkyrocketCartDrawer && typeof window.SkyrocketCartDrawer.refresh === 'function') {
          window.SkyrocketCartDrawer.refresh();
        }
      })
      .fail(function() {
        var $label = $button.find('[data-product-recommendation-button-label]').first();
        if ($label.length) {
          $label.text('Error');
        } else {
          $button.text('Error');
        }
        window.setTimeout(function() {
          setRecommendationSelected($card, false);
        }, 1200);
      })
      .always(function() {
        $button.removeClass('is-loading');
        if ($card.attr('data-available') === 'true') {
          $button.prop('disabled', false);
        }
      });
  });

  proto._addCrossSellItems = function(items) {
    if (!items || !items.length) {
      return $.Deferred().resolve().promise();
    }

    return $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({ items: items })
    });
  };

  proto._initAddToCart = function() {
    var self = this;

    $(this.selectors.productForm, this.$container).on('submit', function(evt) {
      evt.preventDefault();

      var submitter = evt.originalEvent && evt.originalEvent.submitter
        ? evt.originalEvent.submitter
        : document.activeElement;
      self._useSkyrocketDrawer = !!(submitter && submitter.hasAttribute('data-skyrocket-cart-open-on-submit'));

      if (self.$addToCart.is('[aria-disabled]')) {
        return;
      }

      var allFieldsValid = validateRequiredFields($(this));
      if (!allFieldsValid) {
        return;
      }

      if (!self.ajaxEnabled) {
        var addOnItems = self._getProductAddOnItems();
        if (addOnItems.length) {
          self._addCrossSellItems(addOnItems).always(function() {
            this.submit();
          }.bind(this));
          return;
        }
        this.submit();
        return;
      }

      self.$previouslyFocusedElement = $(':focus');

      var isInvalidQuantity = self.$quantityInput.val() <= 0;
      if (isInvalidQuantity) {
        self._showErrorMessage(theme.strings.quantityMinimumMessage);
        return;
      }

      self._handleButtonLoadingState(true);
      var $data = $(self.selectors.productForm, self.$container);
      self._addItemToCart($data);
    });
  };

  proto._addItemToCart = function(data) {
    var params = {
      url: '/cart/add.js',
      data: $(data).serialize(),
      dataType: 'json'
    };

    $.post(params)
      .done(function(item) {
        var addOnItems = this._getProductAddOnItems();
        var finalize = function() {
          this._hideErrorMessage();
          this._setupCartPopup(item);
          setTimeout(function() {
            this._handleButtonLoadingState(false);
          }.bind(this), 200);
        }.bind(this);

        if (!addOnItems.length) {
          finalize();
          return;
        }

        this._addCrossSellItems(addOnItems)
          .fail(function() {
            console.warn('Product add-on add failed.');
          })
          .always(finalize);
      }.bind(this))
      .fail(function(response) {
        this.$previouslyFocusedElement.focus();
        var errorMessage = response.responseJSON
          ? response.responseJSON.description
          : theme.strings.cartError;
        this._showErrorMessage(errorMessage);
        this._handleButtonLoadingState(false);
      }.bind(this));
  };
})();

/* ========================= COURSE MODULES JS START ========================= */
// COURSE MODULES INIT
document.addEventListener('DOMContentLoaded', initCourseModules);
document.addEventListener('shopify:section:load', initCourseModules);

function initCourseModules(event) {
  const root = event && event.target ? event.target : document;

  initCourseSectionAccordions(root);
  initCourseModuleGroups(root);
  initCourseModuleAccordions(root);
  initCourseModuleCheckboxes(root);
  initCourseModuleTabs(root);
}

function hasLinkedCourseNavigation(section) {
  if (!section) return false;
  const courseId = normalizeCourseKey(section.dataset.courseId);
  if (!courseId) return false;
  return !!document.querySelector(`.cm-nav[data-course-id="${courseId}"]`);
}

function initCourseSectionAccordions(root) {
  root.querySelectorAll('.cm-section[data-cm-section-collapsible="true"]').forEach(section => {
    if (section.dataset.cmSectionAccordionInit === 'true') return;
    section.dataset.cmSectionAccordionInit = 'true';

    const toggle = section.querySelector('[data-cm-section-toggle]');
    const content = section.querySelector('[data-cm-section-content]');
    if (!toggle || !content) return;

    const openByDefault = section.dataset.cmSectionOpen !== 'false';
    toggle.classList.toggle('is-open', openByDefault);
    toggle.setAttribute('aria-expanded', openByDefault ? 'true' : 'false');
    content.style.maxHeight = openByDefault ? 'none' : '0px';
    updateGroupToggleIcon(toggle);

    toggle.addEventListener('click', () => {
      const isOpen = toggle.classList.contains('is-open');

      if (isOpen) {
        content.style.maxHeight = `${content.scrollHeight}px`;
        requestAnimationFrame(() => {
          content.style.maxHeight = '0px';
        });
        toggle.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        content.style.maxHeight = `${content.scrollHeight}px`;
        toggle.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');

        const onTransitionEnd = () => {
          if (toggle.classList.contains('is-open')) {
            content.style.maxHeight = 'none';
          }
          content.removeEventListener('transitionend', onTransitionEnd);
        };
        content.addEventListener('transitionend', onTransitionEnd);
      }

      updateGroupToggleIcon(toggle);
    });
  });
}

function initCourseModuleGroups(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    // In navigation-managed mode, keep headings collapsible without structural wrappers.
    if (hasLinkedCourseNavigation(section)) {
      initCourseModuleManagedHeadingToggles(section);
      return;
    }
    if (section.dataset.cmGroupsInit === 'true') return;
    section.dataset.cmGroupsInit = 'true';

    const list = section.querySelector('.cm-list');
    if (!list) return;

    const children = Array.from(list.children);
    const total = children.length;
    let i = 0;

    while (i < total) {
      const heading = children[i];

      if (!heading.classList.contains('cm-heading-block')) {
        i++;
        continue;
      }

      const collapsible = heading.dataset.collapsible === 'true';
      if (!collapsible) {
        i++;
        continue;
      }

      if (heading.dataset.cmGroupInit === 'true') {
        i++;
        continue;
      }
      heading.dataset.cmGroupInit = 'true';

      const openByDefault = heading.dataset.open === 'true';

      const group = document.createElement('div');
      group.className = 'cm-group';

      const toggle = document.createElement('div');
      toggle.className = 'cm-heading-toggle';
      toggle.innerHTML = '<i class="fa-regular fa-plus cm-heading-toggle-icon"></i>';
      heading.appendChild(toggle);

      if (heading.nextSibling) {
        list.insertBefore(group, heading.nextSibling);
      } else {
        list.appendChild(group);
      }

      let j = i + 1;
      while (j < children.length) {
        const node = children[j];
        if (!node) {
          j++;
          continue;
        }
        if (node.classList.contains('cm-heading-block')) break;
        if (node.parentElement === list) group.appendChild(node);
        j++;
      }

      if (!group.children.length) {
        group.remove();
        i = j;
        continue;
      }

      if (openByDefault) {
        heading.classList.add('is-open');
        group.style.maxHeight = 'none';
      } else {
        heading.classList.add('is-closed-border');
        group.style.maxHeight = '0px';
      }

      updateGroupToggleIcon(heading);

      heading.addEventListener('click', () => {
        const isOpen = heading.classList.contains('is-open');

        if (isOpen) {
          group.style.maxHeight = group.scrollHeight + 'px';
          requestAnimationFrame(() => {
            group.style.maxHeight = '0px';
          });
          heading.classList.remove('is-open');
          heading.classList.add('is-closed-border');
        } else {
          group.style.maxHeight = group.scrollHeight + 'px';
          heading.classList.add('is-open');
          heading.classList.remove('is-closed-border');

          const handler = () => {
            if (heading.classList.contains('is-open')) {
              group.style.maxHeight = 'none';
            }
            group.removeEventListener('transitionend', handler);
          };
          group.addEventListener('transitionend', handler);
        }

        updateGroupToggleIcon(heading);
      });

      i = j;
    }
  });
}

function initCourseModuleManagedHeadingToggles(section) {
  if (!section) return;

  const list = section.querySelector('.cm-list');
  if (!list) return;

  // If wrappers were created before nav was added, flatten them.
  Array.from(list.children).forEach(node => {
    if (!node.classList || !node.classList.contains('cm-group')) return;
    while (node.firstChild) {
      list.insertBefore(node.firstChild, node);
    }
    node.remove();
  });

  const headings = Array.from(section.querySelectorAll('.cm-heading-block'));
  headings.forEach(originalHeading => {
    let heading = originalHeading;
    const shouldRebind = heading.dataset.cmGroupInit === 'true' || heading.dataset.cmManagedHeadingBound === 'true';
    if (shouldRebind) {
      const clone = heading.cloneNode(true);
      heading.replaceWith(clone);
      heading = clone;
    }

    const collapsible = heading.dataset.collapsible === 'true';
    if (!collapsible) return;

    const headingIndex = heading.dataset.headingIndex;
    if (!headingIndex) return;

    const existingToggle = heading.querySelector('.cm-heading-toggle');
    if (existingToggle) existingToggle.remove();

    const toggle = document.createElement('div');
    toggle.className = 'cm-heading-toggle';
    toggle.innerHTML = '<i class="fa-regular fa-plus cm-heading-toggle-icon"></i>';
    heading.appendChild(toggle);

    const openByDefault = heading.dataset.open === 'true';
    const collapsed = heading.dataset.cmCollapsedByHeading === 'true'
      ? true
      : !openByDefault;

    heading.classList.toggle('is-open', !collapsed);
    heading.classList.toggle('is-closed-border', collapsed);
    setManagedHeadingItemsCollapsed(section, headingIndex, collapsed, false);
    updateGroupToggleIcon(heading);

    heading.dataset.cmManagedHeadingBound = 'true';
    heading.addEventListener('click', () => {
      const isOpen = heading.classList.contains('is-open');
      const nextCollapsed = isOpen;

      heading.classList.toggle('is-open', !nextCollapsed);
      heading.classList.toggle('is-closed-border', nextCollapsed);
      heading.dataset.cmCollapsedByHeading = nextCollapsed ? 'true' : 'false';

      setManagedHeadingItemsCollapsed(section, headingIndex, nextCollapsed, true);
      updateGroupToggleIcon(heading);
    });
  });
}

function setManagedHeadingItemsCollapsed(section, headingIndex, collapsed, animate) {
  section.querySelectorAll(`.cm-item[data-heading-index="${headingIndex}"]`).forEach(item => {
    item.dataset.cmCollapsedByHeading = collapsed ? 'true' : 'false';

    if (!animate) {
      item.style.display = collapsed ? 'none' : '';
      resetManagedHeadingItemStyles(item);
      return;
    }

    if (collapsed) {
      collapseManagedHeadingItem(item);
    } else {
      expandManagedHeadingItem(item);
    }
  });
}

function resetManagedHeadingItemStyles(item) {
  item.style.removeProperty('transition');
  item.style.removeProperty('overflow');
  item.style.removeProperty('max-height');
  item.style.removeProperty('opacity');
}

function finishManagedHeadingItemAnimation(item, onFinish) {
  if (item._cmHeadingAnimCleanup) item._cmHeadingAnimCleanup();

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    item.removeEventListener('transitionend', onEnd);
    item._cmHeadingAnimCleanup = null;
  };

  const onEnd = e => {
    if (e.target !== item || e.propertyName !== 'max-height') return;
    cleanup();
    if (typeof onFinish === 'function') onFinish();
  };

  item._cmHeadingAnimCleanup = cleanup;
  item.addEventListener('transitionend', onEnd);
}

function collapseManagedHeadingItem(item) {
  if (item.hidden || item.style.display === 'none') {
    item.style.display = 'none';
    resetManagedHeadingItemStyles(item);
    return;
  }

  const startHeight = item.scrollHeight;
  if (startHeight <= 0) {
    item.style.display = 'none';
    resetManagedHeadingItemStyles(item);
    return;
  }

  item.style.display = '';
  item.style.overflow = 'hidden';
  item.style.maxHeight = `${startHeight}px`;
  item.style.opacity = '1';
  item.style.transition = 'max-height .35s ease, opacity .25s ease';

  requestAnimationFrame(() => {
    item.style.maxHeight = '0px';
    item.style.opacity = '0';
  });

  finishManagedHeadingItemAnimation(item, () => {
    item.style.display = 'none';
    resetManagedHeadingItemStyles(item);
  });
}

function expandManagedHeadingItem(item) {
  if (item.hidden) {
    item.style.display = '';
    resetManagedHeadingItemStyles(item);
    return;
  }

  item.style.display = '';
  const endHeight = item.scrollHeight;

  if (endHeight <= 0) {
    resetManagedHeadingItemStyles(item);
    return;
  }

  item.style.overflow = 'hidden';
  item.style.maxHeight = '0px';
  item.style.opacity = '0';
  item.style.transition = 'max-height .35s ease, opacity .25s ease';

  requestAnimationFrame(() => {
    item.style.maxHeight = `${endHeight}px`;
    item.style.opacity = '1';
  });

  finishManagedHeadingItemAnimation(item, () => {
    resetManagedHeadingItemStyles(item);
  });
}

function updateGroupToggleIcon(heading) {
  const icon = heading.querySelector('.cm-heading-toggle-icon');
  if (!icon) return;

  if (heading.classList.contains('is-open')) {
    icon.classList.remove('fa-plus');
    icon.classList.add('fa-minus');
  } else {
    icon.classList.remove('fa-minus');
    icon.classList.add('fa-plus');
  }
}

function initCourseModuleAccordions(root) {
  root.querySelectorAll('.cm-item[data-mode="accordion"]').forEach(item => {
    if (item.dataset.cmAccordionInit === 'true') return;
    item.dataset.cmAccordionInit = 'true';

    const btn = item.querySelector('.cm-main');
    const panel = item.querySelector('.cm-content');
    const inner = panel ? panel.querySelector('.cm-inner') : null;

    if (!btn || !panel || !inner) return;

    btn.addEventListener('click', e => {
      if (e.target.closest('a') || e.target.closest('input')) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        btn.setAttribute('aria-expanded', 'false');

        panel.querySelectorAll('.sky-video-container').forEach(vc => {
          const v = vc.querySelector('video.sky-video');
          const pb = vc.querySelector('.sky-video-play-button');
          if (v) {
            v.pause();
            v.currentTime = 0;
          }
          if (pb) pb.style.opacity = '1';
        });

        panel.style.maxHeight = inner.scrollHeight + 'px';
        requestAnimationFrame(() => {
          panel.style.maxHeight = '0px';
        });
      } else {
        btn.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = inner.scrollHeight + 'px';

        setTimeout(() => {
          if (typeof initSkyVideoSections === 'function') {
            initSkyVideoSections();
          }
        }, 50);

        const onTransitionEnd = () => {
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.maxHeight = 'none';
          }
          panel.removeEventListener('transitionend', onTransitionEnd);
        };

        panel.addEventListener('transitionend', onTransitionEnd);
      }
    });
  });
}

function initCourseModuleCheckboxes(root) {
  root.querySelectorAll('.cm-item').forEach(item => {
    if (item.dataset.cmCheckboxInit === 'true') return;
    item.dataset.cmCheckboxInit = 'true';

    const section = item.closest('.cm-section');
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const customerId = section.dataset.customerId || 'guest';
    const id = item.dataset.blockId;

    if (!sectionId || !id) return;

    const key = `cm:${sectionId}:${id}:completed:${customerId}`;
    const box = item.querySelector('.cm-check-input');
    if (!box) return;

    if (localStorage.getItem(key) === '1') {
      box.checked = true;
    }

    box.addEventListener('change', () => {
      if (box.checked) {
        localStorage.setItem(key, '1');
      } else {
        localStorage.removeItem(key);
      }
    });
  });
}

function initCourseModuleTabs(root) {
  root.querySelectorAll('.cm-section').forEach(section => {
    // Avoid overlap with course-sorting tabs/search/sort controls.
    if (hasLinkedCourseNavigation(section)) {
      const localTabs = section.querySelector('.cm-tabs');
      if (localTabs) localTabs.hidden = true;
      return;
    }
    if (section.dataset.cmTabsInit === 'true') return;
    section.dataset.cmTabsInit = 'true';

    const tabs = section.querySelectorAll('.cm-tab');
    const items = section.querySelectorAll('.cm-item');

    if (!tabs.length || !items.length) return;

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const selected = tab.dataset.tab;

        tabs.forEach(t => {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        items.forEach(item => {
          const tabsAttr = item.dataset.tabs || '';

          if (selected === '__all__') {
            item.style.display = '';
            return;
          }

          const tabList = tabsAttr.split(',').map(value => value.trim()).filter(Boolean);

          if (tabList.includes(selected)) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  });
}
/* ========================== COURSE MODULES JS END ========================== */

/* ======================== COURSE NAVIGATION JS START ======================== */
// COURSE NAVIGATION INIT
document.addEventListener('DOMContentLoaded', initCourseNavigation);
document.addEventListener('shopify:section:load', initCourseNavigation);

let cmNavGlobalBound = false;

function normalizeCourseKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function debounceCourseNav(fn, wait) {
  let timeout;
  return function() {
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
}

function initCourseNavigation() {
  const navs = document.querySelectorAll('.cm-nav');
  if (!navs.length) return;

  if (!cmNavGlobalBound) {
    cmNavGlobalBound = true;
    document.addEventListener('change', e => {
      const target = e.target;
      if (!target || !target.classList || !target.classList.contains('cm-check-input')) return;

      document.querySelectorAll('.cm-nav').forEach(nav => {
        if (nav._cmNavState && typeof nav._cmNavState.refresh === 'function') {
          nav._cmNavState.refresh(true);
        }
      });
    });
  }

  navs.forEach(nav => {
    if (nav._cmNavState) {
      nav._cmNavState.rebuild();
      nav._cmNavState.refresh(true);
      return;
    }
    nav._cmNavState = buildCourseNavState(nav);
  });
}

function buildCourseNavState(nav) {
  const elements = {
    tabs: nav.querySelector('[data-cm-tabs]'),
    search: nav.querySelector('[data-cm-search]'),
    clear: nav.querySelector('[data-cm-clear]'),
    sort: nav.querySelector('[data-cm-sort]'),
    meta: nav.querySelector('[data-cm-meta]'),
    empty: nav.querySelector('[data-cm-empty]')
  };

  const settings = {
    showTabs: nav.dataset.showTabs !== 'false',
    showAllTab: nav.dataset.showAll !== 'false',
    showCounts: nav.dataset.showCounts !== 'false',
    defaultTab: nav.dataset.defaultTab || 'all',
    defaultSort: nav.dataset.defaultSort || 'default',
    allLabel: nav.dataset.allLabel || 'All',
    emptyMessage: nav.dataset.emptyMessage || 'No modules match your search.',
    noSectionsMessage: nav.dataset.noSectionsMessage || 'Add a Course modules section with the same Course ID to connect.'
  };

  let sectionStates = [];
  let tiers = [];
  let activeTierKey = 'all';
  let lastSortKey = null;

  const tabButtons = new Map();
  const tabCounts = new Map();

  function rebuild() {
    const courseId = normalizeCourseKey(nav.dataset.courseId);
    if (!courseId) {
      if (elements.empty) {
        elements.empty.textContent = settings.noSectionsMessage;
        elements.empty.hidden = false;
      }
      if (elements.tabs) elements.tabs.hidden = true;
      return;
    }

    sectionStates = buildCourseSectionStates(courseId);
    tiers = buildTierGroups(sectionStates);

    if (!sectionStates.length) {
      if (elements.empty) {
        elements.empty.textContent = settings.noSectionsMessage;
        elements.empty.hidden = false;
      }
      if (elements.tabs) elements.tabs.hidden = true;
      return;
    }

    if (elements.empty) elements.empty.hidden = true;

    if (settings.showTabs && elements.tabs) {
      renderTabs();
    } else if (elements.tabs) {
      elements.tabs.hidden = true;
    }

    const tierKeys = tiers.map(tier => tier.key);
    if (!tierKeys.includes(activeTierKey)) {
      if (settings.defaultTab === 'none') {
        activeTierKey = '__none__';
      } else if (settings.defaultTab === 'first' && tiers[0]) {
        activeTierKey = tiers[0].key;
      } else {
        activeTierKey = settings.showAllTab ? 'all' : (tiers[0] ? tiers[0].key : 'all');
      }
    }

    setActiveTab(activeTierKey);
  }

  function renderTabs() {
    elements.tabs.hidden = false;
    elements.tabs.innerHTML = '';
    tabButtons.clear();
    tabCounts.clear();

    if (settings.showAllTab) {
      const allTab = createTabButton(settings.allLabel, 'all');
      elements.tabs.appendChild(allTab);
    }

    tiers.forEach(tier => {
      const tab = createTabButton(tier.label, tier.key);
      elements.tabs.appendChild(tab);
    });
  }

  function createTabButton(label, key) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cm-nav__tab';
    btn.setAttribute('role', 'tab');
    btn.dataset.tierKey = key;

    const labelSpan = document.createElement('span');
    labelSpan.className = 'cm-nav__tab-label';
    labelSpan.textContent = label;

    const countSpan = document.createElement('span');
    countSpan.className = 'cm-nav__count';

    btn.appendChild(labelSpan);
    if (settings.showCounts) {
      btn.appendChild(countSpan);
      tabCounts.set(key, countSpan);
    }

    tabButtons.set(key, btn);
    return btn;
  }

  function setActiveTab(key) {
    activeTierKey = key;
    tabButtons.forEach((btn, btnKey) => {
      const isActive = key !== '__none__' && btnKey === key;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.classList.toggle('is-active', isActive);
      btn.tabIndex = isActive ? 0 : -1;
    });
  }

  function refresh(forceSort) {
    if (!sectionStates.length) return;

    const sortKey = elements.sort ? elements.sort.value : settings.defaultSort;
    if (forceSort || sortKey !== lastSortKey) {
      if (sortKey === 'completed-first' || sortKey === 'incomplete-first') {
        updateCompletion(sectionStates);
      }
      sectionStates.forEach(state => applySortToSection(state, sortKey));
      lastSortKey = sortKey;
    }

    const query = elements.search ? elements.search.value.trim().toLowerCase() : '';
    if (elements.clear) elements.clear.hidden = query === '';

    const matches = new Map();
    let visibleCount = 0;
    let totalCount = 0;

    tiers.forEach(tier => {
      let tierTotal = 0;
      let tierMatch = 0;

      tier.sections.forEach(sectionState => {
        const sectionItems = sectionState.items;
        const isActiveTier = activeTierKey === 'all' || activeTierKey === '__none__' || tier.key === activeTierKey;
        let sectionMatch = 0;
        let sectionTotal = 0;

        sectionItems.forEach(item => {
          const matchesSearch = query === '' || item.search.indexOf(query) !== -1;
          const isMatch = matchesSearch;

          tierTotal += 1;
          sectionTotal += 1;
          if (matchesSearch) tierMatch += 1;

          if (isActiveTier) {
            item.el.hidden = !isMatch;
            if (isMatch) sectionMatch += 1;
          }
        });

        if (isActiveTier) {
          totalCount += sectionTotal;
          if (sectionMatch > 0) {
            sectionState.section.hidden = false;
            sectionState.section.removeAttribute('aria-hidden');
          } else {
            sectionState.section.hidden = true;
            sectionState.section.setAttribute('aria-hidden', 'true');
          }
          visibleCount += sectionMatch;
          updateHeadingVisibility(sectionState);
        } else {
          sectionState.section.hidden = true;
          sectionState.section.setAttribute('aria-hidden', 'true');
        }
      });

      matches.set(tier.key, query ? tierMatch : tierTotal);
    });

    if (settings.showCounts) {
      updateTabCounts(matches);
    }

    if (elements.meta && settings.showCounts) {
      elements.meta.textContent = `Showing ${query ? visibleCount : totalCount} of ${totalCount} modules`;
      elements.meta.hidden = false;
    }

    if (elements.empty) {
      if (query && visibleCount === 0) {
        elements.empty.textContent = settings.emptyMessage;
        elements.empty.hidden = false;
      } else {
        elements.empty.hidden = true;
      }
    }
  }

  function updateTabCounts(matches) {
    tabCounts.forEach((el, key) => {
      const count = key === 'all'
        ? Array.from(matches.values()).reduce((sum, value) => sum + value, 0)
        : (matches.get(key) || 0);
      el.textContent = `(${count})`;
    });
  }

  if (elements.sort) {
    elements.sort.value = settings.defaultSort;
    elements.sort.addEventListener('change', () => refresh(true));
  }

  if (elements.search) {
    const onSearch = debounceCourseNav(() => refresh(false), 150);
    elements.search.addEventListener('input', onSearch);
    elements.search.addEventListener('search', onSearch);
  }

  if (elements.clear) {
    elements.clear.addEventListener('click', () => {
      if (elements.search) elements.search.value = '';
      refresh(false);
    });
    elements.clear.hidden = true;
  }

  if (elements.tabs && settings.showTabs) {
    elements.tabs.addEventListener('click', e => {
      const button = e.target.closest('[data-tier-key]');
      if (!button) return;
      setActiveTab(button.dataset.tierKey);
      refresh(false);
    });
  }

  rebuild();
  refresh(true);

  return { rebuild, refresh };
}

function buildCourseSectionStates(courseId) {
  if (!courseId) return [];

  const sections = Array.from(document.querySelectorAll('.cm-section[data-course-id]'))
    .filter(section => normalizeCourseKey(section.dataset.courseId) === courseId);

  return sections.map((section, index) => {
    const list = section.querySelector('.cm-list');
    if (!list) return null;

    const orphanedGroups = Array.from(list.children).filter(node => {
      return node.nodeType === 1 && node.classList.contains('cm-group');
    });
    orphanedGroups.forEach(group => {
      while (group.firstChild) {
        list.insertBefore(group.firstChild, group);
      }
      group.remove();
    });

    const nodes = Array.from(list.children).filter(node => node.nodeType === 1);
    const itemEls = nodes.filter(node => node.classList.contains('cm-item'));
    const headingEls = nodes.filter(node => node.classList.contains('cm-heading-block'));

    const sectionId = section.dataset.sectionId || section.id || `cm-${index}`;
    const customerId = section.dataset.customerId || 'guest';

    const items = itemEls.map((el, itemIndex) => {
      const order = parseInt(el.dataset.cmOrder, 10);
      const headingIndex = parseInt(el.dataset.headingIndex || '0', 10);
      const title = (el.dataset.title || (el.querySelector('.cm-title') ? el.querySelector('.cm-title').textContent : '') || '').trim();
      const search = (el.dataset.search || title).toLowerCase();
      const locked = el.dataset.locked === 'true';
      const blockId = el.dataset.blockId || '';

      return {
        el: el,
        order: Number.isNaN(order) ? itemIndex : order,
        headingIndex: Number.isNaN(headingIndex) ? 0 : headingIndex,
        title: title,
        titleLower: title.toLowerCase(),
        search: search,
        locked: locked,
        storageKey: `cm:${sectionId}:${blockId}:completed:${customerId}`,
        completed: false
      };
    });

    const groups = new Map();
    items.forEach(item => {
      const key = item.headingIndex;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });

    const headings = new Map();
    headingEls.forEach(el => {
      const idx = parseInt(el.dataset.headingIndex, 10);
      if (!Number.isNaN(idx)) headings.set(idx, el);
    });

    const orderedNodes = nodes
      .filter(node => node.classList.contains('cm-item') || node.classList.contains('cm-heading-block'))
      .map((el, nodeIndex) => {
        const order = parseInt(el.dataset.cmOrder, 10);
        return { el: el, order: Number.isNaN(order) ? nodeIndex : order };
      });

    return {
      section: section,
      list: list,
      items: items,
      groups: groups,
      headings: headings,
      headingOrder: Array.from(headings.keys()).sort((a, b) => a - b),
      orderedNodes: orderedNodes,
      tierLabel: (section.dataset.tierLabel || section.dataset.sectionTitle || '').trim(),
      tierKey: normalizeCourseKey(section.dataset.tierKey || section.dataset.tierLabel || section.dataset.sectionTitle || section.id),
      tierOrder: parseInt(section.dataset.tierOrder, 10),
      index: index
    };
  }).filter(Boolean);
}

function buildTierGroups(sectionStates) {
  return sectionStates.map((state, index) => {
    const sectionId = String(state.section.dataset.sectionId || state.section.id || `section-${index + 1}`).trim();
    const label = (state.section.dataset.sectionTitle || state.tierLabel || `Section ${index + 1}`).trim();
    return {
      key: sectionId,
      label: label || `Section ${index + 1}`,
      order: Number.isNaN(state.tierOrder) ? state.index : state.tierOrder,
      sections: [state]
    };
  }).sort((a, b) => {
    const orderA = Number.isNaN(a.order) ? 9999 : a.order;
    const orderB = Number.isNaN(b.order) ? 9999 : b.order;
    if (orderA !== orderB) return orderA - orderB;
    return a.label.localeCompare(b.label);
  });
}

function applySortToSection(sectionState, sortKey) {
  if (!sectionState.list) return;

  const frag = document.createDocumentFragment();

  if (sortKey === 'default') {
    sectionState.orderedNodes
      .slice()
      .sort((a, b) => a.order - b.order)
      .forEach(node => frag.appendChild(node.el));
    sectionState.list.appendChild(frag);
    return;
  }

  if (sectionState.headings.size) {
    if (sectionState.groups.has(0)) {
      sortGroup(sectionState.groups.get(0), sortKey).forEach(item => frag.appendChild(item.el));
    }

    sectionState.headingOrder.forEach(headingIndex => {
      const heading = sectionState.headings.get(headingIndex);
      if (heading) frag.appendChild(heading);
      sortGroup(sectionState.groups.get(headingIndex) || [], sortKey).forEach(item => frag.appendChild(item.el));
    });
  } else {
    sortGroup(sectionState.items, sortKey).forEach(item => frag.appendChild(item.el));
  }

  sectionState.list.appendChild(frag);
}

function sortGroup(items, sortKey) {
  const sorted = items.slice();
  sorted.sort((a, b) => {
    if (sortKey === 'title-asc') {
      const result = a.titleLower.localeCompare(b.titleLower);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'title-desc') {
      const result = b.titleLower.localeCompare(a.titleLower);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'completed-first') {
      const result = (b.completed ? 1 : 0) - (a.completed ? 1 : 0);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'incomplete-first') {
      const result = (a.completed ? 1 : 0) - (b.completed ? 1 : 0);
      return result !== 0 ? result : a.order - b.order;
    }
    if (sortKey === 'unlocked-first') {
      const result = (a.locked ? 1 : 0) - (b.locked ? 1 : 0);
      return result !== 0 ? result : a.order - b.order;
    }
    return a.order - b.order;
  });
  return sorted;
}

function updateHeadingVisibility(sectionState) {
  if (!sectionState.headings.size) return;

  sectionState.headings.forEach((heading, headingIndex) => {
    const items = sectionState.groups.get(headingIndex) || [];
    const hasVisible = items.some(item => !item.el.hidden);
    heading.hidden = !hasVisible;
    if (hasVisible) heading.removeAttribute('aria-hidden');
    else heading.setAttribute('aria-hidden', 'true');
  });
}

function updateCompletion(sectionStates) {
  sectionStates.forEach(sectionState => {
    sectionState.items.forEach(item => {
      item.completed = getCompletionState(item);
    });
  });
}

function getCompletionState(item) {
  if (!item.storageKey) return false;
  try {
    return localStorage.getItem(item.storageKey) === '1';
  } catch (err) {
    return false;
  }
}
/* ========================= COURSE NAVIGATION JS END ========================= */

/* ================ Product quantity breaks ================ */
(function() {
  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.moneyFormat);
    }
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getProductForm(block) {
    return block.closest('form[data-product-form]') || block.closest('form[action*="/cart/add"]');
  }

  function getQuantityInput(block) {
    var form = getProductForm(block);
    if (!form) return null;

    var input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      input.setAttribute('data-quantity-break-hidden-input', '');
      form.appendChild(input);
    }

    return input;
  }

  function getQuantityBlocksForInput(input) {
    var form = input.closest('form[data-product-form]') || input.closest('form[action*="/cart/add"]');
    if (form) {
      return Array.prototype.slice.call(form.querySelectorAll('[data-quantity-breaks]'));
    }

    var productSection = input.closest('[data-section-type="product"]') || document;
    return Array.prototype.slice.call(productSection.querySelectorAll('[data-quantity-breaks]'));
  }

  function updateBreakSelectionFromQuantityInput(input) {
    if (!input || input._skyrocketQuantityBreakSyncing) return;

    var quantity = parseInt(input.value, 10);
    if (!quantity || quantity < 1) quantity = 1;

    getQuantityBlocksForInput(input).forEach(function(block) {
      if (block._skyrocketQuantityBreakSyncing) return;

      var matched = null;
      block.querySelectorAll('[data-quantity-break-input]').forEach(function(tierInput) {
        var tierQuantity = parseInt(tierInput.getAttribute('data-quantity'), 10);
        if (tierQuantity === quantity && !matched) {
          matched = tierInput;
        }
      });

      block.querySelectorAll('[data-quantity-break-input]').forEach(function(tierInput) {
        tierInput.checked = tierInput === matched;
      });
    });
  }

  function syncQuantity(block) {
    var selected = block.querySelector('[data-quantity-break-input]:checked');
    if (!selected) return;

    var quantity = parseInt(selected.getAttribute('data-quantity'), 10);
    if (!quantity || quantity < 1) quantity = 1;

    var quantityInput = getQuantityInput(block);
    if (!quantityInput) return;

    block._skyrocketQuantityBreakSyncing = true;
    quantityInput._skyrocketQuantityBreakSyncing = true;
    quantityInput.value = quantity;
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    quantityInput._skyrocketQuantityBreakSyncing = false;
    block._skyrocketQuantityBreakSyncing = false;
  }

  function updatePrices(block, variant) {
    if (!variant || typeof variant.price === 'undefined') return;

    var unitPrice = parseInt(variant.price, 10) || 0;
    var compareAt = parseInt(variant.compare_at_price, 10) || 0;

    block.querySelectorAll('[data-quantity-break-price]').forEach(function(priceEl) {
      var quantity = parseInt(priceEl.getAttribute('data-quantity'), 10) || 1;
      var discount = parseInt(priceEl.getAttribute('data-discount'), 10) || 0;
      var multiplier = Math.max(0, 100 - discount);
      var total = Math.round(unitPrice * quantity * multiplier / 100);
      priceEl.textContent = formatMoney(total);
    });

    block.querySelectorAll('[data-quantity-break-compare]').forEach(function(compareEl) {
      var quantity = parseInt(compareEl.getAttribute('data-quantity'), 10) || 1;
      var discount = parseInt(compareEl.getAttribute('data-discount'), 10) || 0;
      var multiplier = Math.max(0, 100 - discount);
      var discountedTotal = Math.round(unitPrice * quantity * multiplier / 100);
      var compareTotal = 0;

      if (compareAt > unitPrice) {
        compareTotal = compareAt * quantity;
      } else if (discount > 0) {
        compareTotal = unitPrice * quantity;
      }

      compareEl.textContent = compareTotal > 0 ? formatMoney(compareTotal) : '';
      compareEl.classList.toggle('hide', compareTotal <= discountedTotal);
    });
  }

  function initQuantityBreaks(root) {
    (root || document).querySelectorAll('[data-quantity-breaks]').forEach(function(block) {
      syncQuantity(block);
    });
  }

  document.addEventListener('change', function(event) {
    var input = event.target.closest('[data-quantity-break-input]');
    if (!input) {
      var quantityInput = event.target.closest('input[name="quantity"]');
      if (quantityInput) updateBreakSelectionFromQuantityInput(quantityInput);
      return;
    }

    var block = input.closest('[data-quantity-breaks]');
    if (block) syncQuantity(block);
  });

  document.addEventListener('input', function(event) {
    var quantityInput = event.target.closest('input[name="quantity"]');
    if (quantityInput) updateBreakSelectionFromQuantityInput(quantityInput);
  });

  document.addEventListener('click', function(event) {
    var qtyButton = event.target.closest('.qtybox .btnqty');
    if (!qtyButton) return;

    window.setTimeout(function() {
      var qtyBox = qtyButton.closest('.qtybox');
      var quantityInput = qtyBox ? qtyBox.querySelector('input[name="quantity"]') : null;
      if (quantityInput) updateBreakSelectionFromQuantityInput(quantityInput);
    }, 0);
  });

  if (window.jQuery) {
    jQuery(document).on('variantChange.skyrocketQuantityBreaks', '[data-section-type="product"]', function(event) {
      var variant = event.variant;
      this.querySelectorAll('[data-quantity-breaks]').forEach(function(block) {
        updatePrices(block, variant);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initQuantityBreaks(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initQuantityBreaks(event.target);
  });
})();
